import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** Specifies the quote template id to accept quote template. */
export type AcceptNegotiableQuoteTemplateInput = {
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines an item to add to the gift registry. */
export type AddGiftRegistryItemInput = {
  /** An array of options the customer has entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** A brief note about the item. */
  note?: InputMaybe<Scalars['String']>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The quantity of the product to add. */
  quantity: Scalars['Float'];
  /** An array of strings corresponding to options the customer has selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The SKU of the product to add to the gift registry. */
  sku: Scalars['String'];
};

/** Defines a new registrant. */
export type AddGiftRegistryRegistrantInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<GiftRegistryDynamicAttributeInput>>>;
  /** The email address of the registrant. */
  email: Scalars['String'];
  /** The first name of the registrant. */
  firstname: Scalars['String'];
  /** The last name of the registrant. */
  lastname: Scalars['String'];
};

/** Contains the results of a request to add registrants. */
export type AddGiftRegistryRegistrantsOutput = {
  __typename?: 'AddGiftRegistryRegistrantsOutput';
  /** The gift registry after adding registrants. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput';
  /** The cart after products have been added. */
  cart: Cart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<CartUserInputError>>;
};

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID'];
};

/** Output of the request to add products to a requisition list. */
export type AddProductsToRequisitionListOutput = {
  __typename?: 'AddProductsToRequisitionListOutput';
  /** The requisition list after adding products. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput';
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Contains the comment to be added to a purchase order. */
export type AddPurchaseOrderCommentInput = {
  /** Comment text. */
  comment: Scalars['String'];
  /** The unique ID of a purchase order. */
  purchase_order_uid: Scalars['ID'];
};

/** Contains the successfully added comment. */
export type AddPurchaseOrderCommentOutput = {
  __typename?: 'AddPurchaseOrderCommentOutput';
  /** The purchase order comment. */
  comment: PurchaseOrderComment;
};

/** Defines the purchase order and cart to act on. */
export type AddPurchaseOrderItemsToCartInput = {
  /** The ID to assign to the cart. */
  cart_id: Scalars['String'];
  /** Purchase order unique ID. */
  purchase_order_uid: Scalars['ID'];
  /** Replace existing cart or merge items. */
  replace_existing_cart_items: Scalars['Boolean'];
};

/** Contains details about why an attempt to add items to the requistion list failed. */
export type AddRequisitionListItemToCartUserError = {
  __typename?: 'AddRequisitionListItemToCartUserError';
  /** A description of the error. */
  message: Scalars['String'];
  /** The type of error that occurred. */
  type: AddRequisitionListItemToCartUserErrorType;
};

export enum AddRequisitionListItemToCartUserErrorType {
  /** @deprecated  */
  LowQuantity = 'LOW_QUANTITY',
  /** @deprecated  */
  OptionsUpdated = 'OPTIONS_UPDATED',
  /** @deprecated  */
  OutOfStock = 'OUT_OF_STOCK',
  /** @deprecated  */
  UnavailableSku = 'UNAVAILABLE_SKU'
}

/** Output of the request to add items in a requisition list to the cart. */
export type AddRequisitionListItemsToCartOutput = {
  __typename?: 'AddRequisitionListItemsToCartOutput';
  /** Details about why the attempt to add items to the requistion list was not successful. */
  add_requisition_list_items_to_cart_user_errors: Array<Maybe<AddRequisitionListItemToCartUserError>>;
  /** The cart after adding requisition list items. */
  cart?: Maybe<Cart>;
  /** Indicates whether the attempt to add items to the requisition list was successful. */
  status: Scalars['Boolean'];
};

/** Defines a return comment. */
export type AddReturnCommentInput = {
  /** The text added to the return request. */
  comment_text: Scalars['String'];
  /** The unique ID for a `Return` object. */
  return_uid: Scalars['ID'];
};

/** Contains details about the return request. */
export type AddReturnCommentOutput = {
  __typename?: 'AddReturnCommentOutput';
  /** The modified return. */
  return?: Maybe<Return>;
};

/** Defines tracking information to be added to the return. */
export type AddReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingCarrier` object. */
  carrier_uid: Scalars['ID'];
  /** The unique ID for a `Returns` object. */
  return_uid: Scalars['ID'];
  /** The shipping tracking number for this return request. */
  tracking_number: Scalars['String'];
};

/** Contains the response after adding tracking information. */
export type AddReturnTrackingOutput = {
  __typename?: 'AddReturnTrackingOutput';
  /** Details about the modified return. */
  return?: Maybe<Return>;
  /** Details about shipping for a return. */
  return_shipping_tracking?: Maybe<ReturnShippingTracking>;
};

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput';
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<WishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean'];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

export type AdyenAdditionalData = {
  /** Type of alternative payment method. */
  brand_code: Scalars['String'];
  /** Ratepay device identification token. */
  df_value?: InputMaybe<Scalars['String']>;
  /** Email address if customer is guest. */
  guestEmail?: InputMaybe<Scalars['String']>;
  /** Recurring processing model to tokenize the payment method. */
  recurringProcessingModel?: InputMaybe<Scalars['String']>;
  /** The URL to return to in case of a redirection. The format depends on the channel. This URL can have a maximum of 1024 characters. It can include a placeholder `:merchantReference` to identify the order e.g. `https://your-company.com/checkout?shopperOrder=:merchantReference`. */
  returnUrl?: InputMaybe<Scalars['String']>;
  /** JSON string of filled fields. */
  stateData: Scalars['String'];
};

export type AdyenAdditionalDataCc = {
  /** Credit card brand. */
  cc_type?: InputMaybe<Scalars['String']>;
  /** Debit or Credit card. */
  combo_card_type?: InputMaybe<Scalars['String']>;
  /** Email address if customer is guest. */
  guestEmail?: InputMaybe<Scalars['String']>;
  /** If combo_card_type is credit, Number of installments for the payment. */
  number_of_installments?: InputMaybe<Scalars['Int']>;
  /** Recurring processing model to tokenize the payment method. */
  recurringProcessingModel?: InputMaybe<Scalars['String']>;
  /** The URL to return to in case of a redirection. The format depends on the channel. This URL can have a maximum of 1024 characters. It can include a placeholder `:merchantReference` to identify the order e.g. `https://your-company.com/checkout?shopperOrder=:merchantReference`. */
  returnUrl?: InputMaybe<Scalars['String']>;
  /** JSON string of filled fields. */
  stateData?: InputMaybe<Scalars['String']>;
};

export type AdyenAdditionalDataPosCloud = {
  /** Number of installments for the payment. */
  number_of_installments?: InputMaybe<Scalars['Int']>;
  /** Terminal ID of selected terminal. */
  terminal_id?: InputMaybe<Scalars['String']>;
};

export type AdyenGiftcard = {
  __typename?: 'AdyenGiftcard';
  /** Remaining balance on the gift card. */
  balance?: Maybe<PaymentMethodBalance>;
  /** Gift card brand */
  brand?: Maybe<Scalars['String']>;
  /** Deducted balance from the gift card */
  deductedAmount?: Maybe<Scalars['String']>;
  /** Gift card identifier. */
  stateDataId?: Maybe<Scalars['String']>;
  /** Gift card payment method title */
  title?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodIcon = {
  __typename?: 'AdyenPaymentMethodIcon';
  /** Height of the icon in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** URL of the icon. */
  url?: Maybe<Scalars['String']>;
  /** Width of the icon in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type AdyenPaymentMethods = {
  __typename?: 'AdyenPaymentMethods';
  /** Payment method's additional details. */
  paymentMethodsExtraDetails?: Maybe<Array<Maybe<AdyenPaymentMethodsExtraDetails>>>;
  /** API response from Adyen with payment methods. */
  paymentMethodsResponse?: Maybe<AdyenPaymentMethodsResponse>;
};

export type AdyenPaymentMethodsArray = {
  __typename?: 'AdyenPaymentMethodsArray';
  /** Brand for the selected gift card. For example: plastix, hmclub. */
  brand?: Maybe<Scalars['String']>;
  /** List of possible brands. For example: visa, mc. */
  brands?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The configuration of the payment method. */
  configuration?: Maybe<AdyenPaymentMethodsConfiguration>;
  /**
   * All input details to be provided to complete the payment with this payment method.
   * @deprecated This field will be removed in the next major version following the deprecation in the Checkout API.
   */
  details?: Maybe<Array<Maybe<AdyenPaymentMethodsDetails>>>;
  /** Payment method issuer list. */
  issuers?: Maybe<Array<Maybe<AdyenPaymentMethodsIssuers>>>;
  /** The displayable name of this payment method. */
  name?: Maybe<Scalars['String']>;
  /** The unique payment method code. */
  type?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsBalanceResponse = {
  __typename?: 'AdyenPaymentMethodsBalanceResponse';
  /** Balance of the payment method. */
  balanceResponse?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsConfiguration = {
  __typename?: 'AdyenPaymentMethodsConfiguration';
  /** Name of the merchant for Google Pay. */
  gatewayMerchantId?: Maybe<Scalars['String']>;
  /** ID of the merchant. */
  merchantId?: Maybe<Scalars['String']>;
  /** Name of the merchant. */
  merchantName?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsDetails = {
  __typename?: 'AdyenPaymentMethodsDetails';
  /** The items to choose from in case that the payment method includes a selection list. */
  items?: Maybe<Array<Maybe<AdyenPaymentMethodsDetailsItems>>>;
  /** The value to provide in the result. */
  key?: Maybe<Scalars['String']>;
  /** True if this input is optional. */
  optional?: Maybe<Scalars['String']>;
  /** The type of the required input. */
  type?: Maybe<Scalars['String']>;
  /** The value can be pre-filled, if available. */
  value?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsDetailsItems = {
  __typename?: 'AdyenPaymentMethodsDetailsItems';
  /** The value to provide in the result. */
  id?: Maybe<Scalars['String']>;
  /** The display name. */
  name?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsExtraDetails = {
  __typename?: 'AdyenPaymentMethodsExtraDetails';
  /** Extra configuration settings. */
  configuration?: Maybe<AdyenPaymentMethodsExtraDetailsConfiguration>;
  /** Icon for the payment method. */
  icon?: Maybe<AdyenPaymentMethodIcon>;
  /** True if the payment method is Open Invoice. */
  isOpenInvoice?: Maybe<Scalars['Boolean']>;
  /** The unique payment method code. */
  type?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsExtraDetailsConfiguration = {
  __typename?: 'AdyenPaymentMethodsExtraDetailsConfiguration';
  /** Current order amount in minor units. */
  amount?: Maybe<Money>;
  /** Current order currency. */
  currency?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsIssuers = {
  __typename?: 'AdyenPaymentMethodsIssuers';
  /** Issuer ID. */
  id?: Maybe<Scalars['String']>;
  /** Issuer name. */
  name?: Maybe<Scalars['String']>;
};

export type AdyenPaymentMethodsResponse = {
  __typename?: 'AdyenPaymentMethodsResponse';
  paymentMethods?: Maybe<Array<Maybe<AdyenPaymentMethodsArray>>>;
  storedPaymentMethods?: Maybe<Array<Maybe<AdyenStoredPaymentMethodsArray>>>;
};

export type AdyenPaymentStatus = {
  __typename?: 'AdyenPaymentStatus';
  /** Object containing information about the payment's next step. */
  action?: Maybe<Scalars['String']>;
  /** Additional data required for the next step in the payment process. */
  additionalData?: Maybe<Scalars['String']>;
  /** If True, no further action is required and customer should be redirect to success page. */
  isFinal?: Maybe<Scalars['Boolean']>;
  /** Current state of the order in Adyen. */
  resultCode?: Maybe<Scalars['String']>;
};

export type AdyenRedeemedGiftcardsResponse = {
  __typename?: 'AdyenRedeemedGiftcardsResponse';
  /** List of redeemed gift cards. */
  redeemedGiftcards?: Maybe<Array<Maybe<AdyenGiftcard>>>;
  /** Remaining order amount after giftcard discount. */
  remainingAmount?: Maybe<Scalars['String']>;
  /** Total giftcard discount applied to the cart. */
  totalDiscount?: Maybe<Scalars['String']>;
};

export type AdyenStateData = {
  __typename?: 'AdyenStateData';
  /** ID of the inserted stateData object. */
  stateDataId?: Maybe<Scalars['String']>;
};

export type AdyenStoredPaymentMethodsArray = {
  __typename?: 'AdyenStoredPaymentMethodsArray';
  /** The brand of the card. */
  brand?: Maybe<Scalars['String']>;
  /** The month the card expires. */
  expiryMonth?: Maybe<Scalars['String']>;
  /** The year the card expires. */
  expiryYear?: Maybe<Scalars['String']>;
  /** The unique payment method code. */
  holderName?: Maybe<Scalars['String']>;
  /** The IBAN of the bank account. */
  iban?: Maybe<Scalars['String']>;
  /** A unique identifier of this stored payment method. */
  id?: Maybe<Scalars['String']>;
  /** The last four digits of the PAN. */
  lastFour?: Maybe<Scalars['String']>;
  /** The display name of the stored payment method. */
  name?: Maybe<Scalars['String']>;
  /** Returned in the response if you are not tokenizing with Adyen and are using the Merchant-initiated transactions (MIT) framework from Mastercard or Visa. This contains either the Mastercard Trace ID or the Visa Transaction ID. */
  networkTxReference?: Maybe<Scalars['String']>;
  /** The name of the bank account holder. */
  ownerName?: Maybe<Scalars['String']>;
  /** The shopper’s email address. */
  shopperEmail?: Maybe<Scalars['String']>;
  /** The supported shopper interactions for this stored payment method. */
  supportedShopperInteractions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The type of payment method. */
  type?: Maybe<Scalars['String']>;
};

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']>;
};

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']>;
};

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>;
};

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String'];
};

/** Contains an applied gift card with applied and remaining balance. */
export type AppliedGiftCard = {
  __typename?: 'AppliedGiftCard';
  /** The amount applied to the current cart. */
  applied_balance?: Maybe<Money>;
  /** The gift card account code. */
  code?: Maybe<Scalars['String']>;
  /** The remaining balance on the gift card. */
  current_balance?: Maybe<Money>;
  /** The expiration date of the gift card. */
  expiration_date?: Maybe<Scalars['String']>;
};

/** Contains the applied and current balances. */
export type AppliedStoreCredit = {
  __typename?: 'AppliedStoreCredit';
  /** The applied store credit balance to the current cart. */
  applied_balance?: Maybe<Money>;
  /** The current balance remaining on store credit. */
  current_balance?: Maybe<Money>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the current balance will not be returned. */
  enabled?: Maybe<Scalars['Boolean']>;
};

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** A valid coupon code. */
  coupon_code: Scalars['String'];
};

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  /** The cart after applying a coupon. */
  cart: Cart;
};

/** Defines the input required to run the `applyGiftCardToCart` mutation. */
export type ApplyGiftCardToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
  /** The gift card code to be applied to the cart. */
  gift_card_code: Scalars['String'];
};

/** Defines the possible output for the `applyGiftCardToCart` mutation. */
export type ApplyGiftCardToCartOutput = {
  __typename?: 'ApplyGiftCardToCartOutput';
  /** Describes the contents of the specified shopping cart. */
  cart: Cart;
};

/** Contains the customer cart. */
export type ApplyRewardPointsToCartOutput = {
  __typename?: 'ApplyRewardPointsToCartOutput';
  /** The customer cart after reward points are applied. */
  cart: Cart;
};

/** Defines the input required to run the `applyStoreCreditToCart` mutation. */
export type ApplyStoreCreditToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
};

/** Defines the possible output for the `applyStoreCreditToCart` mutation. */
export type ApplyStoreCreditToCartOutput = {
  __typename?: 'ApplyStoreCreditToCartOutput';
  /** The contents of the specified shopping cart. */
  cart: Cart;
};

export type Assets = {
  __typename?: 'Assets';
  /** The payment method logo url (descriptive) */
  descriptive?: Maybe<Scalars['String']>;
  /** The payment method logo url (standard) */
  standard?: Maybe<Scalars['String']>;
};

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  __typename?: 'AssignCompareListToCustomerOutput';
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean'];
};

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>;
};

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']>;
};

/** Specifies selected option for a select or multiselect attribute value. */
export type AttributeInputSelectedOption = {
  /** The attribute option value. */
  value: Scalars['String'];
};

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The attribute option value. */
  value?: Maybe<Scalars['String']>;
};

/** Specifies the value for attribute. */
export type AttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars['String'];
  /** An array containing selected options for a select or multiselect attribute. */
  selected_options?: InputMaybe<Array<InputMaybe<AttributeInputSelectedOption>>>;
  /** The value assigned to the attribute. */
  value?: InputMaybe<Scalars['String']>;
};

/** Defines the code and symbol of a currency that can be used for purchase orders. */
export type AvailableCurrency = {
  __typename?: 'AvailableCurrency';
  /** 3-letter currency code, for example USD. */
  code: CurrencyEnum;
  /** Currency symbol, for example $. */
  symbol: Scalars['String'];
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean'];
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean'];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

export enum BatchMutationStatus {
  /** @deprecated  */
  Failure = 'FAILURE',
  /** @deprecated  */
  MixedResults = 'MIXED_RESULTS',
  /** @deprecated  */
  Success = 'SUCCESS'
}

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']>;
};

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']>;
};

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<GiftWrapping>>;
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem';
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem';
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID'];
};

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int'];
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float'];
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem';
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars['Boolean']>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'BundleProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the bundle product has a dynamic SKU. */
  dynamic_sku?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput;
};

/** Contains details about bundle products added to a requisition list. */
export type BundleRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'BundleRequisitionListItem';
  /** An array of selected options for a bundle product. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The quantity of the product added to the requisition list. */
  quantity: Scalars['Float'];
  /** The unique ID of an item in a requisition list. */
  uid: Scalars['ID'];
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem';
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Specifies the quote template id of the quote template to cancel */
export type CancelNegotiableQuoteTemplateInput = {
  /** A comment to provide reason of cancellation. */
  cancellation_comment?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart';
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of gift card items applied to the cart. */
  applied_gift_cards?: Maybe<Array<Maybe<AppliedGiftCard>>>;
  /** The amount of reward points applied to the cart. */
  applied_reward_points?: Maybe<RewardPointsAmount>;
  /** Store credit information applied to the cart. */
  applied_store_credit?: Maybe<AppliedStoreCredit>;
  /** The list of available gift wrapping options for the cart. */
  available_gift_wrappings: Array<Maybe<GiftWrapping>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']>;
  /** The entered gift message for the cart */
  gift_message?: Maybe<GiftMessage>;
  /** Indicates whether the shopper requested gift receipt for the cart. */
  gift_receipt_included: Scalars['Boolean'];
  /** The selected gift wrapping for the cart. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID'];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean'];
  /** An array of products that have been added to the cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>;
  /** Indicates whether the shopper requested a printed card for the cart. */
  printed_card_included: Scalars['Boolean'];
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float'];
};

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  /** The country code. */
  code: Scalars['String'];
  /** The display label for the country. */
  label: Scalars['String'];
};

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String'];
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']>;
};

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  /** The state or province code. */
  code?: Maybe<Scalars['String']>;
  /** The display label for the region. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount';
  /** The amount of the discount applied to the item. */
  amount: Money;
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']>>;
};

export type CartItemError = {
  __typename?: 'CartItemError';
  /** An error code that describes the error encountered */
  code: CartItemErrorType;
  /** A localized error message */
  message: Scalars['String'];
};

export enum CartItemErrorType {
  /** @deprecated  */
  ItemIncrements = 'ITEM_INCREMENTS',
  /** @deprecated  */
  ItemQty = 'ITEM_QTY',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of an item to add. */
  quantity: Scalars['Float'];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product. */
  sku: Scalars['String'];
};

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int'];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float'];
};

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars['String'];
  /** A price value. */
  value: Scalars['Float'];
};

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>;
  /** The unique ID for a `GiftWrapping` object to be used for the cart item. */
  gift_wrapping_id?: InputMaybe<Scalars['ID']>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices';
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The list of prices for the selected gift options. */
  gift_options?: Maybe<GiftOptionsPrices>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The description of the tax. */
  label: Scalars['String'];
};

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  __typename?: 'CartUserInputError';
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

export enum CartUserInputErrorType {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  PermissionDenied = 'PERMISSION_DENIED',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

export type Categories = {
  __typename?: 'Categories';
  /** The payment method assets */
  asset_urls?: Maybe<Array<Maybe<Assets>>>;
  /** The payment method identifier */
  identifier: Scalars['String'];
  /** The payment method name */
  name: Scalars['String'];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  automatic_sorting?: Maybe<Scalars['String']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  cat_type_one_between_block?: Maybe<Scalars['String']>;
  category_seo_content?: Maybe<Scalars['String']>;
  children_count?: Maybe<Scalars['String']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  custom_layout_update_file?: Maybe<Scalars['String']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>;
  display_mode?: Maybe<Scalars['String']>;
  filter_price_range?: Maybe<Scalars['Float']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  include_in_menu?: Maybe<Scalars['Int']>;
  is_anchor?: Maybe<Scalars['Int']>;
  is_exclude_cat?: Maybe<Scalars['Int']>;
  is_in_sale?: Maybe<Scalars['Int']>;
  landing_page?: Maybe<Scalars['Int']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Indicates whether the category is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
};


/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult';
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface & RoutableInterface & {
  __typename?: 'CategoryTree';
  automatic_sorting?: Maybe<Scalars['String']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  cat_type_one_between_block?: Maybe<Scalars['String']>;
  category_seo_content?: Maybe<Scalars['String']>;
  /** A tree of child categories. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  custom_layout_update_file?: Maybe<Scalars['String']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>;
  display_mode?: Maybe<Scalars['String']>;
  filter_price_range?: Maybe<Scalars['Float']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  include_in_menu?: Maybe<Scalars['Int']>;
  is_anchor?: Maybe<Scalars['Int']>;
  is_exclude_cat?: Maybe<Scalars['Int']>;
  is_in_sale?: Maybe<Scalars['Int']>;
  landing_page?: Maybe<Scalars['Int']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** Indicates whether the category is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
};


/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int'];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String'];
  /** Required. The text of the agreement. */
  content: Scalars['String'];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean'];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars['String'];
};

/** Indicates how agreements are accepted. */
export enum CheckoutAgreementMode {
  /**
   * Conditions are automatically accepted upon checkout.
   * @deprecated
   */
  Auto = 'AUTO',
  /**
   * Shoppers must manually accept the conditions to place an order.
   * @deprecated
   */
  Manual = 'MANUAL'
}

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError';
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars['String'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']>>;
};

export enum CheckoutUserInputErrorCodes {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  ReorderNotAvailable = 'REORDER_NOT_AVAILABLE',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Output of the request to clear the customer cart. */
export type ClearCustomerCartOutput = {
  __typename?: 'ClearCustomerCartOutput';
  /** The cart after clearing items. */
  cart?: Maybe<Cart>;
  /** Indicates whether cart was cleared. */
  status: Scalars['Boolean'];
};

export type CloseNegotiableQuoteError = InternalError | NegotiableQuoteInvalidStateError | NoSuchEntityUidError;

/** Contains details about a failed close operation on a negotiable quote. */
export type CloseNegotiableQuoteOperationFailure = {
  __typename?: 'CloseNegotiableQuoteOperationFailure';
  /** An array of errors encountered while attempting close the negotiable quote. */
  errors: Array<Maybe<CloseNegotiableQuoteError>>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

export type CloseNegotiableQuoteOperationResult = CloseNegotiableQuoteOperationFailure | NegotiableQuoteUidOperationSuccess;

/** Defines the negotiable quotes to mark as closed. */
export type CloseNegotiableQuotesInput = {
  /** A list of unique IDs from `NegotiableQuote` objects. */
  quote_uids: Array<InputMaybe<Scalars['ID']>>;
};

/** Contains the closed negotiable quotes and other negotiable quotes the company user can view. */
export type CloseNegotiableQuotesOutput = {
  __typename?: 'CloseNegotiableQuotesOutput';
  /**
   * An array containing the negotiable quotes that were just closed.
   * @deprecated Use `operation_results` instead.
   */
  closed_quotes?: Maybe<Array<Maybe<NegotiableQuote>>>;
  /** A list of negotiable quotes that can be viewed by the logged-in customer */
  negotiable_quotes?: Maybe<NegotiableQuotesOutput>;
  /** An array of closed negotiable quote UIDs and details about any errors. */
  operation_results: Array<Maybe<CloseNegotiableQuoteOperationResult>>;
  /** The status of the request to close one or more negotiable quotes. */
  result_status: BatchMutationStatus;
};


/** Contains the closed negotiable quotes and other negotiable quotes the company user can view. */
export type CloseNegotiableQuotesOutputNegotiable_QuotesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NegotiableQuoteFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<NegotiableQuoteSortInput>;
};

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']>;
};

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage';
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** The fields available for sorting the customer companies. */
export enum CompaniesSortFieldEnum {
  /**
   * The name of the company.
   * @deprecated
   */
  Name = 'NAME'
}

/** Specifies which field to sort on, and whether to return the results in ascending or descending order. */
export type CompaniesSortInput = {
  /** The field for sorting the results. */
  field: CompaniesSortFieldEnum;
  /** Indicates whether to return results in ascending or descending order. */
  order: SortEnum;
};

/** Contains the output schema for a company. */
export type Company = {
  __typename?: 'Company';
  /** The list of all resources defined within the company. */
  acl_resources?: Maybe<Array<Maybe<CompanyAclResource>>>;
  /** An object containing information about the company administrator. */
  company_admin?: Maybe<Customer>;
  /** Company credit balances and limits. */
  credit: CompanyCredit;
  /** Details about the history of company credit operations. */
  credit_history: CompanyCreditHistory;
  /** The email address of the company contact. */
  email?: Maybe<Scalars['String']>;
  /** The unique ID of a `Company` object. */
  id: Scalars['ID'];
  /** The address where the company is registered to conduct business. */
  legal_address?: Maybe<CompanyLegalAddress>;
  /** The full legal name of the company. */
  legal_name?: Maybe<Scalars['String']>;
  /** The name of the company. */
  name?: Maybe<Scalars['String']>;
  /** The list of payment methods available to a company. */
  payment_methods?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The resale number that is assigned to the company for tax reporting purposes. */
  reseller_id?: Maybe<Scalars['String']>;
  /** A company role filtered by the unique ID of a `CompanyRole` object. */
  role?: Maybe<CompanyRole>;
  /** An object that contains a list of company roles. */
  roles: CompanyRoles;
  /** An object containing information about the company sales representative. */
  sales_representative?: Maybe<CompanySalesRepresentative>;
  /** The company structure of teams and customers in depth-first order. */
  structure?: Maybe<CompanyStructure>;
  /** The company team data filtered by the unique ID for a `CompanyTeam` object. */
  team?: Maybe<CompanyTeam>;
  /** A company user filtered by the unique ID of a `Customer` object. */
  user?: Maybe<Customer>;
  /** An object that contains a list of company users based on activity status. */
  users?: Maybe<CompanyUsers>;
  /** The value-added tax number that is assigned to the company by some jurisdictions for tax reporting purposes. */
  vat_tax_id?: Maybe<Scalars['String']>;
};


/** Contains the output schema for a company. */
export type CompanyCredit_HistoryArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CompanyCreditHistoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Contains the output schema for a company. */
export type CompanyRoleArgs = {
  id: Scalars['ID'];
};


/** Contains the output schema for a company. */
export type CompanyRolesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Contains the output schema for a company. */
export type CompanyStructureArgs = {
  depth?: InputMaybe<Scalars['Int']>;
  rootId?: InputMaybe<Scalars['ID']>;
};


/** Contains the output schema for a company. */
export type CompanyTeamArgs = {
  id: Scalars['ID'];
};


/** Contains the output schema for a company. */
export type CompanyUserArgs = {
  id: Scalars['ID'];
};


/** Contains the output schema for a company. */
export type CompanyUsersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CompanyUsersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains details about the access control list settings of a resource. */
export type CompanyAclResource = {
  __typename?: 'CompanyAclResource';
  /** An array of sub-resources. */
  children?: Maybe<Array<Maybe<CompanyAclResource>>>;
  /** The unique ID for a `CompanyAclResource` object. */
  id: Scalars['ID'];
  /** The sort order of an ACL resource. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The label assigned to the ACL resource. */
  text?: Maybe<Scalars['String']>;
};

/** Contains details about the company administrator. */
export type CompanyAdmin = {
  __typename?: 'CompanyAdmin';
  /** The email address of the company administrator. */
  email?: Maybe<Scalars['String']>;
  /** The company administrator's first name. */
  firstname?: Maybe<Scalars['String']>;
  /** The company administrator's gender (Male - 1, Female - 2, Not Specified - 3). */
  gender?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CompanyAdmin` object. */
  id: Scalars['ID'];
  /** The job title of the company administrator. */
  job_title?: Maybe<Scalars['String']>;
  /** The company administrator's last name. */
  lastname?: Maybe<Scalars['String']>;
};

/** Defines the input schema for creating a company administrator. */
export type CompanyAdminInput = {
  /** The company administrator's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The email address of the company administrator. */
  email: Scalars['String'];
  /** The company administrator's first name. */
  firstname: Scalars['String'];
  /** The company administrator's gender (Male - 1, Female - 2, Not Specified - 3). */
  gender?: InputMaybe<Scalars['Int']>;
  /** The job title of the company administrator. */
  job_title?: InputMaybe<Scalars['String']>;
  /** The company administrator's last name. */
  lastname: Scalars['String'];
  /** The phone number of the company administrator. */
  telephone?: InputMaybe<Scalars['String']>;
};

/** The minimal required information to identify and display the company. */
export type CompanyBasicInfo = {
  __typename?: 'CompanyBasicInfo';
  /** The unique ID of a `Company` object. */
  id: Scalars['ID'];
  /** The full legal name of the company. */
  legal_name?: Maybe<Scalars['String']>;
  /** The name of the company. */
  name?: Maybe<Scalars['String']>;
};

/** Defines the input schema for creating a new company. */
export type CompanyCreateInput = {
  /** Defines the company administrator. */
  company_admin: CompanyAdminInput;
  /** The email address of the company contact. */
  company_email: Scalars['String'];
  /** The name of the company to create. */
  company_name: Scalars['String'];
  /** Defines legal address data of the company. */
  legal_address: CompanyLegalAddressCreateInput;
  /** The full legal name of the company. */
  legal_name?: InputMaybe<Scalars['String']>;
  /** The resale number that is assigned to the company for tax reporting purposes. */
  reseller_id?: InputMaybe<Scalars['String']>;
  /** The value-added tax number that is assigned to the company by some jurisdictions for tax reporting purposes. */
  vat_tax_id?: InputMaybe<Scalars['String']>;
};

/** Contains company credit balances and limits. */
export type CompanyCredit = {
  __typename?: 'CompanyCredit';
  /** The sum of the credit limit and the outstanding balance. If the company has exceeded the credit limit, the amount is as a negative value. */
  available_credit: Money;
  /** The amount of credit extended to the company. */
  credit_limit: Money;
  /** The amount reimbursed, less the total due from all orders placed using the Payment on Account payment method. The amount can be a positive or negative value. */
  outstanding_balance: Money;
};

/** Contains details about prior company credit operations. */
export type CompanyCreditHistory = {
  __typename?: 'CompanyCreditHistory';
  /** An array of company credit operations. */
  items: Array<Maybe<CompanyCreditOperation>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
  /** The number of the company credit operations matching the specified filter. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Defines a filter for narrowing the results of a credit history search. */
export type CompanyCreditHistoryFilterInput = {
  /** The purchase order number associated with the company credit operation. */
  custom_reference_number?: InputMaybe<Scalars['String']>;
  /** The type of the company credit operation. */
  operation_type?: InputMaybe<CompanyCreditOperationType>;
  /** The name of the person submitting the company credit operation. */
  updated_by?: InputMaybe<Scalars['String']>;
};

/** Contains details about a single company credit operation. */
export type CompanyCreditOperation = {
  __typename?: 'CompanyCreditOperation';
  /** The amount of the company credit operation. */
  amount?: Maybe<Money>;
  /** The credit balance as a result of the operation. */
  balance: CompanyCredit;
  /** The purchase order number associated with the company credit operation. */
  custom_reference_number?: Maybe<Scalars['String']>;
  /** The date the operation occurred. */
  date: Scalars['String'];
  /** The type of the company credit operation. */
  type: CompanyCreditOperationType;
  /** The company user that submitted the company credit operation. */
  updated_by: CompanyCreditOperationUser;
};

export enum CompanyCreditOperationType {
  /** @deprecated  */
  Allocation = 'ALLOCATION',
  /** @deprecated  */
  Purchase = 'PURCHASE',
  /** @deprecated  */
  Refund = 'REFUND',
  /** @deprecated  */
  Reimbursement = 'REIMBURSEMENT',
  /** @deprecated  */
  Revert = 'REVERT',
  /** @deprecated  */
  Update = 'UPDATE'
}

/** Defines the administrator or company user that submitted a company credit operation. */
export type CompanyCreditOperationUser = {
  __typename?: 'CompanyCreditOperationUser';
  /** The name of the company user submitting the company credit operation. */
  name: Scalars['String'];
  /** The type of the company user submitting the company credit operation. */
  type: CompanyCreditOperationUserType;
};

export enum CompanyCreditOperationUserType {
  /** @deprecated  */
  Admin = 'ADMIN',
  /** @deprecated  */
  Customer = 'CUSTOMER'
}

/** Defines the input schema for accepting the company invitation. */
export type CompanyInvitationInput = {
  /** The invitation code. */
  code: Scalars['String'];
  /** The company role id. */
  role_id?: InputMaybe<Scalars['ID']>;
  /** Company user attributes in the invitation. */
  user: CompanyInvitationUserInput;
};

/** The result of accepting the company invitation. */
export type CompanyInvitationOutput = {
  __typename?: 'CompanyInvitationOutput';
  /** Indicates whether the customer was added to the company successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** Company user attributes in the invitation. */
export type CompanyInvitationUserInput = {
  /** The company unique identifier. */
  company_id: Scalars['ID'];
  /** The customer unique identifier. */
  customer_id: Scalars['ID'];
  /** The job title of a company user. */
  job_title?: InputMaybe<Scalars['String']>;
  /** Indicates whether the company user is ACTIVE or INACTIVE. */
  status?: InputMaybe<CompanyUserStatusEnum>;
  /** The phone number of the company user. */
  telephone?: InputMaybe<Scalars['String']>;
};

/** Contains details about the address where the company is registered to conduct business. */
export type CompanyLegalAddress = {
  __typename?: 'CompanyLegalAddress';
  /** The city where the company is registered to conduct business. */
  city?: Maybe<Scalars['String']>;
  /** The country code of the company's legal address. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The company's postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing region data for the company. */
  region?: Maybe<CustomerAddressRegion>;
  /** An array of strings that define the company's street address. */
  street?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The company's phone number. */
  telephone?: Maybe<Scalars['String']>;
};

/** Defines the input schema for defining a company's legal address. */
export type CompanyLegalAddressCreateInput = {
  /** The city where the company is registered to conduct business. */
  city: Scalars['String'];
  /** The company's country ID. Use the `countries` query to get this value. */
  country_id: CountryCodeEnum;
  /** The postal code of the company. */
  postcode: Scalars['String'];
  /** An object containing the region name and/or region ID where the company is registered to conduct business. */
  region: CustomerAddressRegionInput;
  /** An array of strings that define the street address where the company is registered to conduct business. */
  street: Array<InputMaybe<Scalars['String']>>;
  /** The primary phone number of the company. */
  telephone: Scalars['String'];
};

/** Defines the input schema for updating a company's legal address. */
export type CompanyLegalAddressUpdateInput = {
  /** The city where the company is registered to conduct business. */
  city?: InputMaybe<Scalars['String']>;
  /** The unique ID for a `Country` object. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** The postal code of the company. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An object containing the region name and/or region ID where the company is registered to conduct business. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street address where the company is registered to conduct business. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The primary phone number of the company. */
  telephone?: InputMaybe<Scalars['String']>;
};

/** Contails details about a single role. */
export type CompanyRole = {
  __typename?: 'CompanyRole';
  /** The unique ID for a `CompanyRole` object. */
  id: Scalars['ID'];
  /** The name assigned to the role. */
  name?: Maybe<Scalars['String']>;
  /** A list of permission resources defined for a role. */
  permissions?: Maybe<Array<Maybe<CompanyAclResource>>>;
  /** The total number of users assigned the specified role. */
  users_count?: Maybe<Scalars['Int']>;
};

/** Defines the input schema for creating a company role. */
export type CompanyRoleCreateInput = {
  /** The name of the role to create. */
  name: Scalars['String'];
  /** A list of resources the role can access. */
  permissions: Array<InputMaybe<Scalars['String']>>;
};

/** Defines the input schema for updating a company role. */
export type CompanyRoleUpdateInput = {
  /** The unique ID for a `CompanyRole` object. */
  id: Scalars['ID'];
  /** The name of the role to update. */
  name?: InputMaybe<Scalars['String']>;
  /** A list of resources the role can access. */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Contains an array of roles. */
export type CompanyRoles = {
  __typename?: 'CompanyRoles';
  /** A list of company roles that match the specified filter criteria. */
  items: Array<Maybe<CompanyRole>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of objects matching the specified filter. */
  total_count: Scalars['Int'];
};

/** Contains details about a company sales representative. */
export type CompanySalesRepresentative = {
  __typename?: 'CompanySalesRepresentative';
  /** The email address of the company sales representative. */
  email?: Maybe<Scalars['String']>;
  /** The company sales representative's first name. */
  firstname?: Maybe<Scalars['String']>;
  /** The company sales representative's last name. */
  lastname?: Maybe<Scalars['String']>;
};

/** Contains an array of the individual nodes that comprise the company structure. */
export type CompanyStructure = {
  __typename?: 'CompanyStructure';
  /** An array of elements in a company structure. */
  items?: Maybe<Array<Maybe<CompanyStructureItem>>>;
};

export type CompanyStructureEntity = CompanyTeam | Customer;

/** Defines an individual node in the company structure. */
export type CompanyStructureItem = {
  __typename?: 'CompanyStructureItem';
  /** A union of `CompanyTeam` and `Customer` objects. */
  entity?: Maybe<CompanyStructureEntity>;
  /** The unique ID for a `CompanyStructureItem` object. */
  id: Scalars['ID'];
  /** The ID of the parent item in the company hierarchy. */
  parent_id?: Maybe<Scalars['ID']>;
};

/** Defines the input schema for updating the company structure. */
export type CompanyStructureUpdateInput = {
  /** The ID of a company that will be the new parent. */
  parent_tree_id: Scalars['ID'];
  /** The ID of the company team that is being moved to another parent. */
  tree_id: Scalars['ID'];
};

/** Describes a company team. */
export type CompanyTeam = {
  __typename?: 'CompanyTeam';
  /** An optional description of the team. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `CompanyTeam` object. */
  id: Scalars['ID'];
  /** The display name of the team. */
  name?: Maybe<Scalars['String']>;
  /** ID of the company structure */
  structure_id: Scalars['ID'];
};

/** Defines the input schema for creating a company team. */
export type CompanyTeamCreateInput = {
  /** An optional description of the team. */
  description?: InputMaybe<Scalars['String']>;
  /** The display name of the team. */
  name: Scalars['String'];
  /** The ID of a node within a company's structure. This ID will be the parent of the created team. */
  target_id?: InputMaybe<Scalars['ID']>;
};

/** Defines the input schema for updating a company team. */
export type CompanyTeamUpdateInput = {
  /** An optional description of the team. */
  description?: InputMaybe<Scalars['String']>;
  /** The unique ID of the `CompanyTeam` object to update. */
  id: Scalars['ID'];
  /** The display name of the team. */
  name?: InputMaybe<Scalars['String']>;
};

/** Defines the input schema for updating a company. */
export type CompanyUpdateInput = {
  /** The email address of the company contact. */
  company_email?: InputMaybe<Scalars['String']>;
  /** The name of the company to update. */
  company_name?: InputMaybe<Scalars['String']>;
  /** The legal address data of the company. */
  legal_address?: InputMaybe<CompanyLegalAddressUpdateInput>;
  /** The full legal name of the company. */
  legal_name?: InputMaybe<Scalars['String']>;
  /** The resale number that is assigned to the company for tax reporting purposes. */
  reseller_id?: InputMaybe<Scalars['String']>;
  /** The value-added tax number that is assigned to the company by some jurisdictions for tax reporting purposes. */
  vat_tax_id?: InputMaybe<Scalars['String']>;
};

/** Defines the input schema for creating a company user. */
export type CompanyUserCreateInput = {
  /** The company user's email address */
  email: Scalars['String'];
  /** The company user's first name. */
  firstname: Scalars['String'];
  /** The company user's job title or function. */
  job_title: Scalars['String'];
  /** The company user's last name. */
  lastname: Scalars['String'];
  /** The unique ID for a `CompanyRole` object. */
  role_id: Scalars['ID'];
  /** Indicates whether the company user is ACTIVE or INACTIVE. */
  status: CompanyUserStatusEnum;
  /** The ID of a node within a company's structure. This ID will be the parent of the created company user. */
  target_id?: InputMaybe<Scalars['ID']>;
  /** The company user's phone number. */
  telephone: Scalars['String'];
};

/** Defines the list of company user status values. */
export enum CompanyUserStatusEnum {
  /**
   * Only active users.
   * @deprecated
   */
  Active = 'ACTIVE',
  /**
   * Only inactive users.
   * @deprecated
   */
  Inactive = 'INACTIVE'
}

/** Defines the input schema for updating a company user. */
export type CompanyUserUpdateInput = {
  /** The company user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** The company user's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `Customer` object. */
  id: Scalars['ID'];
  /** The company user's job title or function. */
  job_title?: InputMaybe<Scalars['String']>;
  /** The company user's last name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The unique ID for a `CompanyRole` object. */
  role_id?: InputMaybe<Scalars['ID']>;
  /** Indicates whether the company user is ACTIVE or INACTIVE. */
  status?: InputMaybe<CompanyUserStatusEnum>;
  /** The company user's phone number. */
  telephone?: InputMaybe<Scalars['String']>;
};

/** Contains details about company users. */
export type CompanyUsers = {
  __typename?: 'CompanyUsers';
  /** An array of `CompanyUser` objects that match the specified filter criteria. */
  items: Array<Maybe<Customer>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of objects returned. */
  total_count: Scalars['Int'];
};

/** Defines the filter for returning a list of company users. */
export type CompanyUsersFilterInput = {
  /** The activity status to filter on. */
  status?: InputMaybe<CompanyUserStatusEnum>;
};

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  __typename?: 'ComparableAttribute';
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String'];
  /** The label of the attribute code. */
  label: Scalars['String'];
};

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  __typename?: 'ComparableItem';
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>;
  /** Details about a product in a compare list. */
  product: ProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID'];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  __typename?: 'CompareList';
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars['Int'];
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID'];
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** Text that can contain HTML tags. */
  html: Scalars['String'];
};

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID'];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']>;
};

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<GiftWrapping>>;
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'ConfigurableProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** An array of options for the configurable product. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
  configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** An array of simple product variants. */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']>>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']>;
};

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** The display name of the option. */
  label: Scalars['String'];
  /** The unique ID of the configurable option. */
  uid: Scalars['ID'];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue';
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean'];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean'];
  /** The display name of the value. */
  label: Scalars['String'];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars['ID'];
};

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID'];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID'];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection';
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<ConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']>;
  /** The label of the product. */
  label?: Maybe<Scalars['String']>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']>;
};

/** Contains details about configurable products added to a requisition list. */
export type ConfigurableRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'ConfigurableRequisitionListItem';
  /** Selected configurable options for an item in the requisition list. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The quantity of the product added to the requisition list. */
  quantity: Scalars['Float'];
  /** The unique ID of an item in a requisition list. */
  uid: Scalars['ID'];
};

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>;
};

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String'];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** An input object that defines the items in a requisition list to be copied. */
export type CopyItemsBetweenRequisitionListsInput = {
  /** An array of IDs representing products copied from one requisition list to another. */
  requisitionListItemUids: Array<InputMaybe<Scalars['ID']>>;
};

/** Output of the request to copy items to the destination requisition list. */
export type CopyItemsFromRequisitionListsOutput = {
  __typename?: 'CopyItemsFromRequisitionListsOutput';
  /** The destination requisition list after the items were copied. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Contains the source and target wish lists after copying products. */
export type CopyProductsBetweenWishlistsOutput = {
  __typename?: 'CopyProductsBetweenWishlistsOutput';
  /** The destination wish list containing the copied products. */
  destination_wishlist: Wishlist;
  /** The wish list that the products were copied from. */
  source_wishlist: Wishlist;
  /** An array of errors encountered while copying products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
};

export type Country = {
  __typename?: 'Country';
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>;
  /** Country id default for store or not */
  default?: Maybe<Scalars['Boolean']>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']>;
};

/** The list of country codes. */
export enum CountryCodeEnum {
  /**
   * Andorra
   * @deprecated
   */
  Ad = 'AD',
  /**
   * United Arab Emirates
   * @deprecated
   */
  Ae = 'AE',
  /**
   * Afghanistan
   * @deprecated
   */
  Af = 'AF',
  /**
   * Antigua & Barbuda
   * @deprecated
   */
  Ag = 'AG',
  /**
   * Anguilla
   * @deprecated
   */
  Ai = 'AI',
  /**
   * Albania
   * @deprecated
   */
  Al = 'AL',
  /**
   * Armenia
   * @deprecated
   */
  Am = 'AM',
  /**
   * Netherlands Antilles
   * @deprecated
   */
  An = 'AN',
  /**
   * Angola
   * @deprecated
   */
  Ao = 'AO',
  /**
   * Antarctica
   * @deprecated
   */
  Aq = 'AQ',
  /**
   * Argentina
   * @deprecated
   */
  Ar = 'AR',
  /**
   * American Samoa
   * @deprecated
   */
  As = 'AS',
  /**
   * Austria
   * @deprecated
   */
  At = 'AT',
  /**
   * Australia
   * @deprecated
   */
  Au = 'AU',
  /**
   * Aruba
   * @deprecated
   */
  Aw = 'AW',
  /**
   * Åland Islands
   * @deprecated
   */
  Ax = 'AX',
  /**
   * Azerbaijan
   * @deprecated
   */
  Az = 'AZ',
  /**
   * Bosnia & Herzegovina
   * @deprecated
   */
  Ba = 'BA',
  /**
   * Barbados
   * @deprecated
   */
  Bb = 'BB',
  /**
   * Bangladesh
   * @deprecated
   */
  Bd = 'BD',
  /**
   * Belgium
   * @deprecated
   */
  Be = 'BE',
  /**
   * Burkina Faso
   * @deprecated
   */
  Bf = 'BF',
  /**
   * Bulgaria
   * @deprecated
   */
  Bg = 'BG',
  /**
   * Bahrain
   * @deprecated
   */
  Bh = 'BH',
  /**
   * Burundi
   * @deprecated
   */
  Bi = 'BI',
  /**
   * Benin
   * @deprecated
   */
  Bj = 'BJ',
  /**
   * St. Barthélemy
   * @deprecated
   */
  Bl = 'BL',
  /**
   * Bermuda
   * @deprecated
   */
  Bm = 'BM',
  /**
   * Brunei
   * @deprecated
   */
  Bn = 'BN',
  /**
   * Bolivia
   * @deprecated
   */
  Bo = 'BO',
  /**
   * Brazil
   * @deprecated
   */
  Br = 'BR',
  /**
   * Bahamas
   * @deprecated
   */
  Bs = 'BS',
  /**
   * Bhutan
   * @deprecated
   */
  Bt = 'BT',
  /**
   * Bouvet Island
   * @deprecated
   */
  Bv = 'BV',
  /**
   * Botswana
   * @deprecated
   */
  Bw = 'BW',
  /**
   * Belarus
   * @deprecated
   */
  By = 'BY',
  /**
   * Belize
   * @deprecated
   */
  Bz = 'BZ',
  /**
   * Canada
   * @deprecated
   */
  Ca = 'CA',
  /**
   * Cocos (Keeling) Islands
   * @deprecated
   */
  Cc = 'CC',
  /**
   * Congo-Kinshasa
   * @deprecated
   */
  Cd = 'CD',
  /**
   * Central African Republic
   * @deprecated
   */
  Cf = 'CF',
  /**
   * Congo-Brazzaville
   * @deprecated
   */
  Cg = 'CG',
  /**
   * Switzerland
   * @deprecated
   */
  Ch = 'CH',
  /**
   * Côte d’Ivoire
   * @deprecated
   */
  Ci = 'CI',
  /**
   * Cook Islands
   * @deprecated
   */
  Ck = 'CK',
  /**
   * Chile
   * @deprecated
   */
  Cl = 'CL',
  /**
   * Cameroon
   * @deprecated
   */
  Cm = 'CM',
  /**
   * China
   * @deprecated
   */
  Cn = 'CN',
  /**
   * Colombia
   * @deprecated
   */
  Co = 'CO',
  /**
   * Costa Rica
   * @deprecated
   */
  Cr = 'CR',
  /**
   * Cuba
   * @deprecated
   */
  Cu = 'CU',
  /**
   * Cape Verde
   * @deprecated
   */
  Cv = 'CV',
  /**
   * Christmas Island
   * @deprecated
   */
  Cx = 'CX',
  /**
   * Cyprus
   * @deprecated
   */
  Cy = 'CY',
  /**
   * Czech Republic
   * @deprecated
   */
  Cz = 'CZ',
  /**
   * Germany
   * @deprecated
   */
  De = 'DE',
  /**
   * Djibouti
   * @deprecated
   */
  Dj = 'DJ',
  /**
   * Denmark
   * @deprecated
   */
  Dk = 'DK',
  /**
   * Dominica
   * @deprecated
   */
  Dm = 'DM',
  /**
   * Dominican Republic
   * @deprecated
   */
  Do = 'DO',
  /**
   * Algeria
   * @deprecated
   */
  Dz = 'DZ',
  /**
   * Ecuador
   * @deprecated
   */
  Ec = 'EC',
  /**
   * Estonia
   * @deprecated
   */
  Ee = 'EE',
  /**
   * Egypt
   * @deprecated
   */
  Eg = 'EG',
  /**
   * Western Sahara
   * @deprecated
   */
  Eh = 'EH',
  /**
   * Eritrea
   * @deprecated
   */
  Er = 'ER',
  /**
   * Spain
   * @deprecated
   */
  Es = 'ES',
  /**
   * Ethiopia
   * @deprecated
   */
  Et = 'ET',
  /**
   * Finland
   * @deprecated
   */
  Fi = 'FI',
  /**
   * Fiji
   * @deprecated
   */
  Fj = 'FJ',
  /**
   * Falkland Islands
   * @deprecated
   */
  Fk = 'FK',
  /**
   * Micronesia
   * @deprecated
   */
  Fm = 'FM',
  /**
   * Faroe Islands
   * @deprecated
   */
  Fo = 'FO',
  /**
   * France
   * @deprecated
   */
  Fr = 'FR',
  /**
   * Gabon
   * @deprecated
   */
  Ga = 'GA',
  /**
   * United Kingdom
   * @deprecated
   */
  Gb = 'GB',
  /**
   * Grenada
   * @deprecated
   */
  Gd = 'GD',
  /**
   * Georgia
   * @deprecated
   */
  Ge = 'GE',
  /**
   * French Guiana
   * @deprecated
   */
  Gf = 'GF',
  /**
   * Guernsey
   * @deprecated
   */
  Gg = 'GG',
  /**
   * Ghana
   * @deprecated
   */
  Gh = 'GH',
  /**
   * Gibraltar
   * @deprecated
   */
  Gi = 'GI',
  /**
   * Greenland
   * @deprecated
   */
  Gl = 'GL',
  /**
   * Gambia
   * @deprecated
   */
  Gm = 'GM',
  /**
   * Guinea
   * @deprecated
   */
  Gn = 'GN',
  /**
   * Guadeloupe
   * @deprecated
   */
  Gp = 'GP',
  /**
   * Equatorial Guinea
   * @deprecated
   */
  Gq = 'GQ',
  /**
   * Greece
   * @deprecated
   */
  Gr = 'GR',
  /**
   * South Georgia & South Sandwich Islands
   * @deprecated
   */
  Gs = 'GS',
  /**
   * Guatemala
   * @deprecated
   */
  Gt = 'GT',
  /**
   * Guam
   * @deprecated
   */
  Gu = 'GU',
  /**
   * Guinea-Bissau
   * @deprecated
   */
  Gw = 'GW',
  /**
   * Guyana
   * @deprecated
   */
  Gy = 'GY',
  /**
   * Hong Kong SAR China
   * @deprecated
   */
  Hk = 'HK',
  /**
   * Heard &amp; McDonald Islands
   * @deprecated
   */
  Hm = 'HM',
  /**
   * Honduras
   * @deprecated
   */
  Hn = 'HN',
  /**
   * Croatia
   * @deprecated
   */
  Hr = 'HR',
  /**
   * Haiti
   * @deprecated
   */
  Ht = 'HT',
  /**
   * Hungary
   * @deprecated
   */
  Hu = 'HU',
  /**
   * Indonesia
   * @deprecated
   */
  Id = 'ID',
  /**
   * Ireland
   * @deprecated
   */
  Ie = 'IE',
  /**
   * Israel
   * @deprecated
   */
  Il = 'IL',
  /**
   * Isle of Man
   * @deprecated
   */
  Im = 'IM',
  /**
   * India
   * @deprecated
   */
  In = 'IN',
  /**
   * British Indian Ocean Territory
   * @deprecated
   */
  Io = 'IO',
  /**
   * Iraq
   * @deprecated
   */
  Iq = 'IQ',
  /**
   * Iran
   * @deprecated
   */
  Ir = 'IR',
  /**
   * Iceland
   * @deprecated
   */
  Is = 'IS',
  /**
   * Italy
   * @deprecated
   */
  It = 'IT',
  /**
   * Jersey
   * @deprecated
   */
  Je = 'JE',
  /**
   * Jamaica
   * @deprecated
   */
  Jm = 'JM',
  /**
   * Jordan
   * @deprecated
   */
  Jo = 'JO',
  /**
   * Japan
   * @deprecated
   */
  Jp = 'JP',
  /**
   * Kenya
   * @deprecated
   */
  Ke = 'KE',
  /**
   * Kyrgyzstan
   * @deprecated
   */
  Kg = 'KG',
  /**
   * Cambodia
   * @deprecated
   */
  Kh = 'KH',
  /**
   * Kiribati
   * @deprecated
   */
  Ki = 'KI',
  /**
   * Comoros
   * @deprecated
   */
  Km = 'KM',
  /**
   * St. Kitts & Nevis
   * @deprecated
   */
  Kn = 'KN',
  /**
   * North Korea
   * @deprecated
   */
  Kp = 'KP',
  /**
   * South Korea
   * @deprecated
   */
  Kr = 'KR',
  /**
   * Kuwait
   * @deprecated
   */
  Kw = 'KW',
  /**
   * Cayman Islands
   * @deprecated
   */
  Ky = 'KY',
  /**
   * Kazakhstan
   * @deprecated
   */
  Kz = 'KZ',
  /**
   * Laos
   * @deprecated
   */
  La = 'LA',
  /**
   * Lebanon
   * @deprecated
   */
  Lb = 'LB',
  /**
   * St. Lucia
   * @deprecated
   */
  Lc = 'LC',
  /**
   * Liechtenstein
   * @deprecated
   */
  Li = 'LI',
  /**
   * Sri Lanka
   * @deprecated
   */
  Lk = 'LK',
  /**
   * Liberia
   * @deprecated
   */
  Lr = 'LR',
  /**
   * Lesotho
   * @deprecated
   */
  Ls = 'LS',
  /**
   * Lithuania
   * @deprecated
   */
  Lt = 'LT',
  /**
   * Luxembourg
   * @deprecated
   */
  Lu = 'LU',
  /**
   * Latvia
   * @deprecated
   */
  Lv = 'LV',
  /**
   * Libya
   * @deprecated
   */
  Ly = 'LY',
  /**
   * Morocco
   * @deprecated
   */
  Ma = 'MA',
  /**
   * Monaco
   * @deprecated
   */
  Mc = 'MC',
  /**
   * Moldova
   * @deprecated
   */
  Md = 'MD',
  /**
   * Montenegro
   * @deprecated
   */
  Me = 'ME',
  /**
   * St. Martin
   * @deprecated
   */
  Mf = 'MF',
  /**
   * Madagascar
   * @deprecated
   */
  Mg = 'MG',
  /**
   * Marshall Islands
   * @deprecated
   */
  Mh = 'MH',
  /**
   * Macedonia
   * @deprecated
   */
  Mk = 'MK',
  /**
   * Mali
   * @deprecated
   */
  Ml = 'ML',
  /**
   * Myanmar (Burma)
   * @deprecated
   */
  Mm = 'MM',
  /**
   * Mongolia
   * @deprecated
   */
  Mn = 'MN',
  /**
   * Macau SAR China
   * @deprecated
   */
  Mo = 'MO',
  /**
   * Northern Mariana Islands
   * @deprecated
   */
  Mp = 'MP',
  /**
   * Martinique
   * @deprecated
   */
  Mq = 'MQ',
  /**
   * Mauritania
   * @deprecated
   */
  Mr = 'MR',
  /**
   * Montserrat
   * @deprecated
   */
  Ms = 'MS',
  /**
   * Malta
   * @deprecated
   */
  Mt = 'MT',
  /**
   * Mauritius
   * @deprecated
   */
  Mu = 'MU',
  /**
   * Maldives
   * @deprecated
   */
  Mv = 'MV',
  /**
   * Malawi
   * @deprecated
   */
  Mw = 'MW',
  /**
   * Mexico
   * @deprecated
   */
  Mx = 'MX',
  /**
   * Malaysia
   * @deprecated
   */
  My = 'MY',
  /**
   * Mozambique
   * @deprecated
   */
  Mz = 'MZ',
  /**
   * Namibia
   * @deprecated
   */
  Na = 'NA',
  /**
   * New Caledonia
   * @deprecated
   */
  Nc = 'NC',
  /**
   * Niger
   * @deprecated
   */
  Ne = 'NE',
  /**
   * Norfolk Island
   * @deprecated
   */
  Nf = 'NF',
  /**
   * Nigeria
   * @deprecated
   */
  Ng = 'NG',
  /**
   * Nicaragua
   * @deprecated
   */
  Ni = 'NI',
  /**
   * Netherlands
   * @deprecated
   */
  Nl = 'NL',
  /**
   * Norway
   * @deprecated
   */
  No = 'NO',
  /**
   * Nepal
   * @deprecated
   */
  Np = 'NP',
  /**
   * Nauru
   * @deprecated
   */
  Nr = 'NR',
  /**
   * Niue
   * @deprecated
   */
  Nu = 'NU',
  /**
   * New Zealand
   * @deprecated
   */
  Nz = 'NZ',
  /**
   * Oman
   * @deprecated
   */
  Om = 'OM',
  /**
   * Panama
   * @deprecated
   */
  Pa = 'PA',
  /**
   * Peru
   * @deprecated
   */
  Pe = 'PE',
  /**
   * French Polynesia
   * @deprecated
   */
  Pf = 'PF',
  /**
   * Papua New Guinea
   * @deprecated
   */
  Pg = 'PG',
  /**
   * Philippines
   * @deprecated
   */
  Ph = 'PH',
  /**
   * Pakistan
   * @deprecated
   */
  Pk = 'PK',
  /**
   * Poland
   * @deprecated
   */
  Pl = 'PL',
  /**
   * St. Pierre & Miquelon
   * @deprecated
   */
  Pm = 'PM',
  /**
   * Pitcairn Islands
   * @deprecated
   */
  Pn = 'PN',
  /**
   * Palestinian Territories
   * @deprecated
   */
  Ps = 'PS',
  /**
   * Portugal
   * @deprecated
   */
  Pt = 'PT',
  /**
   * Palau
   * @deprecated
   */
  Pw = 'PW',
  /**
   * Paraguay
   * @deprecated
   */
  Py = 'PY',
  /**
   * Qatar
   * @deprecated
   */
  Qa = 'QA',
  /**
   * Réunion
   * @deprecated
   */
  Re = 'RE',
  /**
   * Romania
   * @deprecated
   */
  Ro = 'RO',
  /**
   * Serbia
   * @deprecated
   */
  Rs = 'RS',
  /**
   * Russia
   * @deprecated
   */
  Ru = 'RU',
  /**
   * Rwanda
   * @deprecated
   */
  Rw = 'RW',
  /**
   * Saudi Arabia
   * @deprecated
   */
  Sa = 'SA',
  /**
   * Solomon Islands
   * @deprecated
   */
  Sb = 'SB',
  /**
   * Seychelles
   * @deprecated
   */
  Sc = 'SC',
  /**
   * Sudan
   * @deprecated
   */
  Sd = 'SD',
  /**
   * Sweden
   * @deprecated
   */
  Se = 'SE',
  /**
   * Singapore
   * @deprecated
   */
  Sg = 'SG',
  /**
   * St. Helena
   * @deprecated
   */
  Sh = 'SH',
  /**
   * Slovenia
   * @deprecated
   */
  Si = 'SI',
  /**
   * Svalbard & Jan Mayen
   * @deprecated
   */
  Sj = 'SJ',
  /**
   * Slovakia
   * @deprecated
   */
  Sk = 'SK',
  /**
   * Sierra Leone
   * @deprecated
   */
  Sl = 'SL',
  /**
   * San Marino
   * @deprecated
   */
  Sm = 'SM',
  /**
   * Senegal
   * @deprecated
   */
  Sn = 'SN',
  /**
   * Somalia
   * @deprecated
   */
  So = 'SO',
  /**
   * Suriname
   * @deprecated
   */
  Sr = 'SR',
  /**
   * São Tomé & Príncipe
   * @deprecated
   */
  St = 'ST',
  /**
   * El Salvador
   * @deprecated
   */
  Sv = 'SV',
  /**
   * Syria
   * @deprecated
   */
  Sy = 'SY',
  /**
   * Swaziland
   * @deprecated
   */
  Sz = 'SZ',
  /**
   * Turks & Caicos Islands
   * @deprecated
   */
  Tc = 'TC',
  /**
   * Chad
   * @deprecated
   */
  Td = 'TD',
  /**
   * French Southern Territories
   * @deprecated
   */
  Tf = 'TF',
  /**
   * Togo
   * @deprecated
   */
  Tg = 'TG',
  /**
   * Thailand
   * @deprecated
   */
  Th = 'TH',
  /**
   * Tajikistan
   * @deprecated
   */
  Tj = 'TJ',
  /**
   * Tokelau
   * @deprecated
   */
  Tk = 'TK',
  /**
   * Timor-Leste
   * @deprecated
   */
  Tl = 'TL',
  /**
   * Turkmenistan
   * @deprecated
   */
  Tm = 'TM',
  /**
   * Tunisia
   * @deprecated
   */
  Tn = 'TN',
  /**
   * Tonga
   * @deprecated
   */
  To = 'TO',
  /**
   * Turkey
   * @deprecated
   */
  Tr = 'TR',
  /**
   * Trinidad & Tobago
   * @deprecated
   */
  Tt = 'TT',
  /**
   * Tuvalu
   * @deprecated
   */
  Tv = 'TV',
  /**
   * Taiwan
   * @deprecated
   */
  Tw = 'TW',
  /**
   * Tanzania
   * @deprecated
   */
  Tz = 'TZ',
  /**
   * Ukraine
   * @deprecated
   */
  Ua = 'UA',
  /**
   * Uganda
   * @deprecated
   */
  Ug = 'UG',
  /**
   * U.S. Outlying Islands
   * @deprecated
   */
  Um = 'UM',
  /**
   * United States
   * @deprecated
   */
  Us = 'US',
  /**
   * Uruguay
   * @deprecated
   */
  Uy = 'UY',
  /**
   * Uzbekistan
   * @deprecated
   */
  Uz = 'UZ',
  /**
   * Vatican City
   * @deprecated
   */
  Va = 'VA',
  /**
   * St. Vincent & Grenadines
   * @deprecated
   */
  Vc = 'VC',
  /**
   * Venezuela
   * @deprecated
   */
  Ve = 'VE',
  /**
   * British Virgin Islands
   * @deprecated
   */
  Vg = 'VG',
  /**
   * U.S. Virgin Islands
   * @deprecated
   */
  Vi = 'VI',
  /**
   * Vietnam
   * @deprecated
   */
  Vn = 'VN',
  /**
   * Vanuatu
   * @deprecated
   */
  Vu = 'VU',
  /**
   * Wallis & Futuna
   * @deprecated
   */
  Wf = 'WF',
  /**
   * Samoa
   * @deprecated
   */
  Ws = 'WS',
  /**
   * Yemen
   * @deprecated
   */
  Ye = 'YE',
  /**
   * Mayotte
   * @deprecated
   */
  Yt = 'YT',
  /**
   * South Africa
   * @deprecated
   */
  Za = 'ZA',
  /**
   * Zambia
   * @deprecated
   */
  Zm = 'ZM',
  /**
   * Zimbabwe
   * @deprecated
   */
  Zw = 'ZW'
}

/** Contains the response to the request to create a company. */
export type CreateCompanyOutput = {
  __typename?: 'CreateCompanyOutput';
  /** The new company instance. */
  company: Company;
};

/** Contains the response to the request to create a company role. */
export type CreateCompanyRoleOutput = {
  __typename?: 'CreateCompanyRoleOutput';
  /** The new company role instance. */
  role: CompanyRole;
};

/** Contains the response to the request to create a company team. */
export type CreateCompanyTeamOutput = {
  __typename?: 'CreateCompanyTeamOutput';
  /** The new company team instance. */
  team: CompanyTeam;
};

/** Contains the response to the request to create a company user. */
export type CreateCompanyUserOutput = {
  __typename?: 'CreateCompanyUserOutput';
  /** The new company user instance. */
  user: Customer;
};

/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Defines a new gift registry. */
export type CreateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<GiftRegistryDynamicAttributeInput>>>;
  /** The name of the event. */
  event_name: Scalars['String'];
  /** The ID of the selected event type. */
  gift_registry_type_uid: Scalars['ID'];
  /** A message describing the event. */
  message: Scalars['String'];
  /** Indicates whether the registry is PRIVATE or PUBLIC. */
  privacy_settings: GiftRegistryPrivacySettings;
  /** The list of people who receive notifications about the registry. */
  registrants: Array<InputMaybe<AddGiftRegistryRegistrantInput>>;
  /** The shipping address for all gift registry items. */
  shipping_address?: InputMaybe<GiftRegistryShippingAddressInput>;
  /** Indicates whether the registry is ACTIVE or INACTIVE. */
  status: GiftRegistryStatus;
};

/** Contains the results of a request to create a gift registry. */
export type CreateGiftRegistryOutput = {
  __typename?: 'CreateGiftRegistryOutput';
  /** The newly-created gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
};

export type CreateKlarnaPaymentsSessionOutput = {
  __typename?: 'CreateKlarnaPaymentsSessionOutput';
  /** The payment method client token */
  client_token?: Maybe<Scalars['String']>;
  /** The payment method categories */
  payment_method_categories?: Maybe<Array<Maybe<Categories>>>;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  __typename?: 'CreatePayflowProTokenOutput';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String'];
};

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String'];
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>;
  /** The SKU of the reviewed product. */
  sku: Scalars['String'];
  /** The summary (title) of the review. */
  summary: Scalars['String'];
  /** The review text. */
  text: Scalars['String'];
};

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  __typename?: 'CreateProductReviewOutput';
  /** Product review details. */
  review: ProductReview;
};

/** Specifies the amount and currency to evaluate. */
export type CreatePurchaseOrderApprovalRuleConditionAmountInput = {
  /** Purchase order approval rule condition amount currency. */
  currency: CurrencyEnum;
  /** Purchase order approval rule condition amount value. */
  value: Scalars['Float'];
};

/** Defines a set of conditions that apply to a rule. */
export type CreatePurchaseOrderApprovalRuleConditionInput = {
  /** The amount to be compared in a purchase order approval rule. This field is mutually exclusive with condition quantity. */
  amount?: InputMaybe<CreatePurchaseOrderApprovalRuleConditionAmountInput>;
  /** The type of approval rule. */
  attribute: PurchaseOrderApprovalRuleType;
  /** Defines how to evaluate an amount or quantity in a purchase order. */
  operator: PurchaseOrderApprovalRuleConditionOperator;
  /** The quantity to be compared in a purchase order approval rule. This field is mutually exclusive with condition amount. */
  quantity?: InputMaybe<Scalars['Int']>;
};

/** An input object that identifies and describes a new requisition list. */
export type CreateRequisitionListInput = {
  /** An optional description of the requisition list. */
  description?: InputMaybe<Scalars['String']>;
  /** The name assigned to the requisition list. */
  name: Scalars['String'];
};

/** Output of the request to create a requisition list. */
export type CreateRequisitionListOutput = {
  __typename?: 'CreateRequisitionListOutput';
  /** The created requisition list. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Defines the name and visibility of a new wish list. */
export type CreateWishlistInput = {
  /** The name of the new wish list. */
  name: Scalars['String'];
  /** Indicates whether the wish list is public or private. */
  visibility: WishlistVisibilityEnum;
};

/** Contains the wish list. */
export type CreateWishlistOutput = {
  __typename?: 'CreateWishlistOutput';
  /** The newly-created wish list */
  wishlist: Wishlist;
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int'];
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int'];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int'];
  /** The credit card type. */
  cc_type: Scalars['String'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes. */
export enum CurrencyEnum {
  /** @deprecated  */
  Aed = 'AED',
  /** @deprecated  */
  Afn = 'AFN',
  /** @deprecated  */
  All = 'ALL',
  /** @deprecated  */
  Amd = 'AMD',
  /** @deprecated  */
  Ang = 'ANG',
  /** @deprecated  */
  Aoa = 'AOA',
  /** @deprecated  */
  Ars = 'ARS',
  /** @deprecated  */
  Aud = 'AUD',
  /** @deprecated  */
  Awg = 'AWG',
  /** @deprecated  */
  Azm = 'AZM',
  /** @deprecated  */
  Azn = 'AZN',
  /** @deprecated  */
  Bam = 'BAM',
  /** @deprecated  */
  Bbd = 'BBD',
  /** @deprecated  */
  Bdt = 'BDT',
  /** @deprecated  */
  Bgn = 'BGN',
  /** @deprecated  */
  Bhd = 'BHD',
  /** @deprecated  */
  Bif = 'BIF',
  /** @deprecated  */
  Bmd = 'BMD',
  /** @deprecated  */
  Bnd = 'BND',
  /** @deprecated  */
  Bob = 'BOB',
  /** @deprecated  */
  Brl = 'BRL',
  /** @deprecated  */
  Bsd = 'BSD',
  /** @deprecated  */
  Btn = 'BTN',
  /** @deprecated  */
  Buk = 'BUK',
  /** @deprecated  */
  Bwp = 'BWP',
  /** @deprecated  */
  Byn = 'BYN',
  /** @deprecated  */
  Bzd = 'BZD',
  /** @deprecated  */
  Cad = 'CAD',
  /** @deprecated  */
  Cdf = 'CDF',
  /** @deprecated  */
  Che = 'CHE',
  /** @deprecated  */
  Chf = 'CHF',
  /** @deprecated  */
  Chw = 'CHW',
  /** @deprecated  */
  Clp = 'CLP',
  /** @deprecated  */
  Cny = 'CNY',
  /** @deprecated  */
  Cop = 'COP',
  /** @deprecated  */
  Crc = 'CRC',
  /** @deprecated  */
  Cup = 'CUP',
  /** @deprecated  */
  Cve = 'CVE',
  /** @deprecated  */
  Czk = 'CZK',
  /** @deprecated  */
  Djf = 'DJF',
  /** @deprecated  */
  Dkk = 'DKK',
  /** @deprecated  */
  Dop = 'DOP',
  /** @deprecated  */
  Dzd = 'DZD',
  /** @deprecated  */
  Eek = 'EEK',
  /** @deprecated  */
  Egp = 'EGP',
  /** @deprecated  */
  Ern = 'ERN',
  /** @deprecated  */
  Etb = 'ETB',
  /** @deprecated  */
  Eur = 'EUR',
  /** @deprecated  */
  Fjd = 'FJD',
  /** @deprecated  */
  Fkp = 'FKP',
  /** @deprecated  */
  Gbp = 'GBP',
  /** @deprecated  */
  Gek = 'GEK',
  /** @deprecated  */
  Gel = 'GEL',
  /** @deprecated  */
  Ghs = 'GHS',
  /** @deprecated  */
  Gip = 'GIP',
  /** @deprecated  */
  Gmd = 'GMD',
  /** @deprecated  */
  Gnf = 'GNF',
  /** @deprecated  */
  Gqe = 'GQE',
  /** @deprecated  */
  Gtq = 'GTQ',
  /** @deprecated  */
  Gyd = 'GYD',
  /** @deprecated  */
  Hkd = 'HKD',
  /** @deprecated  */
  Hnl = 'HNL',
  /** @deprecated  */
  Hrk = 'HRK',
  /** @deprecated  */
  Htg = 'HTG',
  /** @deprecated  */
  Huf = 'HUF',
  /** @deprecated  */
  Idr = 'IDR',
  /** @deprecated  */
  Ils = 'ILS',
  /** @deprecated  */
  Inr = 'INR',
  /** @deprecated  */
  Iqd = 'IQD',
  /** @deprecated  */
  Irr = 'IRR',
  /** @deprecated  */
  Isk = 'ISK',
  /** @deprecated  */
  Jmd = 'JMD',
  /** @deprecated  */
  Jod = 'JOD',
  /** @deprecated  */
  Jpy = 'JPY',
  /** @deprecated  */
  Kes = 'KES',
  /** @deprecated  */
  Kgs = 'KGS',
  /** @deprecated  */
  Khr = 'KHR',
  /** @deprecated  */
  Kmf = 'KMF',
  /** @deprecated  */
  Kpw = 'KPW',
  /** @deprecated  */
  Krw = 'KRW',
  /** @deprecated  */
  Kwd = 'KWD',
  /** @deprecated  */
  Kyd = 'KYD',
  /** @deprecated  */
  Kzt = 'KZT',
  /** @deprecated  */
  Lak = 'LAK',
  /** @deprecated  */
  Lbp = 'LBP',
  /** @deprecated  */
  Lkr = 'LKR',
  /** @deprecated  */
  Lrd = 'LRD',
  /** @deprecated  */
  Lsl = 'LSL',
  /** @deprecated  */
  Lsm = 'LSM',
  /** @deprecated  */
  Ltl = 'LTL',
  /** @deprecated  */
  Lvl = 'LVL',
  /** @deprecated  */
  Lyd = 'LYD',
  /** @deprecated  */
  Mad = 'MAD',
  /** @deprecated  */
  Mdl = 'MDL',
  /** @deprecated  */
  Mga = 'MGA',
  /** @deprecated  */
  Mkd = 'MKD',
  /** @deprecated  */
  Mmk = 'MMK',
  /** @deprecated  */
  Mnt = 'MNT',
  /** @deprecated  */
  Mop = 'MOP',
  /** @deprecated  */
  Mro = 'MRO',
  /** @deprecated  */
  Mur = 'MUR',
  /** @deprecated  */
  Mvr = 'MVR',
  /** @deprecated  */
  Mwk = 'MWK',
  /** @deprecated  */
  Mxn = 'MXN',
  /** @deprecated  */
  Myr = 'MYR',
  /** @deprecated  */
  Mzn = 'MZN',
  /** @deprecated  */
  Nad = 'NAD',
  /** @deprecated  */
  Ngn = 'NGN',
  /** @deprecated  */
  Nic = 'NIC',
  /** @deprecated  */
  Nok = 'NOK',
  /** @deprecated  */
  Npr = 'NPR',
  /** @deprecated  */
  Nzd = 'NZD',
  /** @deprecated  */
  Omr = 'OMR',
  /** @deprecated  */
  Pab = 'PAB',
  /** @deprecated  */
  Pen = 'PEN',
  /** @deprecated  */
  Pgk = 'PGK',
  /** @deprecated  */
  Php = 'PHP',
  /** @deprecated  */
  Pkr = 'PKR',
  /** @deprecated  */
  Pln = 'PLN',
  /** @deprecated  */
  Pyg = 'PYG',
  /** @deprecated  */
  Qar = 'QAR',
  /** @deprecated  */
  Rhd = 'RHD',
  /** @deprecated  */
  Rol = 'ROL',
  /** @deprecated  */
  Ron = 'RON',
  /** @deprecated  */
  Rsd = 'RSD',
  /** @deprecated  */
  Rub = 'RUB',
  /** @deprecated  */
  Rwf = 'RWF',
  /** @deprecated  */
  Sar = 'SAR',
  /** @deprecated  */
  Sbd = 'SBD',
  /** @deprecated  */
  Scr = 'SCR',
  /** @deprecated  */
  Sdg = 'SDG',
  /** @deprecated  */
  Sek = 'SEK',
  /** @deprecated  */
  Sgd = 'SGD',
  /** @deprecated  */
  Shp = 'SHP',
  /** @deprecated  */
  Skk = 'SKK',
  /** @deprecated  */
  Sll = 'SLL',
  /** @deprecated  */
  Sos = 'SOS',
  /** @deprecated  */
  Srd = 'SRD',
  /** @deprecated  */
  Std = 'STD',
  /** @deprecated  */
  Svc = 'SVC',
  /** @deprecated  */
  Syp = 'SYP',
  /** @deprecated  */
  Szl = 'SZL',
  /** @deprecated  */
  Thb = 'THB',
  /** @deprecated  */
  Tjs = 'TJS',
  /** @deprecated  */
  Tmm = 'TMM',
  /** @deprecated  */
  Tnd = 'TND',
  /** @deprecated  */
  Top = 'TOP',
  /** @deprecated  */
  Trl = 'TRL',
  /** @deprecated  */
  Try = 'TRY',
  /** @deprecated  */
  Ttd = 'TTD',
  /** @deprecated  */
  Twd = 'TWD',
  /** @deprecated  */
  Tzs = 'TZS',
  /** @deprecated  */
  Uah = 'UAH',
  /** @deprecated  */
  Ugx = 'UGX',
  /** @deprecated  */
  Usd = 'USD',
  /** @deprecated  */
  Uyu = 'UYU',
  /** @deprecated  */
  Uzs = 'UZS',
  /** @deprecated  */
  Veb = 'VEB',
  /** @deprecated  */
  Vef = 'VEF',
  /** @deprecated  */
  Vnd = 'VND',
  /** @deprecated  */
  Vuv = 'VUV',
  /** @deprecated  */
  Wst = 'WST',
  /** @deprecated  */
  Xcd = 'XCD',
  /** @deprecated  */
  Xof = 'XOF',
  /** @deprecated  */
  Xpf = 'XPF',
  /** @deprecated  */
  Yer = 'YER',
  /** @deprecated  */
  Ytl = 'YTL',
  /** @deprecated  */
  Zar = 'ZAR',
  /** @deprecated  */
  Zmk = 'ZMK',
  /** @deprecated  */
  Zwd = 'ZWD'
}

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars['Boolean'];
  /** An object that contains a list of companies user is assigned to. */
  companies: UserCompaniesOutput;
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']>;
  /** Details about all of the customer's gift registries. */
  gift_registries?: Maybe<Array<Maybe<GiftRegistry>>>;
  /** Details about a specific gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** The job title of a company user. */
  job_title?: Maybe<Scalars['String']>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']>;
  orders?: Maybe<CustomerOrders>;
  ordersReversed?: Maybe<CustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** Purchase order details. */
  purchase_order?: Maybe<PurchaseOrder>;
  /** Details about a single purchase order approval rule. */
  purchase_order_approval_rule?: Maybe<PurchaseOrderApprovalRule>;
  /** Purchase order approval rule metadata that can be used for rule edit form rendering. */
  purchase_order_approval_rule_metadata?: Maybe<PurchaseOrderApprovalRuleMetadata>;
  /** A list of purchase order approval rules visible to the customer. */
  purchase_order_approval_rules?: Maybe<PurchaseOrderApprovalRules>;
  /** A list of purchase orders visible to the customer. */
  purchase_orders?: Maybe<PurchaseOrders>;
  /** Indicates whether purchase order functionality is enabled for the current customer. Global and company-level settings are factored into the result. */
  purchase_orders_enabled: Scalars['Boolean'];
  /** An object that contains the customer's requisition lists. */
  requisition_lists?: Maybe<RequisitionLists>;
  /** Details about the specified return request from the unique ID for a `Return` object. */
  return?: Maybe<Return>;
  /** Information about the customer's return requests. */
  returns?: Maybe<Returns>;
  /** Contains the customer's product reviews. */
  reviews: ProductReviews;
  /** Customer reward points details. */
  reward_points?: Maybe<RewardPoints>;
  /** The role name and permissions assigned to the company user. */
  role?: Maybe<CompanyRole>;
  /** Indicates whether the company user is ACTIVE or INACTIVE. */
  status?: Maybe<CompanyUserStatusEnum>;
  /** Store credit information applied for the logged in customer. */
  store_credit?: Maybe<CustomerStoreCredit>;
  /** ID of the company structure */
  structure_id: Scalars['ID'];
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']>;
  /** The team the company user is assigned to. */
  team?: Maybe<CompanyTeam>;
  /** The phone number of the company user. */
  telephone?: Maybe<Scalars['String']>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerCompaniesArgs = {
  input?: InputMaybe<UserCompaniesInput>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerGift_RegistryArgs = {
  giftRegistryUid: Scalars['ID'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersReversedArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerPurchase_OrderArgs = {
  uid: Scalars['ID'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerPurchase_Order_Approval_RuleArgs = {
  uid: Scalars['ID'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerPurchase_Order_Approval_RulesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerPurchase_OrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PurchaseOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerRequisition_ListsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RequisitionListFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerReturnArgs = {
  uid: Scalars['ID'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerReturnsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerWishlist_V2Args = {
  id: Scalars['ID'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']>;
  /** @deprecated Custom attributes should not be put into a container. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /** The valuue assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String'];
  /** The value assigned to the attribute. */
  value: Scalars['String'];
};

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']>;
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The address region code. */
  region_code?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']>;
};

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. */
  email: Scalars['String'];
  /** The customer's first name. */
  firstname: Scalars['String'];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname: Scalars['String'];
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct';
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']>;
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars['String']>;
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars['String']>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars['String']>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']>;
};

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts';
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  /** The entered gift message for the order */
  gift_message?: Maybe<GiftMessage>;
  /** Indicates whether the customer requested a gift receipt for the order. */
  gift_receipt_included: Scalars['Boolean'];
  /** The selected gift wrapping for the order. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** A list of order items eligible to be in a return request. */
  items_eligible_for_return?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String'];
  /** The date the order was placed. */
  order_date: Scalars['String'];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** Indicates whether the customer requested a printed card for the order. */
  printed_card_included: Scalars['Boolean'];
  /** Return requests associated with this order. */
  returns?: Maybe<Returns>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']>;
  /** The current status of the order. */
  status: Scalars['String'];
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};


/** Contains details about each of the customer's orders. */
export type CustomerOrderReturnsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum CustomerOrderSortableField {
  /**
   * Sorts customer orders by created_at field
   * @deprecated
   */
  CreatedAt = 'CREATED_AT',
  /**
   * Sorts customer orders by number
   * @deprecated
   */
  Number = 'NUMBER'
}

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  /** Customer details after creating or updating a customer. */
  customer: Customer;
};

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>;
};

/** Contains store credit information with balance and history. */
export type CustomerStoreCredit = {
  __typename?: 'CustomerStoreCredit';
  /** Contains the customer's store credit balance history. If the history or store credit feature is disabled, then a null value will be returned. */
  balance_history?: Maybe<CustomerStoreCreditHistory>;
  /** The current balance of store credit. */
  current_balance?: Maybe<Money>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the balance will not be returned. */
  enabled?: Maybe<Scalars['Boolean']>;
};


/** Contains store credit information with balance and history. */
export type CustomerStoreCreditBalance_HistoryArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Lists changes to the amount of store credit available to the customer. */
export type CustomerStoreCreditHistory = {
  __typename?: 'CustomerStoreCreditHistory';
  /** An array containing information about changes to the store credit available to the customer. */
  items?: Maybe<Array<Maybe<CustomerStoreCreditHistoryItem>>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of items returned. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains store credit history information. */
export type CustomerStoreCreditHistoryItem = {
  __typename?: 'CustomerStoreCreditHistoryItem';
  /** The action that was made on the store credit. */
  action?: Maybe<Scalars['String']>;
  /** The store credit available to the customer as a result of this action.  */
  actual_balance?: Maybe<Money>;
  /** The amount added to or subtracted from the store credit as a result of this action. */
  balance_change?: Maybe<Money>;
  /** The date and time when the store credit change was made. */
  date_time_changed?: Maybe<Scalars['String']>;
};

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']>;
};

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>;
};

/** Defines the customizable date type. */
export enum CustomizableDateTypeEnum {
  /** @deprecated  */
  Date = 'DATE',
  /** @deprecated  */
  DateTime = 'DATE_TIME',
  /** @deprecated  */
  Time = 'TIME'
}

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue';
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue';
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID'];
};

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']>;
  /** The string value of the option. */
  value_string: Scalars['String'];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
};

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID'];
};

/** Contains the response to the request to delete the company role. */
export type DeleteCompanyRoleOutput = {
  __typename?: 'DeleteCompanyRoleOutput';
  /** SIndicates whether the company role has been deleted successfully. */
  success: Scalars['Boolean'];
};

/** Contains the status of the request to delete a company team. */
export type DeleteCompanyTeamOutput = {
  __typename?: 'DeleteCompanyTeamOutput';
  /** Indicates whether the delete operation succeeded. */
  success: Scalars['Boolean'];
};

/** Contains the response to the request to delete the company user. */
export type DeleteCompanyUserOutput = {
  __typename?: 'DeleteCompanyUserOutput';
  /** Indicates whether the company user has been deactivated successfully. */
  success: Scalars['Boolean'];
};

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  __typename?: 'DeleteCompareListOutput';
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean'];
};

export type DeleteNegotiableQuoteError = InternalError | NegotiableQuoteInvalidStateError | NoSuchEntityUidError;

/** Contains details about a failed delete operation on a negotiable quote. */
export type DeleteNegotiableQuoteOperationFailure = {
  __typename?: 'DeleteNegotiableQuoteOperationFailure';
  errors: Array<Maybe<DeleteNegotiableQuoteError>>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

export type DeleteNegotiableQuoteOperationResult = DeleteNegotiableQuoteOperationFailure | NegotiableQuoteUidOperationSuccess;

/** Specifies the quote template id of the quote template to delete */
export type DeleteNegotiableQuoteTemplateInput = {
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains details about a failed delete operation on a negotiable quote template. */
export type DeleteNegotiableQuoteTemplateOutput = {
  __typename?: 'DeleteNegotiableQuoteTemplateOutput';
  /** A message that describes the error. */
  error_message?: Maybe<Scalars['String']>;
  /** Flag to mark whether the delete operation was successful. */
  status: Scalars['Boolean'];
};

export type DeleteNegotiableQuotesInput = {
  /** A list of unique IDs for `NegotiableQuote` objects to delete. */
  quote_uids: Array<InputMaybe<Scalars['ID']>>;
};

/** Contains a list of undeleted negotiable quotes the company user can view. */
export type DeleteNegotiableQuotesOutput = {
  __typename?: 'DeleteNegotiableQuotesOutput';
  /** A list of negotiable quotes that the customer can view */
  negotiable_quotes?: Maybe<NegotiableQuotesOutput>;
  /** An array of deleted negotiable quote UIDs and details about any errors. */
  operation_results: Array<Maybe<DeleteNegotiableQuoteOperationResult>>;
  /** The status of the request to delete one or more negotiable quotes. */
  result_status: BatchMutationStatus;
};


/** Contains a list of undeleted negotiable quotes the company user can view. */
export type DeleteNegotiableQuotesOutputNegotiable_QuotesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NegotiableQuoteFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<NegotiableQuoteSortInput>;
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean'];
};

/** Contains details about an error that occurred when deleting an approval rule . */
export type DeletePurchaseOrderApprovalRuleError = {
  __typename?: 'DeletePurchaseOrderApprovalRuleError';
  /** The text of the error message. */
  message?: Maybe<Scalars['String']>;
  /** The error type. */
  type?: Maybe<DeletePurchaseOrderApprovalRuleErrorType>;
};

export enum DeletePurchaseOrderApprovalRuleErrorType {
  /** @deprecated  */
  NotFound = 'NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Specifies the IDs of the approval rules to delete. */
export type DeletePurchaseOrderApprovalRuleInput = {
  /** An array of purchase order approval rule IDs. */
  approval_rule_uids: Array<InputMaybe<Scalars['ID']>>;
};

/** Contains any errors encountered while attempting to delete approval rules. */
export type DeletePurchaseOrderApprovalRuleOutput = {
  __typename?: 'DeletePurchaseOrderApprovalRuleOutput';
  /** An array of error messages encountered while performing the operation. */
  errors: Array<Maybe<DeletePurchaseOrderApprovalRuleError>>;
};

/** Output of the request to remove items from the requisition list. */
export type DeleteRequisitionListItemsOutput = {
  __typename?: 'DeleteRequisitionListItemsOutput';
  /** The requisition list after removing items. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Indicates whether the request to delete the requisition list was successful. */
export type DeleteRequisitionListOutput = {
  __typename?: 'DeleteRequisitionListOutput';
  /** The customer's requisition lists after deleting a requisition list. */
  requisition_lists?: Maybe<RequisitionLists>;
  /** Indicates whether the request to delete the requisition list was successful. */
  status: Scalars['Boolean'];
};

/** Contains the status of the request to delete a wish list and an array of the customer's remaining wish lists. */
export type DeleteWishlistOutput = {
  __typename?: 'DeleteWishlistOutput';
  /** Indicates whether the wish list was deleted. */
  status: Scalars['Boolean'];
  /** A list of undeleted wish lists. */
  wishlists: Array<Maybe<Wishlist>>;
};

/** Specifies the discount type and value for quote line item. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount. */
  amount: Money;
  /** Is quote discounting locked for line item. */
  is_discounting_locked?: Maybe<Scalars['Boolean']>;
  /** A description of the discount. */
  label: Scalars['String'];
  /** Quote line item discount type. Values: 1 = PERCENTAGE_DISCOUNT; 2 = AMOUNT_DISCOUNT; 3 = PROPOSED_TOTAL. */
  type?: Maybe<Scalars['String']>;
  /** Quote line item discount value. */
  value?: Maybe<Scalars['Float']>;
};

/** An implementation for downloadable product cart items. */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem';
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'DownloadableCreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = 'URL'
}

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  __typename?: 'DownloadableInvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  __typename?: 'DownloadableItemsLinks';
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID'];
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  __typename?: 'DownloadableOrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars['Boolean']>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'DownloadableProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** An array containing information about the links for this downloadable product. */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /** A value of 1 indicates that each link in the array must be purchased separately. */
  links_purchased_separately?: Maybe<Scalars['Int']>;
  /** The heading above the list of downloadable products. */
  links_title?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars['Boolean']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars['Int']>;
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID'];
};

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int'];
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']>;
};

/** Contains details about downloadable products added to a requisition list. */
export type DownloadableRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'DownloadableRequisitionListItem';
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of links for downloadable products in the requisition list. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The quantity of the product added to the requisition list. */
  quantity: Scalars['Float'];
  /** An array of links to downloadable product samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** The unique ID of an item in a requisition list. */
  uid: Scalars['ID'];
};

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  __typename?: 'DownloadableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

/** Identifies a quote to be duplicated */
export type DuplicateNegotiableQuoteInput = {
  /** ID for the newly duplicated quote. */
  duplicated_quote_uid: Scalars['ID'];
  /** ID of the quote to be duplicated. */
  quote_uid: Scalars['ID'];
};

/** Contains the newly created negotiable quote. */
export type DuplicateNegotiableQuoteOutput = {
  __typename?: 'DuplicateNegotiableQuoteOutput';
  /** Negotiable Quote resulting from duplication operation. */
  quote?: Maybe<NegotiableQuote>;
};

/** Contains a single dynamic block. */
export type DynamicBlock = {
  __typename?: 'DynamicBlock';
  /** The renderable HTML code of the dynamic block. */
  content: ComplexTextValue;
  /** The unique ID of a `DynamicBlock` object. */
  uid: Scalars['ID'];
};

/** Indicates the locations the dynamic block can be placed. If this field is not specified, the query returns all locations. */
export enum DynamicBlockLocationEnum {
  /** @deprecated  */
  Content = 'CONTENT',
  /** @deprecated  */
  Footer = 'FOOTER',
  /** @deprecated  */
  Header = 'HEADER',
  /** @deprecated  */
  Left = 'LEFT',
  /** @deprecated  */
  Right = 'RIGHT'
}

/** Indicates the selected Dynamic Blocks Rotator inline widget. */
export enum DynamicBlockTypeEnum {
  /** @deprecated  */
  CartPriceRuleRelated = 'CART_PRICE_RULE_RELATED',
  /** @deprecated  */
  CatalogPriceRuleRelated = 'CATALOG_PRICE_RULE_RELATED',
  /** @deprecated  */
  Specified = 'SPECIFIED'
}

/** Contains an array of dynamic blocks. */
export type DynamicBlocks = {
  __typename?: 'DynamicBlocks';
  /** An array containing individual dynamic blocks. */
  items: Array<Maybe<DynamicBlock>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of returned dynamic blocks. */
  total_count: Scalars['Int'];
};

/** Defines the dynamic block filter. The filter can identify the block type, location and IDs to return. */
export type DynamicBlocksFilterInput = {
  /** An array of dynamic block UIDs to filter on. */
  dynamic_block_uids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** An array indicating the locations the dynamic block can be placed. */
  locations?: InputMaybe<Array<InputMaybe<DynamicBlockLocationEnum>>>;
  /** A value indicating the type of dynamic block to filter on. */
  type: DynamicBlockTypeEnum;
};

/** Contains details about a custom text attribute that the buyer entered. */
export type EnteredCustomAttributeInput = {
  /** A string that identifies the entered custom attribute. */
  attribute_code: Scalars['String'];
  /** The text or other entered value. */
  value: Scalars['String'];
};

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID'];
  /** Text the customer entered. */
  value: Scalars['String'];
};

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String'];
};

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']>;
};

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['String']>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']>;
  /** Is null. */
  null?: InputMaybe<Scalars['String']>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']>;
};

/** Lists display settings for the Fixed Product Tax. */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'.
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query.
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'.
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'.
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars['String'];
};

/** Contains the generated customer token. */
export type GenerateCustomerTokenAsAdminOutput = {
  __typename?: 'GenerateCustomerTokenAsAdminOutput';
  /** The generated customer token. */
  customer_token: Scalars['String'];
};

/** Specifies the template id, from which to generate quote from. */
export type GenerateNegotiableQuoteFromTemplateInput = {
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains the generated negotiable quote id. */
export type GenerateNegotiableQuoteFromTemplateOutput = {
  __typename?: 'GenerateNegotiableQuoteFromTemplateOutput';
  /** The unique ID of a generated `NegotiableQuote` object. */
  negotiable_quote_uid: Scalars['ID'];
};

/** Contains details about the gift card account. */
export type GiftCardAccount = {
  __typename?: 'GiftCardAccount';
  /** The balance remaining on the gift card. */
  balance?: Maybe<Money>;
  /** The gift card account code. */
  code?: Maybe<Scalars['String']>;
  /** The expiration date of the gift card. */
  expiration_date?: Maybe<Scalars['String']>;
};

/** Contains the gift card code. */
export type GiftCardAccountInput = {
  /** The applied gift card code. */
  gift_card_code: Scalars['String'];
};

/** Contains the value of a gift card, the website that generated the card, and related information. */
export type GiftCardAmounts = {
  __typename?: 'GiftCardAmounts';
  /** An internal attribute ID. */
  attribute_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `GiftCardAmounts` object. */
  uid: Scalars['ID'];
  /** The value of the gift card. */
  value?: Maybe<Scalars['Float']>;
  /**
   * An ID that is assigned to each unique gift card amount.
   * @deprecated Use `uid` instead
   */
  value_id?: Maybe<Scalars['Int']>;
  /** The ID of the website that generated the gift card. */
  website_id?: Maybe<Scalars['Int']>;
  /** The value of the gift card. */
  website_value?: Maybe<Scalars['Float']>;
};

/** Contains details about a gift card that has been added to a cart. */
export type GiftCardCartItem = CartItemInterface & {
  __typename?: 'GiftCardCartItem';
  /** The amount and currency of the gift card. */
  amount: Money;
  /** An array of customizations applied to the gift card. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** The message from the sender to the recipient. */
  message?: Maybe<Scalars['String']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The email address of the person receiving the gift card. */
  recipient_email?: Maybe<Scalars['String']>;
  /** The name of the person receiving the gift card. */
  recipient_name: Scalars['String'];
  /** The email address of the sender. */
  sender_email?: Maybe<Scalars['String']>;
  /** The name of the sender. */
  sender_name: Scalars['String'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

export type GiftCardCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'GiftCardCreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Selected gift card properties for a credit memo item. */
  gift_card?: Maybe<GiftCardItem>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

export type GiftCardInvoiceItem = InvoiceItemInterface & {
  __typename?: 'GiftCardInvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Selected gift card properties for an invoice item. */
  gift_card?: Maybe<GiftCardItem>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains details about a gift card. */
export type GiftCardItem = {
  __typename?: 'GiftCardItem';
  /** The message from the sender to the recipient. */
  message?: Maybe<Scalars['String']>;
  /** The email address of the receiver of a virtual gift card. */
  recipient_email?: Maybe<Scalars['String']>;
  /** The name of the receiver of a physical or virtual gift card. */
  recipient_name?: Maybe<Scalars['String']>;
  /** The email address of the sender of a virtual gift card. */
  sender_email?: Maybe<Scalars['String']>;
  /** The name of the sender of a physical or virtual gift card. */
  sender_name?: Maybe<Scalars['String']>;
};

/** Contains details about the sender, recipient, and amount of a gift card. */
export type GiftCardOptions = {
  __typename?: 'GiftCardOptions';
  /** The amount and currency of the gift card. */
  amount?: Maybe<Money>;
  /** The custom amount and currency of the gift card. */
  custom_giftcard_amount?: Maybe<Money>;
  /** A message to the recipient. */
  message?: Maybe<Scalars['String']>;
  /** The email address of the person receiving the gift card. */
  recipient_email?: Maybe<Scalars['String']>;
  /** The name of the person receiving the gift card. */
  recipient_name?: Maybe<Scalars['String']>;
  /** The email address of the person sending the gift card. */
  sender_email?: Maybe<Scalars['String']>;
  /** The name of the person sending the gift card. */
  sender_name?: Maybe<Scalars['String']>;
};

export type GiftCardOrderItem = OrderItemInterface & {
  __typename?: 'GiftCardOrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars['Boolean']>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** Selected gift card properties for an order item. */
  gift_card?: Maybe<GiftCardItem>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines properties of a gift card. */
export type GiftCardProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'GiftCardProduct';
  /** Indicates whether the customer can provide a message to accompany the gift card. */
  allow_message?: Maybe<Scalars['Boolean']>;
  /** Indicates whether shoppers have the ability to set the value of the gift card. */
  allow_open_amount?: Maybe<Scalars['Boolean']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** An array of customizable gift card options. */
  gift_card_options: Array<Maybe<CustomizableOptionInterface>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /** An array that contains information about the values and ID of a gift card. */
  giftcard_amounts?: Maybe<Array<Maybe<GiftCardAmounts>>>;
  /** An enumeration that specifies the type of gift card. */
  giftcard_type?: Maybe<GiftCardTypeEnum>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the customer can redeem the value on the card for cash. */
  is_redeemable?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /** The number of days after purchase until the gift card expires. A null value means there is no limit. */
  lifetime?: Maybe<Scalars['Int']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** The maximum number of characters the gift message can contain. */
  message_max_length?: Maybe<Scalars['Int']>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** The maximum acceptable value of an open amount gift card. */
  open_amount_max?: Maybe<Scalars['Float']>;
  /** The minimum acceptable value of an open amount gift card. */
  open_amount_min?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};


/** Defines properties of a gift card. */
export type GiftCardProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains details about gift cards added to a requisition list. */
export type GiftCardRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'GiftCardRequisitionListItem';
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array that defines gift card properties. */
  gift_card_options: GiftCardOptions;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The amount added. */
  quantity: Scalars['Float'];
  /** The unique ID for the requisition list item. */
  uid: Scalars['ID'];
};

export type GiftCardShipmentItem = ShipmentItemInterface & {
  __typename?: 'GiftCardShipmentItem';
  /** Selected gift card properties for a shipment item. */
  gift_card?: Maybe<GiftCardItem>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Specifies the gift card type. */
export enum GiftCardTypeEnum {
  /** @deprecated  */
  Combined = 'COMBINED',
  /** @deprecated  */
  Physical = 'PHYSICAL',
  /** @deprecated  */
  Virtual = 'VIRTUAL'
}

/** A single gift card added to a wish list. */
export type GiftCardWishlistItem = WishlistItemInterface & {
  __typename?: 'GiftCardWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** Details about a gift card. */
  gift_card_options: GiftCardOptions;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  __typename?: 'GiftMessage';
  /** Sender name */
  from: Scalars['String'];
  /** Gift message text */
  message: Scalars['String'];
  /** Recipient name */
  to: Scalars['String'];
};

/** Defines a gift message. */
export type GiftMessageInput = {
  /** The name of the sender. */
  from: Scalars['String'];
  /** The text of the gift message. */
  message: Scalars['String'];
  /** The name of the recepient. */
  to: Scalars['String'];
};

/** Contains prices for gift wrapping options. */
export type GiftOptionsPrices = {
  __typename?: 'GiftOptionsPrices';
  /** Price of the gift wrapping for all individual order items. */
  gift_wrapping_for_items?: Maybe<Money>;
  /** Price of the gift wrapping for the whole order. */
  gift_wrapping_for_order?: Maybe<Money>;
  /** Price for the printed card. */
  printed_card?: Maybe<Money>;
};

/** Contains details about a gift registry. */
export type GiftRegistry = {
  __typename?: 'GiftRegistry';
  /** The date on which the gift registry was created. Only the registry owner can access this attribute. */
  created_at: Scalars['String'];
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes?: Maybe<Array<Maybe<GiftRegistryDynamicAttribute>>>;
  /** The name of the event. */
  event_name: Scalars['String'];
  /** An array of products added to the gift registry. */
  items?: Maybe<Array<Maybe<GiftRegistryItemInterface>>>;
  /** The message text the customer entered to describe the event. */
  message: Scalars['String'];
  /** The customer who created the gift registry. */
  owner_name: Scalars['String'];
  /** An enum that states whether the gift registry is PRIVATE or PUBLIC. Only the registry owner can access this attribute. */
  privacy_settings: GiftRegistryPrivacySettings;
  /** Contains details about each registrant for the event. */
  registrants?: Maybe<Array<Maybe<GiftRegistryRegistrant>>>;
  /** Contains the customer's shipping address. Only the registry owner can access this attribute. */
  shipping_address?: Maybe<CustomerAddress>;
  /** An enum that states whether the gift registry is ACTIVE or INACTIVE. Only the registry owner can access this attribute. */
  status: GiftRegistryStatus;
  /** The type of gift registry. */
  type?: Maybe<GiftRegistryType>;
  /** The unique ID assigned to the gift registry. */
  uid: Scalars['ID'];
};

export type GiftRegistryDynamicAttribute = GiftRegistryDynamicAttributeInterface & {
  __typename?: 'GiftRegistryDynamicAttribute';
  /** The internal ID of the dynamic attribute. */
  code: Scalars['ID'];
  /** Indicates which group the dynamic attribute is a member of. */
  group: GiftRegistryDynamicAttributeGroup;
  /** The display name of the dynamic attribute. */
  label: Scalars['String'];
  /** A corresponding value for the code. */
  value: Scalars['String'];
};

/** Defines the group type of a gift registry dynamic attribute. */
export enum GiftRegistryDynamicAttributeGroup {
  /** @deprecated  */
  DetailedInformation = 'DETAILED_INFORMATION',
  /** @deprecated  */
  EventInformation = 'EVENT_INFORMATION',
  /** @deprecated  */
  GeneralInformation = 'GENERAL_INFORMATION',
  /** @deprecated  */
  PrivacySettings = 'PRIVACY_SETTINGS',
  /** @deprecated  */
  Registrant = 'REGISTRANT',
  /** @deprecated  */
  ShippingAddress = 'SHIPPING_ADDRESS'
}

/** Defines a dynamic attribute. */
export type GiftRegistryDynamicAttributeInput = {
  /** A unique key for an additional attribute of the event. */
  code: Scalars['ID'];
  /** A string that describes a dynamic attribute. */
  value: Scalars['String'];
};

export type GiftRegistryDynamicAttributeInterface = {
  /** The internal ID of the dynamic attribute. */
  code: Scalars['ID'];
  /** The display name of the dynamic attribute. */
  label: Scalars['String'];
  /** A corresponding value for the code. */
  value: Scalars['String'];
};

export type GiftRegistryDynamicAttributeMetadata = GiftRegistryDynamicAttributeMetadataInterface & {
  __typename?: 'GiftRegistryDynamicAttributeMetadata';
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars['String'];
  /** The internal ID of the dynamic attribute. */
  code: Scalars['ID'];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars['String'];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars['Boolean'];
  /** The display name of the dynamic attribute. */
  label: Scalars['String'];
  /** The order in which to display the dynamic attribute. */
  sort_order?: Maybe<Scalars['Int']>;
};

export type GiftRegistryDynamicAttributeMetadataInterface = {
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars['String'];
  /** The internal ID of the dynamic attribute. */
  code: Scalars['ID'];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars['String'];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars['Boolean'];
  /** The display name of the dynamic attribute. */
  label: Scalars['String'];
  /** The order in which to display the dynamic attribute. */
  sort_order?: Maybe<Scalars['Int']>;
};

export type GiftRegistryItem = GiftRegistryItemInterface & {
  __typename?: 'GiftRegistryItem';
  /** The date the product was added to the gift registry. */
  created_at: Scalars['String'];
  /** A brief message about the gift registry item. */
  note?: Maybe<Scalars['String']>;
  /** Details about the gift registry item. */
  product?: Maybe<ProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars['Float'];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars['Float'];
  /** The unique ID of a gift registry item. */
  uid: Scalars['ID'];
};

export type GiftRegistryItemInterface = {
  /** The date the product was added to the gift registry. */
  created_at: Scalars['String'];
  /** A brief message about the gift registry item. */
  note?: Maybe<Scalars['String']>;
  /** Details about the gift registry item. */
  product?: Maybe<ProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars['Float'];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars['Float'];
  /** The unique ID of a gift registry item. */
  uid: Scalars['ID'];
};

/** Contains the status and any errors that encountered with the customer's gift register item. */
export type GiftRegistryItemUserErrorInterface = {
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars['Boolean'];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<GiftRegistryItemsUserError>>;
};

/** Contains error information. */
export type GiftRegistryItemUserErrors = GiftRegistryItemUserErrorInterface & {
  __typename?: 'GiftRegistryItemUserErrors';
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars['Boolean'];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<GiftRegistryItemsUserError>>;
};

/** Contains details about an error that occurred when processing a gift registry item. */
export type GiftRegistryItemsUserError = {
  __typename?: 'GiftRegistryItemsUserError';
  /** An error code that describes the error encountered. */
  code: GiftRegistryItemsUserErrorType;
  /** The unique ID of the gift registry item containing an error. */
  gift_registry_item_uid?: Maybe<Scalars['ID']>;
  /** The unique ID of the `GiftRegistry` object containing an error. */
  gift_registry_uid?: Maybe<Scalars['ID']>;
  /** A localized error message. */
  message: Scalars['String'];
  /** The unique ID of the product containing an error. */
  product_uid?: Maybe<Scalars['ID']>;
};

/** Defines the error type. */
export enum GiftRegistryItemsUserErrorType {
  /**
   * Used for exceptions like EntityNotFound.
   * @deprecated
   */
  NotFound = 'NOT_FOUND',
  /**
   * Used for handling out of stock products.
   * @deprecated
   */
  OutOfStock = 'OUT_OF_STOCK',
  /**
   * Used for other exceptions, such as database connection failures.
   * @deprecated
   */
  Undefined = 'UNDEFINED'
}

/** Contains details about the gift registry. */
export type GiftRegistryOutput = GiftRegistryOutputInterface & {
  __typename?: 'GiftRegistryOutput';
  /** The gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Contains the customer's gift registry. */
export type GiftRegistryOutputInterface = {
  /** The gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Defines the privacy setting of the gift registry. */
export enum GiftRegistryPrivacySettings {
  /** @deprecated  */
  Private = 'PRIVATE',
  /** @deprecated  */
  Public = 'PUBLIC'
}

/** Contains details about a registrant. */
export type GiftRegistryRegistrant = {
  __typename?: 'GiftRegistryRegistrant';
  /** An array of dynamic attributes assigned to the registrant. */
  dynamic_attributes?: Maybe<Array<Maybe<GiftRegistryRegistrantDynamicAttribute>>>;
  /** The email address of the registrant. Only the registry owner can access this attribute. */
  email: Scalars['String'];
  /** The first name of the registrant. */
  firstname: Scalars['String'];
  /** The last name of the registrant. */
  lastname: Scalars['String'];
  /** The unique ID assigned to the registrant. */
  uid: Scalars['ID'];
};

export type GiftRegistryRegistrantDynamicAttribute = GiftRegistryDynamicAttributeInterface & {
  __typename?: 'GiftRegistryRegistrantDynamicAttribute';
  /** The internal ID of the dynamic attribute. */
  code: Scalars['ID'];
  /** The display name of the dynamic attribute. */
  label: Scalars['String'];
  /** A corresponding value for the code. */
  value: Scalars['String'];
};

/** Contains the results of a gift registry search. */
export type GiftRegistrySearchResult = {
  __typename?: 'GiftRegistrySearchResult';
  /** The date of the event. */
  event_date?: Maybe<Scalars['String']>;
  /** The title given to the event. */
  event_title: Scalars['String'];
  /** The URL key of the gift registry. */
  gift_registry_uid: Scalars['ID'];
  /** The location of the event. */
  location?: Maybe<Scalars['String']>;
  /** The name of the gift registry owner. */
  name: Scalars['String'];
  /** The type of event being held. */
  type?: Maybe<Scalars['String']>;
};

/** Defines a shipping address for a gift registry. Specify either `address_data` or the `address_id`. If both are provided, validation will fail. */
export type GiftRegistryShippingAddressInput = {
  /** Defines the shipping address for this gift registry. */
  address_data?: InputMaybe<CustomerAddressInput>;
  /** The ID assigned to this customer address. */
  address_id?: InputMaybe<Scalars['ID']>;
};

/** Defines the status of the gift registry. */
export enum GiftRegistryStatus {
  /** @deprecated  */
  Active = 'ACTIVE',
  /** @deprecated  */
  Inactive = 'INACTIVE'
}

/** Contains details about a gift registry type. */
export type GiftRegistryType = {
  __typename?: 'GiftRegistryType';
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes_metadata?: Maybe<Array<Maybe<GiftRegistryDynamicAttributeMetadataInterface>>>;
  /** The label assigned to the gift registry type on the Admin. */
  label: Scalars['String'];
  /** The unique ID assigned to the gift registry type. */
  uid: Scalars['ID'];
};

/** Contains details about the selected or available gift wrapping options. */
export type GiftWrapping = {
  __typename?: 'GiftWrapping';
  /** The name of the gift wrapping design. */
  design: Scalars['String'];
  /**
   * The unique ID for a `GiftWrapping` object.
   * @deprecated Use `uid` instead
   */
  id: Scalars['ID'];
  /** The preview image for a gift wrapping option. */
  image?: Maybe<GiftWrappingImage>;
  /** The gift wrapping price. */
  price: Money;
  /** The unique ID for a `GiftWrapping` object. */
  uid: Scalars['ID'];
};

/** Points to an image associated with a gift wrapping option. */
export type GiftWrappingImage = {
  __typename?: 'GiftWrappingImage';
  /** The gift wrapping preview image label. */
  label: Scalars['String'];
  /** The gift wrapping preview image URL. */
  url: Scalars['String'];
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'GroupedProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** An array containing grouped product items. */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem';
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']>;
  /** Details about this product option. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']>;
};

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  __typename?: 'GroupedProductWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  __typename?: 'HostedProUrl';
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars['String']>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
};

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** A parameter name. */
  name?: Maybe<Scalars['String']>;
  /** A parameter value. */
  value?: Maybe<Scalars['String']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError';
  /** The returned error message. */
  message: Scalars['String'];
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

/** Contains the response of a company admin email validation query. */
export type IsCompanyAdminEmailAvailableOutput = {
  __typename?: 'IsCompanyAdminEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a company administrator. */
  is_email_available: Scalars['Boolean'];
};

/** Contains the response of a company email validation query. */
export type IsCompanyEmailAvailableOutput = {
  __typename?: 'IsCompanyEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a company. */
  is_email_available: Scalars['Boolean'];
};

/** Contains the response of a role name validation query. */
export type IsCompanyRoleNameAvailableOutput = {
  __typename?: 'IsCompanyRoleNameAvailableOutput';
  /** Indicates whether the specified company role name is available. */
  is_role_name_available: Scalars['Boolean'];
};

/** Contains the response of a company user email validation query. */
export type IsCompanyUserEmailAvailableOutput = {
  __typename?: 'IsCompanyUserEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a company user. */
  is_email_available: Scalars['Boolean'];
};

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']>;
};

/** The note object for quote line item. */
export type ItemNote = {
  __typename?: 'ItemNote';
  /** Timestamp that reflects note creation date. */
  created_at?: Maybe<Scalars['String']>;
  /** ID of the user who submitted a note. */
  creator_id?: Maybe<Scalars['Int']>;
  /** Type of teh user who submitted a note. */
  creator_type?: Maybe<Scalars['Int']>;
  /** The unique ID of a `CartItemInterface` object. */
  negotiable_quote_item_uid?: Maybe<Scalars['ID']>;
  /** Note text. */
  note?: Maybe<Scalars['String']>;
  /** The unique ID of a `ItemNote` object. */
  note_uid?: Maybe<Scalars['ID']>;
};

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption';
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The label of the option. */
  label: Scalars['String'];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID'];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue';
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The price of the child bundle product. */
  price: Money;
  /** The name of the child bundle product. */
  product_name: Scalars['String'];
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String'];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float'];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID'];
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']>;
};

export type KlarnaInput = {
  /** The authorization token must be provided to set any Klarna Payments method */
  authorization_token: Scalars['String'];
};

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']>;
};

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

/** Sets quote item note. */
export type LineItemNoteInput = {
  /** The note text to be added. */
  note?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `CartLineItem` object. */
  quote_item_uid: Scalars['ID'];
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID'];
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']>;
};

/** Contains the customer's gift registry and any errors encountered. */
export type MoveCartItemsToGiftRegistryOutput = GiftRegistryItemUserErrorInterface & GiftRegistryOutputInterface & {
  __typename?: 'MoveCartItemsToGiftRegistryOutput';
  /** The gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars['Boolean'];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<GiftRegistryItemsUserError>>;
};

/** An input object that defines the items in a requisition list to be moved. */
export type MoveItemsBetweenRequisitionListsInput = {
  /** An array of IDs representing products moved from one requisition list to another. */
  requisitionListItemUids: Array<InputMaybe<Scalars['ID']>>;
};

/** Output of the request to move items to another requisition list. */
export type MoveItemsBetweenRequisitionListsOutput = {
  __typename?: 'MoveItemsBetweenRequisitionListsOutput';
  /** The destination requisition list after moving items. */
  destination_requisition_list?: Maybe<RequisitionList>;
  /** The source requisition list after moving items. */
  source_requisition_list?: Maybe<RequisitionList>;
};

/** Move Line Item to Requisition List. */
export type MoveLineItemToRequisitionListInput = {
  /** The unique ID of a `CartLineItem` object. */
  quote_item_uid: Scalars['ID'];
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
  /** The unique ID of a requisition list. */
  requisition_list_uid: Scalars['ID'];
};

/** Contains the updated negotiable quote. */
export type MoveLineItemToRequisitionListOutput = {
  __typename?: 'MoveLineItemToRequisitionListOutput';
  /** The negotiable quote after moving item to requisition list. */
  quote?: Maybe<NegotiableQuote>;
};

/** Contains the source and target wish lists after moving products. */
export type MoveProductsBetweenWishlistsOutput = {
  __typename?: 'MoveProductsBetweenWishlistsOutput';
  /** The destination wish list after receiving products moved from the source wish list. */
  destination_wishlist: Wishlist;
  /** The source wish list after moving products from it. */
  source_wishlist: Wishlist;
  /** An array of errors encountered while moving products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept invitation to the company. */
  acceptCompanyInvitation?: Maybe<CompanyInvitationOutput>;
  /** Update an existing negotiable quote template. */
  acceptNegotiableQuoteTemplate?: Maybe<NegotiableQuoteTemplate>;
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  /** Add registrants to the specified gift registry. */
  addGiftRegistryRegistrants?: Maybe<AddGiftRegistryRegistrantsOutput>;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>;
  /** Add items to the specified requisition list. */
  addProductsToRequisitionList?: Maybe<AddProductsToRequisitionListOutput>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>;
  /** Add a comment to an existing purchase order. */
  addPurchaseOrderComment?: Maybe<AddPurchaseOrderCommentOutput>;
  /** Add purchase order items to the shopping cart. */
  addPurchaseOrderItemsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add items in the requisition list to the customer's cart. */
  addRequisitionListItemsToCart?: Maybe<AddRequisitionListItemsToCartOutput>;
  /** Add a comment to an existing return. */
  addReturnComment?: Maybe<AddReturnCommentOutput>;
  /** Add tracking information to the return. */
  addReturnTracking?: Maybe<AddReturnTrackingOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  addStockNotification: Scalars['Boolean'];
  addTrustpilotInvitationForOrder: Scalars['Boolean'];
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>;
  adyenPaymentDetails?: Maybe<AdyenPaymentStatus>;
  adyenRemoveStateData?: Maybe<AdyenStateData>;
  adyenSaveStateData?: Maybe<AdyenStateData>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Apply a pre-defined gift card code to the specified cart. */
  applyGiftCardToCart?: Maybe<ApplyGiftCardToCartOutput>;
  /** Apply all available points, up to the cart total. Partial redemption is not available. */
  applyRewardPointsToCart?: Maybe<ApplyRewardPointsToCartOutput>;
  /** Apply store credit to the specified cart. */
  applyStoreCreditToCart?: Maybe<ApplyStoreCreditToCartOutput>;
  /** Approve purchase orders. */
  approvePurchaseOrders?: Maybe<PurchaseOrdersActionOutput>;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart;
  /** Cancel a negotiable quote template */
  cancelNegotiableQuoteTemplate?: Maybe<NegotiableQuoteTemplate>;
  /** Cancel purchase orders. */
  cancelPurchaseOrders?: Maybe<PurchaseOrdersActionOutput>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>;
  /** Remove all items from the specified cart. */
  clearCustomerCart?: Maybe<ClearCustomerCartOutput>;
  /** Mark a negotiable quote as closed. The negotiable quote is still visible on the storefront. */
  closeNegotiableQuotes?: Maybe<CloseNegotiableQuotesOutput>;
  confirmNewsletterRegistration: Scalars['Boolean'];
  /** Copy items from one requisition list to another. */
  copyItemsBetweenRequisitionLists?: Maybe<CopyItemsFromRequisitionListsOutput>;
  /** Copy products from one wish list to another. The original wish list is unchanged. */
  copyProductsBetweenWishlists?: Maybe<CopyProductsBetweenWishlistsOutput>;
  /** Create a company at the request of either a customer or a guest. */
  createCompany?: Maybe<CreateCompanyOutput>;
  /** Create a new company role. */
  createCompanyRole?: Maybe<CreateCompanyRoleOutput>;
  /** Create a new team for the customer's company within the current company context. */
  createCompanyTeam?: Maybe<CreateCompanyTeamOutput>;
  /** Create a new company user at the request of an existing customer. */
  createCompanyUser?: Maybe<CreateCompanyUserOutput>;
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>;
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>;
  /** Create an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']>;
  /** Create a gift registry on behalf of the customer. */
  createGiftRegistry?: Maybe<CreateGiftRegistryOutput>;
  /** Creates a Klarna Payments Session. */
  createKlarnaPaymentsSession?: Maybe<CreateKlarnaPaymentsSessionOutput>;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput;
  /** Create a purchase order approval rule. */
  createPurchaseOrderApprovalRule?: Maybe<PurchaseOrderApprovalRule>;
  /** Create an empty requisition list. */
  createRequisitionList?: Maybe<CreateRequisitionListOutput>;
  /** Create a new wish list. */
  createWishlist?: Maybe<CreateWishlistOutput>;
  /** Delete the specified company role. */
  deleteCompanyRole?: Maybe<DeleteCompanyRoleOutput>;
  /** Delete the specified company team. */
  deleteCompanyTeam?: Maybe<DeleteCompanyTeamOutput>;
  /**
   * Delete the specified company user.
   * @deprecated Use deleteCompanyUserV2 instead. The current method only deactivates the user account associated with the company.
   */
  deleteCompanyUser?: Maybe<DeleteCompanyUserOutput>;
  /** Delete the specified company user. */
  deleteCompanyUserV2?: Maybe<DeleteCompanyUserOutput>;
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars['Boolean']>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']>;
  /** Delete a negotiable quote template */
  deleteNegotiableQuoteTemplate: Scalars['Boolean'];
  /** Delete a negotiable quote. The negotiable quote will not be displayed on the storefront. */
  deleteNegotiableQuotes?: Maybe<DeleteNegotiableQuotesOutput>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  /** Delete existing purchase order approval rules. */
  deletePurchaseOrderApprovalRule?: Maybe<DeletePurchaseOrderApprovalRuleOutput>;
  /** Delete a requisition list. */
  deleteRequisitionList?: Maybe<DeleteRequisitionListOutput>;
  /** Delete items from a requisition list. */
  deleteRequisitionListItems?: Maybe<DeleteRequisitionListItemsOutput>;
  /** Delete the specified wish list. You cannot delete the customer's default (first) wish list. */
  deleteWishlist?: Maybe<DeleteWishlistOutput>;
  /** Negotiable Quote resulting from duplication operation. */
  duplicateNegotiableQuote?: Maybe<DuplicateNegotiableQuoteOutput>;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<GenerateCustomerTokenAsAdminOutput>;
  /** Generate a negotiable quote from an accept quote template. */
  generateNegotiableQuoteFromTemplate?: Maybe<GenerateNegotiableQuoteFromTemplateOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>;
  klarnaAuthorize: Scalars['Int'];
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart;
  /** Move all items from the cart to a gift registry. */
  moveCartItemsToGiftRegistry?: Maybe<MoveCartItemsToGiftRegistryOutput>;
  /** Move Items from one requisition list to another. */
  moveItemsBetweenRequisitionLists?: Maybe<MoveItemsBetweenRequisitionListsOutput>;
  /** Move negotiable quote item to requisition list. */
  moveLineItemToRequisitionList?: Maybe<MoveLineItemToRequisitionListOutput>;
  /** Move products from one wish list to another. */
  moveProductsBetweenWishlists?: Maybe<MoveProductsBetweenWishlistsOutput>;
  /** Open an existing negotiable quote template. */
  openNegotiableQuoteTemplate?: Maybe<NegotiableQuoteTemplate>;
  /** Convert a negotiable quote into an order. */
  placeNegotiableQuoteOrder?: Maybe<PlaceNegotiableQuoteOrderOutput>;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>;
  /** Convert the purchase order into an order. */
  placeOrderForPurchaseOrder?: Maybe<PlaceOrderForPurchaseOrderOutput>;
  /** Place a purchase order. */
  placePurchaseOrder?: Maybe<PlacePurchaseOrderOutput>;
  /** Redeem a gift card for store credit. */
  redeemGiftCardBalanceAsStoreCredit?: Maybe<GiftCardAccount>;
  /** Reject purchase orders. */
  rejectPurchaseOrders?: Maybe<PurchaseOrdersActionOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Removes a gift card from the cart. */
  removeGiftCardFromCart?: Maybe<RemoveGiftCardFromCartOutput>;
  /** Delete the specified gift registry. */
  removeGiftRegistry?: Maybe<RemoveGiftRegistryOutput>;
  /** Delete the specified items from a gift registry. */
  removeGiftRegistryItems?: Maybe<RemoveGiftRegistryItemsOutput>;
  /** Removes registrants from a gift registry. */
  removeGiftRegistryRegistrants?: Maybe<RemoveGiftRegistryRegistrantsOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Remove one or more products from a negotiable quote. */
  removeNegotiableQuoteItems?: Maybe<RemoveNegotiableQuoteItemsOutput>;
  /** Remove one or more products from a negotiable quote template. */
  removeNegotiableQuoteTemplateItems?: Maybe<NegotiableQuoteTemplate>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>;
  /** Remove a tracked shipment from a return. */
  removeReturnTracking?: Maybe<RemoveReturnTrackingOutput>;
  /** Cancel the application of reward points to the cart. */
  removeRewardPointsFromCart?: Maybe<RemoveRewardPointsFromCartOutput>;
  /** Remove store credit that has been applied to the specified cart. */
  removeStoreCreditFromCart?: Maybe<RemoveStoreCreditFromCartOutput>;
  /** Rename negotiable quote. */
  renameNegotiableQuote?: Maybe<RenameNegotiableQuoteOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>;
  /** Request a new negotiable quote on behalf of the buyer. */
  requestNegotiableQuote?: Maybe<RequestNegotiableQuoteOutput>;
  /** Request a new negotiable quote on behalf of the buyer. */
  requestNegotiableQuoteTemplateFromQuote?: Maybe<NegotiableQuoteTemplate>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Initiates a buyer's request to return items for replacement or refund. */
  requestReturn?: Maybe<RequestReturnOutput>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<SendEmailToFriendOutput>;
  /** Send the negotiable quote to the seller for review. */
  sendNegotiableQuoteForReview?: Maybe<SendNegotiableQuoteForReviewOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  /** Set gift options, including gift messages, gift wrapping, gift receipts, and printed cards. */
  setGiftOptionsOnCart?: Maybe<SetGiftOptionsOnCartOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /** Add buyer's note to a negotiable quote item. */
  setLineItemNote?: Maybe<SetLineItemNoteOutput>;
  /** Assign a billing address to a negotiable quote. */
  setNegotiableQuoteBillingAddress?: Maybe<SetNegotiableQuoteBillingAddressOutput>;
  /** Set the payment method on a negotiable quote. */
  setNegotiableQuotePaymentMethod?: Maybe<SetNegotiableQuotePaymentMethodOutput>;
  /** Assign a previously-defined address as the shipping address for a negotiable quote. */
  setNegotiableQuoteShippingAddress?: Maybe<SetNegotiableQuoteShippingAddressOutput>;
  /** Assign the shipping methods on the negotiable quote. */
  setNegotiableQuoteShippingMethods?: Maybe<SetNegotiableQuoteShippingMethodsOutput>;
  /** Assign a previously-defined address as the shipping address for a negotiable quote template. */
  setNegotiableQuoteTemplateShippingAddress?: Maybe<NegotiableQuoteTemplate>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  /** Add buyer's note to a negotiable quote template item. */
  setQuoteTemplateLineItemNote?: Maybe<NegotiableQuoteTemplate>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Send an email about the gift registry to a list of invitees. */
  shareGiftRegistry?: Maybe<ShareGiftRegistryOutput>;
  /** Accept an existing negotiable quote template. */
  submitNegotiableQuoteTemplateForReview?: Maybe<NegotiableQuoteTemplate>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Update company information. */
  updateCompany?: Maybe<UpdateCompanyOutput>;
  /** Update company role information. */
  updateCompanyRole?: Maybe<UpdateCompanyRoleOutput>;
  /** Change the parent node of a company team within the current company context. */
  updateCompanyStructure?: Maybe<UpdateCompanyStructureOutput>;
  /** Update company team data. */
  updateCompanyTeam?: Maybe<UpdateCompanyTeamOutput>;
  /** Update an existing company user. */
  updateCompanyUser?: Maybe<UpdateCompanyUserOutput>;
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>;
  /** Update the specified gift registry. */
  updateGiftRegistry?: Maybe<UpdateGiftRegistryOutput>;
  /** Update the specified items in the gift registry. */
  updateGiftRegistryItems?: Maybe<UpdateGiftRegistryItemsOutput>;
  /** Modify the properties of one or more gift registry registrants. */
  updateGiftRegistryRegistrants?: Maybe<UpdateGiftRegistryRegistrantsOutput>;
  /** Change the quantity of one or more items in an existing negotiable quote. */
  updateNegotiableQuoteQuantities?: Maybe<UpdateNegotiableQuoteItemsQuantityOutput>;
  /** Change the quantity of one or more items in an existing negotiable quote template. */
  updateNegotiableQuoteTemplateQuantities?: Maybe<UpdateNegotiableQuoteTemplateItemsQuantityOutput>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>;
  /** Update existing purchase order approval rules. */
  updatePurchaseOrderApprovalRule?: Maybe<PurchaseOrderApprovalRule>;
  /** Updates the email address of a quote. */
  updateQuoteEmail?: Maybe<Scalars['Boolean']>;
  /** Rename a requisition list and change its description. */
  updateRequisitionList?: Maybe<UpdateRequisitionListOutput>;
  /** Update items in a requisition list. */
  updateRequisitionListItems?: Maybe<UpdateRequisitionListItemsOutput>;
  /** Change the name and visibility of the specified wish list. */
  updateWishlist?: Maybe<UpdateWishlistOutput>;
  /** Validate purchase orders. */
  validatePurchaseOrders?: Maybe<ValidatePurchaseOrdersOutput>;
};


export type MutationAcceptCompanyInvitationArgs = {
  input: CompanyInvitationInput;
};


export type MutationAcceptNegotiableQuoteTemplateArgs = {
  input: AcceptNegotiableQuoteTemplateInput;
};


export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


export type MutationAddGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars['ID'];
  registrants: Array<AddGiftRegistryRegistrantInput>;
};


export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String'];
  cartItems: Array<CartItemInput>;
};


export type MutationAddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>;
};


export type MutationAddProductsToRequisitionListArgs = {
  requisitionListItems: Array<RequisitionListItemsInput>;
  requisitionListUid: Scalars['ID'];
};


export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemInput>;
};


export type MutationAddPurchaseOrderCommentArgs = {
  input: AddPurchaseOrderCommentInput;
};


export type MutationAddPurchaseOrderItemsToCartArgs = {
  input: AddPurchaseOrderItemsToCartInput;
};


export type MutationAddRequisitionListItemsToCartArgs = {
  requisitionListItemUids?: InputMaybe<Array<Scalars['ID']>>;
  requisitionListUid: Scalars['ID'];
};


export type MutationAddReturnCommentArgs = {
  input: AddReturnCommentInput;
};


export type MutationAddReturnTrackingArgs = {
  input: AddReturnTrackingInput;
};


export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


export type MutationAddStockNotificationArgs = {
  email: Scalars['String'];
  sku: Scalars['String'];
  storeCode: Scalars['String'];
};


export type MutationAddTrustpilotInvitationForOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationAdyenPaymentDetailsArgs = {
  cart_id: Scalars['String'];
  payload: Scalars['String'];
};


export type MutationAdyenRemoveStateDataArgs = {
  cartId: Scalars['String'];
  stateDataId: Scalars['Int'];
};


export type MutationAdyenSaveStateDataArgs = {
  cartId: Scalars['String'];
  stateData: Scalars['String'];
};


export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


export type MutationApplyGiftCardToCartArgs = {
  input?: InputMaybe<ApplyGiftCardToCartInput>;
};


export type MutationApplyRewardPointsToCartArgs = {
  cartId: Scalars['ID'];
};


export type MutationApplyStoreCreditToCartArgs = {
  input: ApplyStoreCreditToCartInput;
};


export type MutationApprovePurchaseOrdersArgs = {
  input: PurchaseOrdersActionInput;
};


export type MutationAssignCompareListToCustomerArgs = {
  uid: Scalars['ID'];
};


export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String'];
};


export type MutationCancelNegotiableQuoteTemplateArgs = {
  input: CancelNegotiableQuoteTemplateInput;
};


export type MutationCancelPurchaseOrdersArgs = {
  input: PurchaseOrdersActionInput;
};


export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationClearCustomerCartArgs = {
  cartUid: Scalars['String'];
};


export type MutationCloseNegotiableQuotesArgs = {
  input: CloseNegotiableQuotesInput;
};


export type MutationConfirmNewsletterRegistrationArgs = {
  code: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationCopyItemsBetweenRequisitionListsArgs = {
  destinationRequisitionListUid?: InputMaybe<Scalars['ID']>;
  requisitionListItem?: InputMaybe<CopyItemsBetweenRequisitionListsInput>;
  sourceRequisitionListUid: Scalars['ID'];
};


export type MutationCopyProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars['ID'];
  sourceWishlistUid: Scalars['ID'];
  wishlistItems: Array<WishlistItemCopyInput>;
};


export type MutationCreateCompanyArgs = {
  input: CompanyCreateInput;
};


export type MutationCreateCompanyRoleArgs = {
  input: CompanyRoleCreateInput;
};


export type MutationCreateCompanyTeamArgs = {
  input: CompanyTeamCreateInput;
};


export type MutationCreateCompanyUserArgs = {
  input: CompanyUserCreateInput;
};


export type MutationCreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>;
};


export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};


export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput;
};


export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};


export type MutationCreateGiftRegistryArgs = {
  giftRegistry: CreateGiftRegistryInput;
};


export type MutationCreateKlarnaPaymentsSessionArgs = {
  input?: InputMaybe<CreateKlarnaPaymentsSessionInput>;
};


export type MutationCreatePayflowProTokenArgs = {
  input: PayflowProTokenInput;
};


export type MutationCreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput;
};


export type MutationCreateProductReviewArgs = {
  input: CreateProductReviewInput;
};


export type MutationCreatePurchaseOrderApprovalRuleArgs = {
  input: PurchaseOrderApprovalRuleInput;
};


export type MutationCreateRequisitionListArgs = {
  input?: InputMaybe<CreateRequisitionListInput>;
};


export type MutationCreateWishlistArgs = {
  input: CreateWishlistInput;
};


export type MutationDeleteCompanyRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCompanyTeamArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCompanyUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCompanyUserV2Args = {
  id: Scalars['ID'];
};


export type MutationDeleteCompareListArgs = {
  uid: Scalars['ID'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteNegotiableQuoteTemplateArgs = {
  input: DeleteNegotiableQuoteTemplateInput;
};


export type MutationDeleteNegotiableQuotesArgs = {
  input: DeleteNegotiableQuotesInput;
};


export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String'];
};


export type MutationDeletePurchaseOrderApprovalRuleArgs = {
  input: DeletePurchaseOrderApprovalRuleInput;
};


export type MutationDeleteRequisitionListArgs = {
  requisitionListUid: Scalars['ID'];
};


export type MutationDeleteRequisitionListItemsArgs = {
  requisitionListItemUids: Array<Scalars['ID']>;
  requisitionListUid: Scalars['ID'];
};


export type MutationDeleteWishlistArgs = {
  wishlistId: Scalars['ID'];
};


export type MutationDuplicateNegotiableQuoteArgs = {
  input: DuplicateNegotiableQuoteInput;
};


export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationGenerateCustomerTokenAsAdminArgs = {
  input: GenerateCustomerTokenAsAdminInput;
};


export type MutationGenerateNegotiableQuoteFromTemplateArgs = {
  input: GenerateNegotiableQuoteFromTemplateInput;
};


export type MutationHandlePayflowProResponseArgs = {
  input: PayflowProResponseInput;
};


export type MutationKlarnaAuthorizeArgs = {
  requestBody: Scalars['String'];
  token: Scalars['String'];
};


export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']>;
  source_cart_id: Scalars['String'];
};


export type MutationMoveCartItemsToGiftRegistryArgs = {
  cartUid: Scalars['ID'];
  giftRegistryUid: Scalars['ID'];
};


export type MutationMoveItemsBetweenRequisitionListsArgs = {
  destinationRequisitionListUid?: InputMaybe<Scalars['ID']>;
  requisitionListItem?: InputMaybe<MoveItemsBetweenRequisitionListsInput>;
  sourceRequisitionListUid: Scalars['ID'];
};


export type MutationMoveLineItemToRequisitionListArgs = {
  input: MoveLineItemToRequisitionListInput;
};


export type MutationMoveProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars['ID'];
  sourceWishlistUid: Scalars['ID'];
  wishlistItems: Array<WishlistItemMoveInput>;
};


export type MutationOpenNegotiableQuoteTemplateArgs = {
  input: OpenNegotiableQuoteTemplateInput;
};


export type MutationPlaceNegotiableQuoteOrderArgs = {
  input: PlaceNegotiableQuoteOrderInput;
};


export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


export type MutationPlaceOrderForPurchaseOrderArgs = {
  input: PlaceOrderForPurchaseOrderInput;
};


export type MutationPlacePurchaseOrderArgs = {
  input: PlacePurchaseOrderInput;
};


export type MutationRedeemGiftCardBalanceAsStoreCreditArgs = {
  input: GiftCardAccountInput;
};


export type MutationRejectPurchaseOrdersArgs = {
  input: PurchaseOrdersActionInput;
};


export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


export type MutationRemoveGiftCardFromCartArgs = {
  input?: InputMaybe<RemoveGiftCardFromCartInput>;
};


export type MutationRemoveGiftRegistryArgs = {
  giftRegistryUid: Scalars['ID'];
};


export type MutationRemoveGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars['ID'];
  itemsUid: Array<Scalars['ID']>;
};


export type MutationRemoveGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars['ID'];
  registrantsUid: Array<Scalars['ID']>;
};


export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


export type MutationRemoveNegotiableQuoteItemsArgs = {
  input: RemoveNegotiableQuoteItemsInput;
};


export type MutationRemoveNegotiableQuoteTemplateItemsArgs = {
  input: RemoveNegotiableQuoteTemplateItemsInput;
};


export type MutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>;
};


export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemsIds: Array<Scalars['ID']>;
};


export type MutationRemoveReturnTrackingArgs = {
  input: RemoveReturnTrackingInput;
};


export type MutationRemoveRewardPointsFromCartArgs = {
  cartId: Scalars['ID'];
};


export type MutationRemoveStoreCreditFromCartArgs = {
  input: RemoveStoreCreditFromCartInput;
};


export type MutationRenameNegotiableQuoteArgs = {
  input: RenameNegotiableQuoteInput;
};


export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String'];
};


export type MutationRequestNegotiableQuoteArgs = {
  input: RequestNegotiableQuoteInput;
};


export type MutationRequestNegotiableQuoteTemplateFromQuoteArgs = {
  input: RequestNegotiableQuoteTemplateInput;
};


export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationRequestReturnArgs = {
  input: RequestReturnInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationSendEmailToFriendArgs = {
  input?: InputMaybe<SendEmailToFriendInput>;
};


export type MutationSendNegotiableQuoteForReviewArgs = {
  input: SendNegotiableQuoteForReviewInput;
};


export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


export type MutationSetGiftOptionsOnCartArgs = {
  input?: InputMaybe<SetGiftOptionsOnCartInput>;
};


export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


export type MutationSetLineItemNoteArgs = {
  input: LineItemNoteInput;
};


export type MutationSetNegotiableQuoteBillingAddressArgs = {
  input: SetNegotiableQuoteBillingAddressInput;
};


export type MutationSetNegotiableQuotePaymentMethodArgs = {
  input: SetNegotiableQuotePaymentMethodInput;
};


export type MutationSetNegotiableQuoteShippingAddressArgs = {
  input: SetNegotiableQuoteShippingAddressInput;
};


export type MutationSetNegotiableQuoteShippingMethodsArgs = {
  input: SetNegotiableQuoteShippingMethodsInput;
};


export type MutationSetNegotiableQuoteTemplateShippingAddressArgs = {
  input: SetNegotiableQuoteTemplateShippingAddressInput;
};


export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


export type MutationSetQuoteTemplateLineItemNoteArgs = {
  input: QuoteTemplateLineItemNoteInput;
};


export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


export type MutationShareGiftRegistryArgs = {
  giftRegistryUid: Scalars['ID'];
  invitees: Array<ShareGiftRegistryInviteeInput>;
  sender: ShareGiftRegistrySenderInput;
};


export type MutationSubmitNegotiableQuoteTemplateForReviewArgs = {
  input: SubmitNegotiableQuoteTemplateForReviewInput;
};


export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String'];
};


export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


export type MutationUpdateCompanyArgs = {
  input: CompanyUpdateInput;
};


export type MutationUpdateCompanyRoleArgs = {
  input: CompanyRoleUpdateInput;
};


export type MutationUpdateCompanyStructureArgs = {
  input: CompanyStructureUpdateInput;
};


export type MutationUpdateCompanyTeamArgs = {
  input: CompanyTeamUpdateInput;
};


export type MutationUpdateCompanyUserArgs = {
  input: CompanyUserUpdateInput;
};


export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<CustomerAddressInput>;
};


export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput;
};


export type MutationUpdateGiftRegistryArgs = {
  giftRegistry: UpdateGiftRegistryInput;
  giftRegistryUid: Scalars['ID'];
};


export type MutationUpdateGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars['ID'];
  items: Array<UpdateGiftRegistryItemInput>;
};


export type MutationUpdateGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars['ID'];
  registrants: Array<UpdateGiftRegistryRegistrantInput>;
};


export type MutationUpdateNegotiableQuoteQuantitiesArgs = {
  input: UpdateNegotiableQuoteQuantitiesInput;
};


export type MutationUpdateNegotiableQuoteTemplateQuantitiesArgs = {
  input: UpdateNegotiableQuoteTemplateQuantitiesInput;
};


export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemUpdateInput>;
};


export type MutationUpdatePurchaseOrderApprovalRuleArgs = {
  input: UpdatePurchaseOrderApprovalRuleInput;
};


export type MutationUpdateQuoteEmailArgs = {
  cartId: Scalars['String'];
  email: Scalars['String'];
};


export type MutationUpdateRequisitionListArgs = {
  input?: InputMaybe<UpdateRequisitionListInput>;
  requisitionListUid: Scalars['ID'];
};


export type MutationUpdateRequisitionListItemsArgs = {
  requisitionListItems: Array<UpdateRequisitionListItemsInput>;
  requisitionListUid: Scalars['ID'];
};


export type MutationUpdateWishlistArgs = {
  name?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<WishlistVisibilityEnum>;
  wishlistId: Scalars['ID'];
};


export type MutationValidatePurchaseOrdersArgs = {
  input: ValidatePurchaseOrdersInput;
};

/** Contains details about a negotiable quote. */
export type NegotiableQuote = {
  __typename?: 'NegotiableQuote';
  /** An array of payment methods that can be applied to the negotiable quote. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address applied to the negotiable quote. */
  billing_address?: Maybe<NegotiableQuoteBillingAddress>;
  /** The first and last name of the buyer. */
  buyer: NegotiableQuoteUser;
  /** A list of comments made by the buyer and seller. */
  comments?: Maybe<Array<Maybe<NegotiableQuoteComment>>>;
  /** Timestamp indicating when the negotiable quote was created. */
  created_at?: Maybe<Scalars['String']>;
  /** The email address of the company user. */
  email?: Maybe<Scalars['String']>;
  /** A list of status and price changes for the negotiable quote. */
  history?: Maybe<Array<Maybe<NegotiableQuoteHistoryEntry>>>;
  /** Indicates whether the negotiable quote contains only virtual products. */
  is_virtual: Scalars['Boolean'];
  /** The list of items in the negotiable quote. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** The title assigned to the negotiable quote. */
  name: Scalars['String'];
  /** A set of subtotals and totals applied to the negotiable quote. */
  prices?: Maybe<CartPrices>;
  /** The payment method that was applied to the negotiable quote. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** A list of shipping addresses applied to the negotiable quote. */
  shipping_addresses: Array<Maybe<NegotiableQuoteShippingAddress>>;
  /** The status of the negotiable quote. */
  status: NegotiableQuoteStatus;
  /** The total number of items in the negotiable quote. */
  total_quantity: Scalars['Float'];
  /** The unique ID of a `NegotiableQuote` object. */
  uid: Scalars['ID'];
  /** Timestamp indicating when the negotiable quote was updated. */
  updated_at?: Maybe<Scalars['String']>;
};

/** Defines the company's country. */
export type NegotiableQuoteAddressCountry = {
  __typename?: 'NegotiableQuoteAddressCountry';
  /** The address country code. */
  code: Scalars['String'];
  /** The display name of the region. */
  label: Scalars['String'];
};

/** Defines the billing or shipping address to be applied to the cart. */
export type NegotiableQuoteAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company name. */
  company?: InputMaybe<Scalars['String']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String'];
  /** The first name of the company user. */
  firstname: Scalars['String'];
  /** The last name of the company user. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']>;
};

export type NegotiableQuoteAddressInterface = {
  /** The company's city or town. */
  city: Scalars['String'];
  /** The company name associated with the shipping/billing address. */
  company?: Maybe<Scalars['String']>;
  /** The company's country. */
  country: NegotiableQuoteAddressCountry;
  /** The first name of the company user. */
  firstname: Scalars['String'];
  /** The last name of the company user. */
  lastname: Scalars['String'];
  /** The company's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<NegotiableQuoteAddressRegion>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
};

/** Defines the company's state or province. */
export type NegotiableQuoteAddressRegion = {
  __typename?: 'NegotiableQuoteAddressRegion';
  /** The address region code. */
  code?: Maybe<Scalars['String']>;
  /** The display name of the region. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

export type NegotiableQuoteBillingAddress = NegotiableQuoteAddressInterface & {
  __typename?: 'NegotiableQuoteBillingAddress';
  /** The company's city or town. */
  city: Scalars['String'];
  /** The company name associated with the shipping/billing address. */
  company?: Maybe<Scalars['String']>;
  /** The company's country. */
  country: NegotiableQuoteAddressCountry;
  /** The first name of the company user. */
  firstname: Scalars['String'];
  /** The last name of the company user. */
  lastname: Scalars['String'];
  /** The company's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<NegotiableQuoteAddressRegion>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
};

/** Defines the billing address. */
export type NegotiableQuoteBillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<NegotiableQuoteAddressInput>;
  /** The unique ID of a `CustomerAddress` object. */
  customer_address_uid?: InputMaybe<Scalars['ID']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the negotiable quote. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']>;
};

/** Contains a single plain text comment from either the buyer or seller. */
export type NegotiableQuoteComment = {
  __typename?: 'NegotiableQuoteComment';
  /** The first and last name of the commenter. */
  author: NegotiableQuoteUser;
  /** Timestamp indicating when the comment was created. */
  created_at: Scalars['String'];
  /** Indicates whether a buyer or seller commented. */
  creator_type: NegotiableQuoteCommentCreatorType;
  /** The plain text comment. */
  text: Scalars['String'];
  /** The unique ID of a `NegotiableQuoteComment` object. */
  uid: Scalars['ID'];
};

export enum NegotiableQuoteCommentCreatorType {
  /** @deprecated  */
  Buyer = 'BUYER',
  /** @deprecated  */
  Seller = 'SELLER'
}

/** Contains the commend provided by the buyer. */
export type NegotiableQuoteCommentInput = {
  /** The comment provided by the buyer. */
  comment: Scalars['String'];
};

/** Contains custom log entries added by third-party extensions. */
export type NegotiableQuoteCustomLogChange = {
  __typename?: 'NegotiableQuoteCustomLogChange';
  /** The new entry content. */
  new_value: Scalars['String'];
  /** The previous entry in the custom log. */
  old_value?: Maybe<Scalars['String']>;
  /** The title of the custom log entry. */
  title: Scalars['String'];
};

/** Defines a filter to limit the negotiable quotes to return. */
export type NegotiableQuoteFilterInput = {
  /** Filter by the ID of one or more negotiable quotes. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the negotiable quote name. */
  name?: InputMaybe<FilterMatchTypeInput>;
};

/** Contains a list of changes to a negotiable quote. */
export type NegotiableQuoteHistoryChanges = {
  __typename?: 'NegotiableQuoteHistoryChanges';
  /** The comment provided with a change in the negotiable quote history. */
  comment_added?: Maybe<NegotiableQuoteHistoryCommentChange>;
  /** Lists log entries added by third-party extensions. */
  custom_changes?: Maybe<NegotiableQuoteCustomLogChange>;
  /** The expiration date of the negotiable quote before and after a change in the quote history. */
  expiration?: Maybe<NegotiableQuoteHistoryExpirationChange>;
  /** Lists products that were removed as a result of a change in the quote history. */
  products_removed?: Maybe<NegotiableQuoteHistoryProductsRemovedChange>;
  /** The status before and after a change in the negotiable quote history. */
  statuses?: Maybe<NegotiableQuoteHistoryStatusesChange>;
  /** The total amount of the negotiable quote before and after a change in the quote history. */
  total?: Maybe<NegotiableQuoteHistoryTotalChange>;
};

/** Contains a comment submitted by a seller or buyer. */
export type NegotiableQuoteHistoryCommentChange = {
  __typename?: 'NegotiableQuoteHistoryCommentChange';
  /** A plain text comment submitted by a seller or buyer. */
  comment: Scalars['String'];
};

/** Contains details about a change for a negotiable quote. */
export type NegotiableQuoteHistoryEntry = {
  __typename?: 'NegotiableQuoteHistoryEntry';
  /** The person who made a change in the status of the negotiable quote. */
  author: NegotiableQuoteUser;
  /** An enum that describes the why the entry in the negotiable quote history changed status. */
  change_type: NegotiableQuoteHistoryEntryChangeType;
  /** The set of changes in the negotiable quote. */
  changes?: Maybe<NegotiableQuoteHistoryChanges>;
  /** Timestamp indicating when the negotiable quote entry was created. */
  created_at?: Maybe<Scalars['String']>;
  /** The unique ID of a `NegotiableQuoteHistoryEntry` object. */
  uid: Scalars['ID'];
};

export enum NegotiableQuoteHistoryEntryChangeType {
  /** @deprecated  */
  Closed = 'CLOSED',
  /** @deprecated  */
  Created = 'CREATED',
  /** @deprecated  */
  Updated = 'UPDATED',
  /** @deprecated  */
  UpdatedBySystem = 'UPDATED_BY_SYSTEM'
}

/** Contains a new expiration date and the previous date. */
export type NegotiableQuoteHistoryExpirationChange = {
  __typename?: 'NegotiableQuoteHistoryExpirationChange';
  /** The expiration date after the change. The value will be 'null' if not set. */
  new_expiration?: Maybe<Scalars['String']>;
  /** The previous expiration date. The value will be 'null' if not previously set. */
  old_expiration?: Maybe<Scalars['String']>;
};

/** Contains lists of products that have been removed from the catalog and negotiable quote. */
export type NegotiableQuoteHistoryProductsRemovedChange = {
  __typename?: 'NegotiableQuoteHistoryProductsRemovedChange';
  /** A list of product IDs the seller removed from the catalog. */
  products_removed_from_catalog?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** A list of products removed from the negotiable quote by either the buyer or the seller. */
  products_removed_from_quote?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** Lists a new status change applied to a negotiable quote and the previous status. */
export type NegotiableQuoteHistoryStatusChange = {
  __typename?: 'NegotiableQuoteHistoryStatusChange';
  /** The updated status. */
  new_status: NegotiableQuoteStatus;
  /** The previous status. The value will be null for the first history entry in a negotiable quote. */
  old_status?: Maybe<NegotiableQuoteStatus>;
};

/** Contains a list of status changes that occurred for the negotiable quote. */
export type NegotiableQuoteHistoryStatusesChange = {
  __typename?: 'NegotiableQuoteHistoryStatusesChange';
  /** A list of status changes. */
  changes: Array<Maybe<NegotiableQuoteHistoryStatusChange>>;
};

/** Contains a new price and the previous price. */
export type NegotiableQuoteHistoryTotalChange = {
  __typename?: 'NegotiableQuoteHistoryTotalChange';
  /** The total price as a result of the change. */
  new_price?: Maybe<Money>;
  /** The previous total price on the negotiable quote. */
  old_price?: Maybe<Money>;
};

/** An error indicating that an operation was attempted on a negotiable quote in an invalid state. */
export type NegotiableQuoteInvalidStateError = ErrorInterface & {
  __typename?: 'NegotiableQuoteInvalidStateError';
  /** The returned error message. */
  message: Scalars['String'];
};

/** Specifies the updated quantity of an item. */
export type NegotiableQuoteItemQuantityInput = {
  /** The new quantity of the negotiable quote item. */
  quantity: Scalars['Float'];
  /** The unique ID of a `CartItemInterface` object. */
  quote_item_uid: Scalars['ID'];
};

/** Defines the payment method to be applied to the negotiable quote. */
export type NegotiableQuotePaymentMethodInput = {
  /** Payment method code */
  code: Scalars['String'];
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']>;
};

export type NegotiableQuoteShippingAddress = NegotiableQuoteAddressInterface & {
  __typename?: 'NegotiableQuoteShippingAddress';
  /** An array of shipping methods available to the buyer. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** The company's city or town. */
  city: Scalars['String'];
  /** The company name associated with the shipping/billing address. */
  company?: Maybe<Scalars['String']>;
  /** The company's country. */
  country: NegotiableQuoteAddressCountry;
  /** The first name of the company user. */
  firstname: Scalars['String'];
  /** The last name of the company user. */
  lastname: Scalars['String'];
  /** The company's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<NegotiableQuoteAddressRegion>;
  /** The selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
};

/** Defines shipping addresses for the negotiable quote. */
export type NegotiableQuoteShippingAddressInput = {
  /** A shipping address. */
  address?: InputMaybe<NegotiableQuoteAddressInput>;
  /** An ID from the company user's address book that uniquely identifies the address to be used for shipping. */
  customer_address_uid?: InputMaybe<Scalars['ID']>;
  /** Text provided by the company user. */
  customer_notes?: InputMaybe<Scalars['String']>;
};

/** Defines the field to use to sort a list of negotiable quotes. */
export type NegotiableQuoteSortInput = {
  /** Whether to return results in ascending or descending order. */
  sort_direction: SortEnum;
  /** The specified sort field. */
  sort_field: NegotiableQuoteSortableField;
};

export enum NegotiableQuoteSortableField {
  /**
   * Sorts negotiable quotes by the dates they were created.
   * @deprecated
   */
  CreatedAt = 'CREATED_AT',
  /**
   * Sorts negotiable quotes by name.
   * @deprecated
   */
  QuoteName = 'QUOTE_NAME',
  /**
   * Sorts negotiable quotes by the dates they were last modified.
   * @deprecated
   */
  UpdatedAt = 'UPDATED_AT'
}

export enum NegotiableQuoteStatus {
  /** @deprecated  */
  Closed = 'CLOSED',
  /** @deprecated  */
  Declined = 'DECLINED',
  /** @deprecated  */
  Draft = 'DRAFT',
  /** @deprecated  */
  Expired = 'EXPIRED',
  /** @deprecated  */
  Open = 'OPEN',
  /** @deprecated  */
  Ordered = 'ORDERED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  Submitted = 'SUBMITTED',
  /** @deprecated  */
  Updated = 'UPDATED'
}

/** Contains details about a negotiable quote template. */
export type NegotiableQuoteTemplate = {
  __typename?: 'NegotiableQuoteTemplate';
  /** The first and last name of the buyer. */
  buyer: NegotiableQuoteUser;
  /** A list of comments made by the buyer and seller. */
  comments?: Maybe<Array<Maybe<NegotiableQuoteComment>>>;
  /** The expiration period of the negotiable quote template. */
  expiration_date: Scalars['String'];
  /** A list of status and price changes for the negotiable quote template. */
  history?: Maybe<Array<Maybe<NegotiableQuoteHistoryEntry>>>;
  /** Indicates whether the minimum and maximum quantity settings are used. */
  is_min_max_qty_used: Scalars['Boolean'];
  /** Indicates whether the negotiable quote template contains only virtual products. */
  is_virtual: Scalars['Boolean'];
  /** The list of items in the negotiable quote template. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** Commitment for maximum orders */
  max_order_commitment: Scalars['Int'];
  /** Commitment for minimum orders */
  min_order_commitment: Scalars['Int'];
  /** The title assigned to the negotiable quote template. */
  name: Scalars['String'];
  /** A list of notifications for the negotiable quote template. */
  notifications?: Maybe<Array<Maybe<QuoteTemplateNotificationMessage>>>;
  /** A set of subtotals and totals applied to the negotiable quote template. */
  prices?: Maybe<CartPrices>;
  /** A list of shipping addresses applied to the negotiable quote template. */
  shipping_addresses: Array<Maybe<NegotiableQuoteShippingAddress>>;
  /** The status of the negotiable quote template. */
  status: Scalars['String'];
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
  /** The total number of items in the negotiable quote template. */
  total_quantity: Scalars['Float'];
};

/** Defines a filter to limit the negotiable quotes to return. */
export type NegotiableQuoteTemplateFilterInput = {
  /** Filter by state of one or more negotiable quote templates. */
  state?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by status of one or more negotiable quote templates. */
  status?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains data for a negotiable quote template in a grid. */
export type NegotiableQuoteTemplateGridItem = {
  __typename?: 'NegotiableQuoteTemplateGridItem';
  /** The date and time the negotiable quote template was activated. */
  activated_at: Scalars['String'];
  /** Company name the quote template is assigned to */
  company_name: Scalars['String'];
  /** The expiration period of the negotiable quote template. */
  expiration_date: Scalars['String'];
  /** Indicates whether the minimum and maximum quantity settings are used. */
  is_min_max_qty_used: Scalars['Boolean'];
  /** The date and time the negotiable quote template was last shared. */
  last_shared_at: Scalars['String'];
  /** Commitment for maximum orders */
  max_order_commitment: Scalars['Int'];
  /** The minimum negotiated grand total of the negotiable quote template. */
  min_negotiated_grand_total: Scalars['Float'];
  /** Commitment for minimum orders */
  min_order_commitment: Scalars['Int'];
  /** The title assigned to the negotiable quote template. */
  name: Scalars['String'];
  /** The number of orders placed for the negotiable quote template. */
  orders_placed: Scalars['Int'];
  /** The first and last name of the sales representative. */
  sales_rep_name: Scalars['String'];
  /** State of the negotiable quote template. */
  state: Scalars['String'];
  /** The status of the negotiable quote template. */
  status: Scalars['String'];
  /** The first and last name of the buyer. */
  submitted_by: Scalars['String'];
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Specifies the updated quantity of an item. */
export type NegotiableQuoteTemplateItemQuantityInput = {
  /** The unique ID of a `CartItemInterface` object. */
  item_id: Scalars['ID'];
  /** The new max quantity of the negotiable quote template item. Only used if is_min_max_qty_used is true on the template. */
  max_qty?: InputMaybe<Scalars['Float']>;
  /** The new min quantity of the negotiable quote template item. Only used if is_min_max_qty_used is true on the template. */
  min_qty?: InputMaybe<Scalars['Float']>;
  /** The new quantity of the negotiable quote item. */
  quantity: Scalars['Float'];
};

/** Defines shipping addresses for the negotiable quote template. */
export type NegotiableQuoteTemplateShippingAddressInput = {
  /** A shipping address. */
  address?: InputMaybe<NegotiableQuoteAddressInput>;
  /** An ID from the company user's address book that uniquely identifies the address to be used for shipping. */
  customer_address_uid?: InputMaybe<Scalars['ID']>;
  /** Text provided by the company user. */
  customer_notes?: InputMaybe<Scalars['String']>;
};

/** Defines the field to use to sort a list of negotiable quotes. */
export type NegotiableQuoteTemplateSortInput = {
  /** Whether to return results in ascending or descending order. */
  sort_direction: SortEnum;
  /** The specified sort field. */
  sort_field: NegotiableQuoteTemplateSortableField;
};

export enum NegotiableQuoteTemplateSortableField {
  /**
   * Sorts negotiable quote templates by the date they were last shared.
   * @deprecated
   */
  LastSharedAt = 'LAST_SHARED_AT',
  /**
   * Sorts negotiable quote templates by template id.
   * @deprecated
   */
  TemplateId = 'TEMPLATE_ID'
}

/** Contains a list of negotiable templates that match the specified filter. */
export type NegotiableQuoteTemplatesOutput = {
  __typename?: 'NegotiableQuoteTemplatesOutput';
  /** A list of negotiable quote templates */
  items: Array<Maybe<NegotiableQuoteTemplateGridItem>>;
  /** Contains pagination metadata */
  page_info: SearchResultPageInfo;
  /** Contains the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** The number of negotiable quote templates returned */
  total_count: Scalars['Int'];
};

export type NegotiableQuoteUidNonFatalResultInterface = {
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains details about a successful operation on a negotiable quote. */
export type NegotiableQuoteUidOperationSuccess = NegotiableQuoteUidNonFatalResultInterface & {
  __typename?: 'NegotiableQuoteUidOperationSuccess';
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** A limited view of a Buyer or Seller in the negotiable quote process. */
export type NegotiableQuoteUser = {
  __typename?: 'NegotiableQuoteUser';
  /** The first name of the buyer or seller making a change. */
  firstname: Scalars['String'];
  /** The buyer's or seller's last name. */
  lastname: Scalars['String'];
};

/** Contains a list of negotiable that match the specified filter. */
export type NegotiableQuotesOutput = {
  __typename?: 'NegotiableQuotesOutput';
  /** A list of negotiable quotes */
  items: Array<Maybe<NegotiableQuote>>;
  /** Contains pagination metadata */
  page_info: SearchResultPageInfo;
  /** Contains the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** The number of negotiable quotes returned */
  total_count: Scalars['Int'];
};

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError';
  /** The returned error message. */
  message: Scalars['String'];
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID'];
};

/** Specifies the quote template id to open quote template. */
export type OpenNegotiableQuoteTemplateInput = {
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains details about the requested order */
export type Order = {
  __typename?: 'Order';
  adyen_payment_status?: Maybe<AdyenPaymentStatus>;
  /** Cart ID. */
  cart_id: Scalars['String'];
  /** An array containing the items purchased in this order */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String'];
  /** Contains the calculated total for this order */
  total?: Maybe<Scalars['String']>;
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** The city or town. */
  city: Scalars['String'];
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars['Boolean']>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars['Boolean']>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String'];
  /** The value of the option. */
  value: Scalars['String'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The gift card balance applied to the order. */
  total_giftcard?: Maybe<Money>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String'];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String'];
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export enum PayflowLinkMode {
  /** @deprecated  */
  Live = 'LIVE',
  /** @deprecated  */
  Test = 'TEST'
}

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  __typename?: 'PayflowLinkToken';
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars['String']>;
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars['String']>;
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars['String']>;
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']>;
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String'];
};

export type PayflowProResponseOutput = {
  __typename?: 'PayflowProResponseOutput';
  /** The cart with the updated selected payment method. */
  cart: Cart;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  __typename?: 'PayflowProToken';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String'];
};

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
};

export type PaymentMethodBalance = {
  __typename?: 'PaymentMethodBalance';
  /** Cart currency */
  currency?: Maybe<Scalars['String']>;
  /** Total cart amount */
  value?: Maybe<Scalars['String']>;
};

/** Defines the payment method. */
export type PaymentMethodInput = {
  /** Required input for Adyen alternative payment methods. */
  adyen_additional_data?: InputMaybe<AdyenAdditionalData>;
  /** Required input for Adyen CC payments. */
  adyen_additional_data_cc?: InputMaybe<AdyenAdditionalDataCc>;
  /** Required input for Adyen POS Cloud payments. */
  adyen_additional_data_pos_cloud?: InputMaybe<AdyenAdditionalDataPosCloud>;
  /** The internal name for the payment method. */
  code: Scalars['String'];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>;
  klarna?: InputMaybe<KlarnaInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']>;
};

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String'];
  /** The public hash of the token. */
  public_hash: Scalars['String'];
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export enum PaymentTokenTypeEnum {
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  Account = 'account',
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  Card = 'card'
}

/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String'];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String'];
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  __typename?: 'PaypalExpressToken';
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']>;
};

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
  /** The payment method code. */
  code: Scalars['String'];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  __typename?: 'PaypalExpressTokenOutput';
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  __typename?: 'PaypalExpressUrlList';
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']>;
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String'];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']>;
};

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};

/** Specifies the negotiable quote to convert to an order. */
export type PlaceNegotiableQuoteOrderInput = {
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** An output object that returns the generated order. */
export type PlaceNegotiableQuoteOrderOutput = {
  __typename?: 'PlaceNegotiableQuoteOrderOutput';
  /** Contains the generated order number. */
  order: Order;
};

/** Specifies the purchase order to convert to an order. */
export type PlaceOrderForPurchaseOrderInput = {
  /** The unique ID of a purchase order. */
  purchase_order_uid: Scalars['ID'];
};

/** Contains the results of the request to place an order. */
export type PlaceOrderForPurchaseOrderOutput = {
  __typename?: 'PlaceOrderForPurchaseOrderOutput';
  /** Placed order. */
  order: CustomerOrder;
};

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  /** The ID of the order. */
  order: Order;
};

/** Specifies the quote to be converted to a purchase order. */
export type PlacePurchaseOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains the results of the request to place a purchase order. */
export type PlacePurchaseOrderOutput = {
  __typename?: 'PlacePurchaseOrderOutput';
  /** Placed purchase order. */
  purchase_order: PurchaseOrder;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated `PriceAdjustmentCodesEnum` is deprecated. Tax is included or excluded in the price. Tax is not shown separately in Catalog. */
  Tax = 'TAX',
  /** @deprecated WEEE code is deprecated. Use `fixed_product_taxes.label` instead. */
  Weee = 'WEEE',
  /** @deprecated Use `fixed_product_taxes` instead.  Tax is included or excluded in price. The tax is not shown separtely in Catalog. */
  WeeeTax = 'WEEE_TAX'
}

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  /** @deprecated  */
  Excluded = 'EXCLUDED',
  /** @deprecated  */
  Included = 'INCLUDED'
}

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** Defines the price type. */
export enum PriceTypeEnum {
  /** @deprecated  */
  Dynamic = 'DYNAMIC',
  /** @deprecated  */
  Fixed = 'FIXED',
  /** @deprecated  */
  Percent = 'PERCENT'
}

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  /** @deprecated  */
  AsLowAs = 'AS_LOW_AS',
  /** @deprecated  */
  PriceRange = 'PRICE_RANGE'
}

/** Contains a product attribute code and value. */
export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  /** The unique identifier for a product attribute code. */
  code: Scalars['String'];
  /** The display value of the attribute. */
  value: Scalars['String'];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Farbfilter */
  benuta_color_filter?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Form */
  benuta_form_new?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Lifestyle */
  benuta_lifestyle?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Wohnraum */
  benuta_living_area?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Material */
  benuta_material?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Motiv/Design */
  benuta_motive_design?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Preisgruppe */
  benuta_pricegroup_new?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Prüfsiegel */
  benuta_test_seal?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Marke */
  manufacturer?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
  /** Attribute label: Aktion */
  test_special_sortorder?: InputMaybe<SortEnum>;
  /** Attribute label: Bestsellers */
  umsatz?: InputMaybe<SortEnum>;
};

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product can be returned. */
  is_returnable?: InputMaybe<FilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>;
  url_path?: InputMaybe<FilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks';
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']>;
};

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: Money;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>;
};

/** Contains details of a product review. */
export type ProductReview = {
  __typename?: 'ProductReview';
  /** The average of all ratings for this product. */
  average_rating: Scalars['Float'];
  /** The date the review was created. */
  created_at: Scalars['String'];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String'];
  /** The reviewed product. */
  product: ProductInterface;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<ProductReviewRating>>;
  /** The summary (title) of the review. */
  summary: Scalars['String'];
  /** The review text. */
  text: Scalars['String'];
};

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  __typename?: 'ProductReviewRating';
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String'];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String'];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String'];
  /** An encoded rating value ID. */
  value_id: Scalars['String'];
};

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  __typename?: 'ProductReviewRatingMetadata';
  /** An encoded rating ID. */
  id: Scalars['String'];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String'];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  __typename?: 'ProductReviewRatingValueMetadata';
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String'];
  /** An encoded rating value ID. */
  value_id: Scalars['String'];
};

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  __typename?: 'ProductReviewRatingsMetadata';
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>;
};

/** Contains an array of product reviews. */
export type ProductReviews = {
  __typename?: 'ProductReviews';
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>;
  /** Indicates whether the product can be returned. */
  is_returnable?: InputMaybe<SortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>;
  /** The price of the item. */
  price?: InputMaybe<SortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>;
  url_path?: InputMaybe<SortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>;
};

/** States whether a product stock status is in stock or out of stock. */
export enum ProductStockStatus {
  /** @deprecated  */
  InStock = 'IN_STOCK',
  /** @deprecated  */
  OutOfStock = 'OUT_OF_STOCK'
}

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products';
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};


/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>;
};

/** Contains details about a purchase order. */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  /** The approval flows for each applied rules. */
  approval_flow: Array<Maybe<PurchaseOrderRuleApprovalFlow>>;
  /** Purchase order actions available to the customer. Can be used to display action buttons on the client. */
  available_actions: Array<Maybe<PurchaseOrderAction>>;
  /** The set of comments applied to the purchase order. */
  comments: Array<Maybe<PurchaseOrderComment>>;
  /** The date the purchase order was created. */
  created_at: Scalars['String'];
  /** The company user who created the purchase order. */
  created_by?: Maybe<Customer>;
  /** The log of the events related to the purchase order. */
  history_log: Array<Maybe<PurchaseOrderHistoryItem>>;
  /** The purchase order number. */
  number: Scalars['String'];
  /** The reference to the order placed based on the purchase order. */
  order?: Maybe<CustomerOrder>;
  /** The quote related to the purchase order. */
  quote?: Maybe<Cart>;
  /** The current status of the purchase order. */
  status: PurchaseOrderStatus;
  /** A unique identifier for the purchase order. */
  uid: Scalars['ID'];
  /** The date the purchase order was last updated. */
  updated_at: Scalars['String'];
};

export enum PurchaseOrderAction {
  /** @deprecated  */
  Approve = 'APPROVE',
  /** @deprecated  */
  Cancel = 'CANCEL',
  /** @deprecated  */
  PlaceOrder = 'PLACE_ORDER',
  /** @deprecated  */
  Reject = 'REJECT',
  /** @deprecated  */
  Validate = 'VALIDATE'
}

/** Contains details about a failed action. */
export type PurchaseOrderActionError = {
  __typename?: 'PurchaseOrderActionError';
  /** The returned error message. */
  message: Scalars['String'];
  /** The error type. */
  type: PurchaseOrderErrorType;
};

/** Contains details about a single event in the approval flow of the purchase order. */
export type PurchaseOrderApprovalFlowEvent = {
  __typename?: 'PurchaseOrderApprovalFlowEvent';
  /** A formatted message. */
  message?: Maybe<Scalars['String']>;
  /** The approver name. */
  name?: Maybe<Scalars['String']>;
  /** The approver role. */
  role?: Maybe<Scalars['String']>;
  /** The status related to the event. */
  status?: Maybe<PurchaseOrderApprovalFlowItemStatus>;
  /** The date and time the event was updated. */
  updated_at?: Maybe<Scalars['String']>;
};

export enum PurchaseOrderApprovalFlowItemStatus {
  /** @deprecated  */
  Approved = 'APPROVED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  Rejected = 'REJECTED'
}

/** Contains details about a purchase order approval rule. */
export type PurchaseOrderApprovalRule = {
  __typename?: 'PurchaseOrderApprovalRule';
  /** The name of the user(s) affected by the the purchase order approval rule. */
  applies_to_roles: Array<Maybe<CompanyRole>>;
  /** The name of the user who needs to approve purchase orders that trigger the approval rule. */
  approver_roles: Array<Maybe<CompanyRole>>;
  /** Condition which triggers the approval rule. */
  condition?: Maybe<PurchaseOrderApprovalRuleConditionInterface>;
  /** The date the purchase order rule was created. */
  created_at: Scalars['String'];
  /** The name of the user who created the purchase order approval rule. */
  created_by: Scalars['String'];
  /** Description of the purchase order approval rule. */
  description?: Maybe<Scalars['String']>;
  /** The name of the purchase order approval rule. */
  name: Scalars['String'];
  /** The status of the purchase order approval rule. */
  status: PurchaseOrderApprovalRuleStatus;
  /** The unique identifier for the purchase order approval rule. */
  uid: Scalars['ID'];
  /** The date the purchase order rule was last updated. */
  updated_at: Scalars['String'];
};

/** Contains approval rule condition details, including the amount to be evaluated. */
export type PurchaseOrderApprovalRuleConditionAmount = PurchaseOrderApprovalRuleConditionInterface & {
  __typename?: 'PurchaseOrderApprovalRuleConditionAmount';
  /** The amount to be be used for evaluation of the approval rule condition. */
  amount: Money;
  /** The type of purchase order approval rule. */
  attribute?: Maybe<PurchaseOrderApprovalRuleType>;
  /** The operator to be used for evaluating the approval rule condition. */
  operator?: Maybe<PurchaseOrderApprovalRuleConditionOperator>;
};

/** Purchase order rule condition details. */
export type PurchaseOrderApprovalRuleConditionInterface = {
  /** The type of purchase order approval rule. */
  attribute?: Maybe<PurchaseOrderApprovalRuleType>;
  /** The operator to be used for evaluating the approval rule condition. */
  operator?: Maybe<PurchaseOrderApprovalRuleConditionOperator>;
};

export enum PurchaseOrderApprovalRuleConditionOperator {
  /** @deprecated  */
  LessThan = 'LESS_THAN',
  /** @deprecated  */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** @deprecated  */
  MoreThan = 'MORE_THAN',
  /** @deprecated  */
  MoreThanOrEqualTo = 'MORE_THAN_OR_EQUAL_TO'
}

/** Contains approval rule condition details, including the quantity to be evaluated. */
export type PurchaseOrderApprovalRuleConditionQuantity = PurchaseOrderApprovalRuleConditionInterface & {
  __typename?: 'PurchaseOrderApprovalRuleConditionQuantity';
  /** The type of purchase order approval rule. */
  attribute?: Maybe<PurchaseOrderApprovalRuleType>;
  /** The operator to be used for evaluating the approval rule condition. */
  operator?: Maybe<PurchaseOrderApprovalRuleConditionOperator>;
  /** The quantity to be used for evaluation of the approval rule condition. */
  quantity?: Maybe<Scalars['Int']>;
};

/** Defines a new purchase order approval rule. */
export type PurchaseOrderApprovalRuleInput = {
  /** A list of company user role IDs to which this purchase order approval rule should be applied. When an empty array is provided, the rule is applied to all user roles in the system, including those created in the future. */
  applies_to: Array<InputMaybe<Scalars['ID']>>;
  /** A list of B2B user roles that can approve this purchase order approval rule. */
  approvers: Array<InputMaybe<Scalars['ID']>>;
  /** The condition of the purchase order approval rule. */
  condition: CreatePurchaseOrderApprovalRuleConditionInput;
  /** A summary of the purpose of the purchase order approval rule. */
  description?: InputMaybe<Scalars['String']>;
  /** The purchase order approval rule name. */
  name: Scalars['String'];
  /** The status of the purchase order approval rule. */
  status: PurchaseOrderApprovalRuleStatus;
};

/** Contains metadata that can be used to render rule edit forms. */
export type PurchaseOrderApprovalRuleMetadata = {
  __typename?: 'PurchaseOrderApprovalRuleMetadata';
  /** A list of B2B user roles that the rule can be applied to. */
  available_applies_to: Array<Maybe<CompanyRole>>;
  /** A list of currencies that can be used to create approval rules based on amounts, for example shipping cost rules. */
  available_condition_currencies: Array<Maybe<AvailableCurrency>>;
  /** A list of B2B user roles that can be specified as approvers for the approval rules. */
  available_requires_approval_from: Array<Maybe<CompanyRole>>;
};

export enum PurchaseOrderApprovalRuleStatus {
  /** @deprecated  */
  Disabled = 'DISABLED',
  /** @deprecated  */
  Enabled = 'ENABLED'
}

export enum PurchaseOrderApprovalRuleType {
  /** @deprecated  */
  GrandTotal = 'GRAND_TOTAL',
  /** @deprecated  */
  NumberOfSkus = 'NUMBER_OF_SKUS',
  /** @deprecated  */
  ShippingInclTax = 'SHIPPING_INCL_TAX'
}

/** Contains the approval rules that the customer can see. */
export type PurchaseOrderApprovalRules = {
  __typename?: 'PurchaseOrderApprovalRules';
  /** A list of purchase order approval rules visible to the customer. */
  items: Array<Maybe<PurchaseOrderApprovalRule>>;
  /** Result pagination details. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of purchase order approval rules visible to the customer. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains details about a comment. */
export type PurchaseOrderComment = {
  __typename?: 'PurchaseOrderComment';
  /** The user who left the comment. */
  author?: Maybe<Customer>;
  /** The date and time when the comment was created. */
  created_at: Scalars['String'];
  /** The text of the comment. */
  text: Scalars['String'];
  /** A unique identifier of the comment. */
  uid: Scalars['ID'];
};

export enum PurchaseOrderErrorType {
  /** @deprecated  */
  CouldNotSave = 'COULD_NOT_SAVE',
  /** @deprecated  */
  NotFound = 'NOT_FOUND',
  /** @deprecated  */
  NotValidData = 'NOT_VALID_DATA',
  /** @deprecated  */
  OperationNotApplicable = 'OPERATION_NOT_APPLICABLE',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Contains details about a status change. */
export type PurchaseOrderHistoryItem = {
  __typename?: 'PurchaseOrderHistoryItem';
  /** The activity type of the event. */
  activity: Scalars['String'];
  /** The date and time when the event happened. */
  created_at: Scalars['String'];
  /** The message representation of the event. */
  message: Scalars['String'];
  /** A unique identifier of the purchase order history item. */
  uid: Scalars['ID'];
};

/** Contains details about approval roles applied to the purchase order and status changes. */
export type PurchaseOrderRuleApprovalFlow = {
  __typename?: 'PurchaseOrderRuleApprovalFlow';
  /** The approval flow event related to the rule. */
  events: Array<Maybe<PurchaseOrderApprovalFlowEvent>>;
  /** The name of the applied rule. */
  rule_name: Scalars['String'];
};

export enum PurchaseOrderStatus {
  /** @deprecated  */
  ApprovalRequired = 'APPROVAL_REQUIRED',
  /** @deprecated  */
  Approved = 'APPROVED',
  /** @deprecated  */
  ApprovedPendingPayment = 'APPROVED_PENDING_PAYMENT',
  /** @deprecated  */
  Canceled = 'CANCELED',
  /** @deprecated  */
  OrderFailed = 'ORDER_FAILED',
  /** @deprecated  */
  OrderInProgress = 'ORDER_IN_PROGRESS',
  /** @deprecated  */
  OrderPlaced = 'ORDER_PLACED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  Rejected = 'REJECTED'
}

/** Contains a list of purchase orders. */
export type PurchaseOrders = {
  __typename?: 'PurchaseOrders';
  /** Purchase orders matching the search criteria. */
  items: Array<Maybe<PurchaseOrder>>;
  /** Page information of search result's current page. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** Total number of purchase orders found matching the search criteria. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Defines which purchase orders to act on. */
export type PurchaseOrdersActionInput = {
  /** An array of purchase order UIDs. */
  purchase_order_uids: Array<InputMaybe<Scalars['ID']>>;
};

/** Returns a list of updated purchase orders and any error messages. */
export type PurchaseOrdersActionOutput = {
  __typename?: 'PurchaseOrdersActionOutput';
  /** An array of error messages encountered while performing the operation. */
  errors: Array<Maybe<PurchaseOrderActionError>>;
  /** A list of purchase orders. */
  purchase_orders: Array<Maybe<PurchaseOrder>>;
};

/** Defines the criteria to use to filter the list of purchase orders. */
export type PurchaseOrdersFilterInput = {
  /** Include only purchase orders made by subordinate company users. */
  company_purchase_orders?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the creation date of the purchase order. */
  created_date?: InputMaybe<FilterRangeTypeInput>;
  /** Include only purchase orders that are waiting for the customer’s approval. */
  require_my_approval?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the status of the purchase order. */
  status?: InputMaybe<PurchaseOrderStatus>;
};

export type Query = {
  __typename?: 'Query';
  adyenPaymentMethods?: Maybe<AdyenPaymentMethods>;
  adyenPaymentMethodsBalance?: Maybe<AdyenPaymentMethodsBalanceResponse>;
  adyenPaymentStatus?: Maybe<AdyenPaymentStatus>;
  adyenRedeemedGiftcards?: Maybe<AdyenRedeemedGiftcardsResponse>;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>;
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  categoryUrls: Array<Maybe<Scalars['String']>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>;
  /** Return detailed information about the customer's company within the current company context. */
  company?: Maybe<Company>;
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>;
  /** Return the attribute type, given an attribute code and entity type. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>;
  /** Return information about the customer's shopping cart. */
  customerCart: Cart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Return a list of dynamic blocks filtered by type, location, or UIDs. */
  dynamicBlocks: DynamicBlocks;
  /** Returns status of Easy Email Capture for Checkout. */
  emailCaptureCheckout?: Maybe<IsConfigSettingEnabledOutput>;
  /** Returns status of Easy Email Capture for Newsletter. */
  emailCaptureNewsletter?: Maybe<IsConfigSettingEnabledOutput>;
  first_time_customer?: Maybe<Scalars['Boolean']>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>;
  getSovendusData: SovendusData;
  getTrustedShopsDataForLastOrder: TrustedShopsData;
  /** Return details about a specific gift card. */
  giftCardAccount?: Maybe<GiftCardAccount>;
  /** Return the specified gift registry. Some details will not be available to guests. */
  giftRegistry?: Maybe<GiftRegistry>;
  /** Search for gift registries by specifying a registrant email address. */
  giftRegistryEmailSearch?: Maybe<Array<Maybe<GiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying a registry URL key. */
  giftRegistryIdSearch?: Maybe<Array<Maybe<GiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying the registrant name and registry type ID. */
  giftRegistryTypeSearch?: Maybe<Array<Maybe<GiftRegistrySearchResult>>>;
  /** Get a list of available gift registry types. */
  giftRegistryTypes?: Maybe<Array<Maybe<GiftRegistryType>>>;
  /** Check whether the specified email can be used to register a company admin. */
  isCompanyAdminEmailAvailable?: Maybe<IsCompanyAdminEmailAvailableOutput>;
  /** Check whether the specified email can be used to register a new company. */
  isCompanyEmailAvailable?: Maybe<IsCompanyEmailAvailableOutput>;
  /** Check whether the specified role name is valid for the company. */
  isCompanyRoleNameAvailable?: Maybe<IsCompanyRoleNameAvailableOutput>;
  /** Check whether the specified email can be used to register a company user. */
  isCompanyUserEmailAvailable?: Maybe<IsCompanyUserEmailAvailableOutput>;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  live_time_value?: Maybe<Scalars['Float']>;
  /** Retrieve the specified negotiable quote. */
  negotiableQuote?: Maybe<NegotiableQuote>;
  /** Retrieve the specified negotiable quote template. */
  negotiableQuoteTemplate?: Maybe<NegotiableQuoteTemplate>;
  /** Return a list of negotiable quote templates that can be viewed by the logged-in customer. */
  negotiableQuoteTemplates?: Maybe<NegotiableQuoteTemplatesOutput>;
  /** Return a list of negotiable quotes that can be viewed by the logged-in customer. */
  negotiableQuotes?: Maybe<NegotiableQuotesOutput>;
  /** Retrieves information about an order by order id. */
  orderData?: Maybe<Order>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata;
  productUrls: Array<Maybe<Scalars['String']>>;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>;
  /** Retrieves an array of configuration data for different types of tracking. */
  trackingData?: Maybe<TrackingData>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>;
};


export type QueryAdyenPaymentMethodsArgs = {
  cart_id: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  shopper_locale?: InputMaybe<Scalars['String']>;
};


export type QueryAdyenPaymentMethodsBalanceArgs = {
  payload: Scalars['String'];
};


export type QueryAdyenPaymentStatusArgs = {
  cartId?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
};


export type QueryAdyenRedeemedGiftcardsArgs = {
  cartId: Scalars['String'];
};


export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCartArgs = {
  cart_id: Scalars['String'];
};


export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryUrlsArgs = {
  identifier: Scalars['Int'];
};


export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
};


export type QueryCompareListArgs = {
  uid: Scalars['ID'];
};


export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


export type QueryDynamicBlocksArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<DynamicBlocksFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetHostedProUrlArgs = {
  input: HostedProUrlInput;
};


export type QueryGetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput;
};


export type QueryGiftCardAccountArgs = {
  input: GiftCardAccountInput;
};


export type QueryGiftRegistryArgs = {
  giftRegistryUid: Scalars['ID'];
};


export type QueryGiftRegistryEmailSearchArgs = {
  email: Scalars['String'];
};


export type QueryGiftRegistryIdSearchArgs = {
  giftRegistryUid: Scalars['ID'];
};


export type QueryGiftRegistryTypeSearchArgs = {
  firstName: Scalars['String'];
  giftRegistryTypeUid?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
};


export type QueryIsCompanyAdminEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryIsCompanyEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryIsCompanyRoleNameAvailableArgs = {
  name: Scalars['String'];
};


export type QueryIsCompanyUserEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryNegotiableQuoteArgs = {
  uid: Scalars['ID'];
};


export type QueryNegotiableQuoteTemplateArgs = {
  templateId: Scalars['ID'];
};


export type QueryNegotiableQuoteTemplatesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NegotiableQuoteTemplateFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<NegotiableQuoteTemplateSortInput>;
};


export type QueryNegotiableQuotesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NegotiableQuoteFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<NegotiableQuoteSortInput>;
};


export type QueryOrderDataArgs = {
  order_id: Scalars['String'];
};


export type QueryProductUrlsArgs = {
  identifier: Scalars['Int'];
};


export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryRouteArgs = {
  url: Scalars['String'];
};


export type QueryUrlResolverArgs = {
  url: Scalars['String'];
};

/** Sets quote item note. */
export type QuoteTemplateLineItemNoteInput = {
  /** The unique ID of a `CartLineItem` object. */
  item_id: Scalars['ID'];
  /** The note text to be added. */
  note?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  templateId: Scalars['ID'];
};

/** Contains a notification message for a negotiable quote template. */
export type QuoteTemplateNotificationMessage = {
  __typename?: 'QuoteTemplateNotificationMessage';
  /** The notification message. */
  message: Scalars['String'];
  /** The type of notification message. */
  type: Scalars['String'];
};

export type Region = {
  __typename?: 'Region';
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']>;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']>;
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>;
};

/** Defines the input required to run the `removeGiftCardFromCart` mutation. */
export type RemoveGiftCardFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
  /** The gift card code to be removed to the cart. */
  gift_card_code: Scalars['String'];
};

/** Defines the possible output for the `removeGiftCardFromCart` mutation. */
export type RemoveGiftCardFromCartOutput = {
  __typename?: 'RemoveGiftCardFromCartOutput';
  /** The contents of the specified shopping cart. */
  cart: Cart;
};

/** Contains the results of a request to remove an item from a gift registry. */
export type RemoveGiftRegistryItemsOutput = {
  __typename?: 'RemoveGiftRegistryItemsOutput';
  /** The gift registry after removing items. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Contains the results of a request to delete a gift registry. */
export type RemoveGiftRegistryOutput = {
  __typename?: 'RemoveGiftRegistryOutput';
  /** Indicates whether the gift registry was successfully deleted. */
  success: Scalars['Boolean'];
};

/** Contains the results of a request to delete a registrant. */
export type RemoveGiftRegistryRegistrantsOutput = {
  __typename?: 'RemoveGiftRegistryRegistrantsOutput';
  /** The gift registry after deleting registrants. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
};

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  /** The cart after removing an item. */
  cart: Cart;
};

/** Defines the items to remove from the specified negotiable quote. */
export type RemoveNegotiableQuoteItemsInput = {
  /** An array of IDs indicating which items to remove from the negotiable quote. */
  quote_item_uids: Array<InputMaybe<Scalars['ID']>>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains the negotiable quote. */
export type RemoveNegotiableQuoteItemsOutput = {
  __typename?: 'RemoveNegotiableQuoteItemsOutput';
  /** The negotiable quote after removing items. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines the items to remove from the specified negotiable quote. */
export type RemoveNegotiableQuoteTemplateItemsInput = {
  /** An array of IDs indicating which items to remove from the negotiable quote. */
  item_uids: Array<InputMaybe<Scalars['ID']>>;
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID'];
};

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput';
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist;
};

/** Defines the tracking information to delete. */
export type RemoveReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingTracking` object. */
  return_shipping_tracking_uid: Scalars['ID'];
};

/** Contains the response after deleting tracking information. */
export type RemoveReturnTrackingOutput = {
  __typename?: 'RemoveReturnTrackingOutput';
  /** Contains details about the modified return. */
  return?: Maybe<Return>;
};

/** Contains the customer cart. */
export type RemoveRewardPointsFromCartOutput = {
  __typename?: 'RemoveRewardPointsFromCartOutput';
  /** The customer cart after reward points are removed. */
  cart: Cart;
};

/** Defines the input required to run the `removeStoreCreditFromCart` mutation. */
export type RemoveStoreCreditFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String'];
};

/** Defines the possible output for the `removeStoreCreditFromCart` mutation. */
export type RemoveStoreCreditFromCartOutput = {
  __typename?: 'RemoveStoreCreditFromCartOutput';
  /** The contents of the specified shopping cart. */
  cart: Cart;
};

/** Sets new name for a negotiable quote. */
export type RenameNegotiableQuoteInput = {
  /** The reason for the quote name change specified by the buyer. */
  quote_comment?: InputMaybe<Scalars['String']>;
  /** The new quote name the buyer specified to the negotiable quote request. */
  quote_name: Scalars['String'];
  /** The cart ID of the buyer requesting a new negotiable quote. */
  quote_uid: Scalars['ID'];
};

/** Contains the updated negotiable quote. */
export type RenameNegotiableQuoteOutput = {
  __typename?: 'RenameNegotiableQuoteOutput';
  /** The negotiable quote after updating the name. */
  quote?: Maybe<NegotiableQuote>;
};

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput';
  /** Detailed information about the customer's cart. */
  cart: Cart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>;
};

/** Defines properties of a negotiable quote request. */
export type RequestNegotiableQuoteInput = {
  /** The cart ID of the buyer requesting a new negotiable quote. */
  cart_id: Scalars['ID'];
  /** Comments the buyer entered to describe the request. */
  comment: NegotiableQuoteCommentInput;
  /** Flag indicating if quote is draft or not. */
  is_draft?: InputMaybe<Scalars['Boolean']>;
  /** The name the buyer assigned to the negotiable quote request. */
  quote_name: Scalars['String'];
};

/** Contains the `NegotiableQuote` object generated when a buyer requests a negotiable quote. */
export type RequestNegotiableQuoteOutput = {
  __typename?: 'RequestNegotiableQuoteOutput';
  /** Details about the negotiable quote. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines properties of a negotiable quote template request. */
export type RequestNegotiableQuoteTemplateInput = {
  /** The cart ID of the quote to create the new negotiable quote template from. */
  cart_id: Scalars['ID'];
};

/** Contains information needed to start a return request. */
export type RequestReturnInput = {
  /** Text the buyer entered that describes the reason for the refund request. */
  comment_text?: InputMaybe<Scalars['String']>;
  /** The email address the buyer enters to receive notifications about the status of the return. */
  contact_email?: InputMaybe<Scalars['String']>;
  /** An array of items to be returned. */
  items: Array<InputMaybe<RequestReturnItemInput>>;
  /** The unique ID for a `Order` object. */
  order_uid: Scalars['ID'];
};

/** Contains details about an item to be returned. */
export type RequestReturnItemInput = {
  /** Details about a custom attribute that was entered. */
  entered_custom_attributes?: InputMaybe<Array<InputMaybe<EnteredCustomAttributeInput>>>;
  /** The unique ID for a `OrderItemInterface` object. */
  order_item_uid: Scalars['ID'];
  /** The quantity of the item to be returned. */
  quantity_to_return: Scalars['Float'];
  /** An array of selected custom option IDs associated with the item to be returned. For example, the IDs for the selected color and size of a configurable product. */
  selected_custom_attributes?: InputMaybe<Array<InputMaybe<SelectedCustomAttributeInput>>>;
};

/** Contains the response to a return request. */
export type RequestReturnOutput = {
  __typename?: 'RequestReturnOutput';
  /** Details about a single return request. */
  return?: Maybe<Return>;
  /** An array of return requests. */
  returns?: Maybe<Returns>;
};


/** Contains the response to a return request. */
export type RequestReturnOutputReturnsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines the contents of a requisition list. */
export type RequisitionList = {
  __typename?: 'RequisitionList';
  /** Optional text that describes the requisition list. */
  description?: Maybe<Scalars['String']>;
  /** An array of products added to the requisition list. */
  items?: Maybe<RequistionListItems>;
  /** The number of items in the list. */
  items_count: Scalars['Int'];
  /** The requisition list name. */
  name: Scalars['String'];
  /** The unique requisition list ID. */
  uid: Scalars['ID'];
  /** The time of the last modification of the requisition list. */
  updated_at?: Maybe<Scalars['String']>;
};


/** Defines the contents of a requisition list. */
export type RequisitionListItemsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines requisition list filters. */
export type RequisitionListFilterInput = {
  /** Filter by the display name of the requisition list. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter requisition lists by one or more requisition list IDs. */
  uids?: InputMaybe<FilterEqualTypeInput>;
};

/** The interface for requisition list items. */
export type RequisitionListItemInterface = {
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The amount added. */
  quantity: Scalars['Float'];
  /** The unique ID for the requisition list item. */
  uid: Scalars['ID'];
};

/** Defines the items to add. */
export type RequisitionListItemsInput = {
  /** Entered option IDs. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For configurable products, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The quantity of the product to add. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** Selected option IDs. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The product SKU. */
  sku: Scalars['String'];
};

/** Defines customer requisition lists. */
export type RequisitionLists = {
  __typename?: 'RequisitionLists';
  /** An array of requisition lists. */
  items?: Maybe<Array<Maybe<RequisitionList>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of returned requisition lists. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains an array of items added to a requisition list. */
export type RequistionListItems = {
  __typename?: 'RequistionListItems';
  /** An array of items in the requisition list. */
  items: Array<Maybe<RequisitionListItemInterface>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of pages returned. */
  total_pages: Scalars['Int'];
};

/** Contains details about a return. */
export type Return = {
  __typename?: 'Return';
  /** A list of shipping carriers available for returns. */
  available_shipping_carriers?: Maybe<Array<Maybe<ReturnShippingCarrier>>>;
  /** A list of comments posted for the return request. */
  comments?: Maybe<Array<Maybe<ReturnComment>>>;
  /** The date the return was requested. */
  created_at: Scalars['String'];
  /** Data from the customer who created the return request. */
  customer: ReturnCustomer;
  /** A list of items being returned. */
  items?: Maybe<Array<Maybe<ReturnItem>>>;
  /** A human-readable return number. */
  number: Scalars['String'];
  /** The order associated with the return. */
  order?: Maybe<CustomerOrder>;
  /** Shipping information for the return. */
  shipping?: Maybe<ReturnShipping>;
  /** The status of the return request. */
  status?: Maybe<ReturnStatus>;
  /** The unique ID for a `Return` object. */
  uid: Scalars['ID'];
};

/** Contains details about a return comment. */
export type ReturnComment = {
  __typename?: 'ReturnComment';
  /** The name or author who posted the comment. */
  author_name: Scalars['String'];
  /** The date and time the comment was posted. */
  created_at: Scalars['String'];
  /** The contents of the comment. */
  text: Scalars['String'];
  /** The unique ID for a `ReturnComment` object. */
  uid: Scalars['ID'];
};

/** Contains details about a `ReturnCustomerAttribute` object. */
export type ReturnCustomAttribute = {
  __typename?: 'ReturnCustomAttribute';
  /** A description of the attribute. */
  label: Scalars['String'];
  /** The unique ID for a `ReturnCustomAttribute` object. */
  uid: Scalars['ID'];
  /** A JSON-encoded value of the attribute. */
  value: Scalars['String'];
};

/** The customer information for the return. */
export type ReturnCustomer = {
  __typename?: 'ReturnCustomer';
  /** The email address of the customer. */
  email: Scalars['String'];
  /** The first name of the customer. */
  firstname?: Maybe<Scalars['String']>;
  /** The last name of the customer. */
  lastname?: Maybe<Scalars['String']>;
};

/** Contains details about a product being returned. */
export type ReturnItem = {
  __typename?: 'ReturnItem';
  /** Return item custom attributes that are visible on the storefront. */
  custom_attributes?: Maybe<Array<Maybe<ReturnCustomAttribute>>>;
  /** Provides access to the product being returned, including information about selected and entered options. */
  order_item: OrderItemInterface;
  /** The quantity of the item the merchant authorized to be returned. */
  quantity: Scalars['Float'];
  /** The quantity of the item requested to be returned. */
  request_quantity: Scalars['Float'];
  /** The return status of the item. */
  status: ReturnItemStatus;
  /** The unique ID for a `ReturnItem` object. */
  uid: Scalars['ID'];
};

export enum ReturnItemStatus {
  /** @deprecated  */
  Approved = 'APPROVED',
  /** @deprecated  */
  Authorized = 'AUTHORIZED',
  /** @deprecated  */
  Denied = 'DENIED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  Received = 'RECEIVED',
  /** @deprecated  */
  Rejected = 'REJECTED'
}

/** Contains details about the return shipping address. */
export type ReturnShipping = {
  __typename?: 'ReturnShipping';
  /** The merchant-defined return shipping address. */
  address?: Maybe<ReturnShippingAddress>;
  /** The unique ID for a `ReturnShippingTracking` object. If a single UID is specified, the array contains a single tracking record. Otherwise, array contains all tracking information. */
  tracking?: Maybe<Array<Maybe<ReturnShippingTracking>>>;
};


/** Contains details about the return shipping address. */
export type ReturnShippingTrackingArgs = {
  uid?: InputMaybe<Scalars['ID']>;
};

/** Contains details about the shipping address used for receiving returned items. */
export type ReturnShippingAddress = {
  __typename?: 'ReturnShippingAddress';
  /** The city for product returns. */
  city: Scalars['String'];
  /** The merchant's contact person. */
  contact_name?: Maybe<Scalars['String']>;
  /** An object that defines the country for product returns. */
  country: Country;
  /** The postal code for product returns. */
  postcode: Scalars['String'];
  /** An object that defines the state or province for product returns. */
  region: Region;
  /** The street address for product returns. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for product returns. */
  telephone?: Maybe<Scalars['String']>;
};

/** Contains details about the carrier on a return. */
export type ReturnShippingCarrier = {
  __typename?: 'ReturnShippingCarrier';
  /** A description of the shipping carrier. */
  label: Scalars['String'];
  /** The unique ID for a `ReturnShippingCarrier` object assigned to the shipping carrier. */
  uid: Scalars['ID'];
};

/** Contains shipping and tracking details. */
export type ReturnShippingTracking = {
  __typename?: 'ReturnShippingTracking';
  /** Contains details of a shipping carrier. */
  carrier: ReturnShippingCarrier;
  /** Details about the status of a shipment. */
  status?: Maybe<ReturnShippingTrackingStatus>;
  /** A tracking number assigned by the carrier. */
  tracking_number: Scalars['String'];
  /** The unique ID for a `ReturnShippingTracking` object assigned to the tracking item. */
  uid: Scalars['ID'];
};

/** Contains the status of a shipment. */
export type ReturnShippingTrackingStatus = {
  __typename?: 'ReturnShippingTrackingStatus';
  /** Text that describes the status. */
  text: Scalars['String'];
  /** Indicates whether the status type is informational or an error. */
  type: ReturnShippingTrackingStatusType;
};

export enum ReturnShippingTrackingStatusType {
  /** @deprecated  */
  Error = 'ERROR',
  /** @deprecated  */
  Information = 'INFORMATION'
}

export enum ReturnStatus {
  /** @deprecated  */
  Approved = 'APPROVED',
  /** @deprecated  */
  Authorized = 'AUTHORIZED',
  /** @deprecated  */
  Closed = 'CLOSED',
  /** @deprecated  */
  Denied = 'DENIED',
  /** @deprecated  */
  PartiallyApproved = 'PARTIALLY_APPROVED',
  /** @deprecated  */
  PartiallyAuthorized = 'PARTIALLY_AUTHORIZED',
  /** @deprecated  */
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  /** @deprecated  */
  PartiallyRejected = 'PARTIALLY_REJECTED',
  /** @deprecated  */
  Pending = 'PENDING',
  /** @deprecated  */
  ProcessedAndClosed = 'PROCESSED_AND_CLOSED',
  /** @deprecated  */
  Received = 'RECEIVED',
  /** @deprecated  */
  Rejected = 'REJECTED'
}

/** Contains a list of customer return requests. */
export type Returns = {
  __typename?: 'Returns';
  /** A list of return requests. */
  items?: Maybe<Array<Maybe<Return>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of return requests. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean'];
};

/** Contains details about a customer's reward points. */
export type RewardPoints = {
  __typename?: 'RewardPoints';
  /** The current balance of reward points. */
  balance?: Maybe<RewardPointsAmount>;
  /** The balance history of reward points. If the ability for customers to view the balance history has been disabled in the Admin, this field will be set to null. */
  balance_history?: Maybe<Array<Maybe<RewardPointsBalanceHistoryItem>>>;
  /** The current exchange rates for reward points. */
  exchange_rates?: Maybe<RewardPointsExchangeRates>;
  /** The subscription status of emails related to reward points. */
  subscription_status?: Maybe<RewardPointsSubscriptionStatus>;
};

export type RewardPointsAmount = {
  __typename?: 'RewardPointsAmount';
  /** The reward points amount in store currency. */
  money: Money;
  /** The reward points amount in points. */
  points: Scalars['Float'];
};

/** Contain details about the reward points transaction. */
export type RewardPointsBalanceHistoryItem = {
  __typename?: 'RewardPointsBalanceHistoryItem';
  /** The award points balance after the completion of the transaction. */
  balance?: Maybe<RewardPointsAmount>;
  /** The reason the balance changed. */
  change_reason: Scalars['String'];
  /** The date of the transaction. */
  date: Scalars['String'];
  /** The number of points added or deducted in the transaction. */
  points_change: Scalars['Float'];
};

/** Lists the reward points exchange rates. The values depend on the customer group. */
export type RewardPointsExchangeRates = {
  __typename?: 'RewardPointsExchangeRates';
  /** How many points are earned for a given amount spent. */
  earning?: Maybe<RewardPointsRate>;
  /** How many points must be redeemed to get a given amount of currency discount at the checkout. */
  redemption?: Maybe<RewardPointsRate>;
};

/** Contains details about customer's reward points rate. */
export type RewardPointsRate = {
  __typename?: 'RewardPointsRate';
  /** The money value for the exchange rate. For earnings, this is the amount spent to earn the specified points. For redemption, this is the amount of money the number of points represents. */
  currency_amount: Scalars['Float'];
  /** The number of points for an exchange rate. For earnings, this is the number of points earned. For redemption, this is the number of points needed for redemption. */
  points: Scalars['Float'];
};

/** Indicates whether the customer subscribes to reward points emails. */
export type RewardPointsSubscriptionStatus = {
  __typename?: 'RewardPointsSubscriptionStatus';
  /** Indicates whether the customer subscribes to 'Reward points balance updates' emails. */
  balance_updates: RewardPointsSubscriptionStatusesEnum;
  /** Indicates whether the customer subscribes to 'Reward points expiration notifications' emails. */
  points_expiration_notifications: RewardPointsSubscriptionStatusesEnum;
};

export enum RewardPointsSubscriptionStatusesEnum {
  /** @deprecated  */
  NotSubscribed = 'NOT_SUBSCRIBED',
  /** @deprecated  */
  Subscribed = 'SUBSCRIBED'
}

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String'];
};

export type SalesItemInterface = {
  __typename?: 'SalesItemInterface';
  /** The entered gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
};

/** This enumeration defines the scope type for customer orders. */
export enum ScopeTypeEnum {
  /** @deprecated  */
  Global = 'GLOBAL',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  Website = 'WEBSITE'
}

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']>;
};

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** The search suggestion of existing product. */
  search: Scalars['String'];
};

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  /** @deprecated Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the selected bundle product option. */
  label: Scalars['String'];
  /** The type of selected bundle product option. */
  type: Scalars['String'];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID'];
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  /** Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String'];
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float'];
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float'];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID'];
};

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID'];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int'];
  /** The display text for the option. */
  option_label: Scalars['String'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int'];
  /** The display name of the selected configurable option. */
  value_label: Scalars['String'];
};

/** Contains details about an attribute the buyer selected. */
export type SelectedCustomAttributeInput = {
  /** A string that identifies the selected attribute. */
  attribute_code: Scalars['String'];
  /** The unique ID for a `CustomAttribute` object of a selected custom attribute. */
  value: Scalars['ID'];
};

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int'];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean'];
  /** The display name of the selected customizable option. */
  label: Scalars['String'];
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int'];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String'];
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int'];
  /** The display name of the selected value. */
  label: Scalars['String'];
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars['String'];
};

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']>;
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String'];
  /** The label for the method code. */
  method_title: Scalars['String'];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

/** Defines the referenced product and the email sender and recipients. */
export type SendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars['Int'];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<SendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: SendEmailToFriendSenderInput;
};

/** Contains information about the sender and recipients. */
export type SendEmailToFriendOutput = {
  __typename?: 'SendEmailToFriendOutput';
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender?: Maybe<SendEmailToFriendSender>;
};

/** An output object that contains information about the recipient. */
export type SendEmailToFriendRecipient = {
  __typename?: 'SendEmailToFriendRecipient';
  /** The email address of the recipient. */
  email: Scalars['String'];
  /** The name of the recipient. */
  name: Scalars['String'];
};

/** Contains details about a recipient. */
export type SendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars['String'];
  /** The name of the recipient. */
  name: Scalars['String'];
};

/** An output object that contains information about the sender. */
export type SendEmailToFriendSender = {
  __typename?: 'SendEmailToFriendSender';
  /** The email address of the sender. */
  email: Scalars['String'];
  /** The text of the message to be sent. */
  message: Scalars['String'];
  /** The name of the sender. */
  name: Scalars['String'];
};

/** Contains details about the sender. */
export type SendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars['String'];
  /** The text of the message to be sent. */
  message: Scalars['String'];
  /** The name of the sender. */
  name: Scalars['String'];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type SendFriendConfiguration = {
  __typename?: 'SendFriendConfiguration';
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars['Boolean'];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars['Boolean'];
};

/** Specifies which negotiable quote to send for review. */
export type SendNegotiableQuoteForReviewInput = {
  /** A comment for the seller to review. */
  comment?: InputMaybe<NegotiableQuoteCommentInput>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains the negotiable quote. */
export type SendNegotiableQuoteForReviewOutput = {
  __typename?: 'SendNegotiableQuoteForReviewOutput';
  /** The negotiable quote after sending for seller review. */
  quote?: Maybe<NegotiableQuote>;
};

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  /** The cart after setting the billing address. */
  cart: Cart;
};

/** Defines the gift options applied to the cart. */
export type SetGiftOptionsOnCartInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String'];
  /** Gift message details for the cart. */
  gift_message?: InputMaybe<GiftMessageInput>;
  /** Whether customer requested gift receipt for the cart. */
  gift_receipt_included: Scalars['Boolean'];
  /** The unique ID for a `GiftWrapping` object to be used for the cart. */
  gift_wrapping_id?: InputMaybe<Scalars['ID']>;
  /** Whether customer requested printed card for the cart. */
  printed_card_included: Scalars['Boolean'];
};

/** Contains the cart after gift options have been applied. */
export type SetGiftOptionsOnCartOutput = {
  __typename?: 'SetGiftOptionsOnCartOutput';
  /** The modified cart object. */
  cart: Cart;
};

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The email address of the guest. */
  email: Scalars['String'];
};

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  /** The cart after setting the guest email. */
  cart: Cart;
};

/** Contains the updated negotiable quote. */
export type SetLineItemNoteOutput = {
  __typename?: 'SetLineItemNoteOutput';
  /** The negotiable quote after sending for seller review. */
  quote?: Maybe<NegotiableQuote>;
};

/** Sets the billing address. */
export type SetNegotiableQuoteBillingAddressInput = {
  /** The billing address to be added. */
  billing_address: NegotiableQuoteBillingAddressInput;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains the negotiable quote. */
export type SetNegotiableQuoteBillingAddressOutput = {
  __typename?: 'SetNegotiableQuoteBillingAddressOutput';
  /** The negotiable quote after assigning a billing address. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines the payment method of the specified negotiable quote. */
export type SetNegotiableQuotePaymentMethodInput = {
  /** The payment method to be assigned to the negotiable quote. */
  payment_method: NegotiableQuotePaymentMethodInput;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains details about the negotiable quote after setting the payment method. */
export type SetNegotiableQuotePaymentMethodOutput = {
  __typename?: 'SetNegotiableQuotePaymentMethodOutput';
  /** The updated negotiable quote. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines the shipping address to assign to the negotiable quote. */
export type SetNegotiableQuoteShippingAddressInput = {
  /** The unique ID of a `CustomerAddress` object. */
  customer_address_id?: InputMaybe<Scalars['ID']>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
  /** An array of shipping addresses to apply to the negotiable quote. */
  shipping_addresses?: InputMaybe<Array<InputMaybe<NegotiableQuoteShippingAddressInput>>>;
};

/** Contains the negotiable quote. */
export type SetNegotiableQuoteShippingAddressOutput = {
  __typename?: 'SetNegotiableQuoteShippingAddressOutput';
  /** The negotiable quote after assigning a shipping address. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines the shipping method to apply to the negotiable quote. */
export type SetNegotiableQuoteShippingMethodsInput = {
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
  /** An array of shipping methods to apply to the negotiable quote. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Contains the negotiable quote. */
export type SetNegotiableQuoteShippingMethodsOutput = {
  __typename?: 'SetNegotiableQuoteShippingMethodsOutput';
  /** The negotiable quote after applying shipping methods. */
  quote?: Maybe<NegotiableQuote>;
};

/** Defines the shipping address to assign to the negotiable quote template. */
export type SetNegotiableQuoteTemplateShippingAddressInput = {
  /** A shipping adadress to apply to the negotiable quote template. */
  shipping_address: NegotiableQuoteTemplateShippingAddressInput;
  /** The unique ID of a `NegotiableQuote` object. */
  template_id: Scalars['ID'];
};

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  /** The cart after setting the payment method. */
  cart: Cart;
};

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  /** The cart after setting the shipping addresses. */
  cart: Cart;
};

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  /** The cart after setting the shipping methods. */
  cart: Cart;
};

/** Defines a gift registry invitee. */
export type ShareGiftRegistryInviteeInput = {
  /** The email address of the gift registry invitee. */
  email: Scalars['String'];
  /** The name of the gift registry invitee. */
  name: Scalars['String'];
};

/** Contains the results of a request to share a gift registry. */
export type ShareGiftRegistryOutput = {
  __typename?: 'ShareGiftRegistryOutput';
  /** Indicates whether the gift registry was successfully shared. */
  is_shared: Scalars['Boolean'];
};

/** Defines the sender of an invitation to view a gift registry. */
export type ShareGiftRegistrySenderInput = {
  /** A brief message from the sender. */
  message: Scalars['String'];
  /** The sender of the gift registry invitation. */
  name: Scalars['String'];
};

/** Defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  /** @deprecated  */
  Separately = 'SEPARATELY',
  /** @deprecated  */
  Together = 'TOGETHER'
}

export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem';
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']>;
  /** The shipment tracking title. */
  title: Scalars['String'];
};

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']>;
};

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String'];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String'];
};

/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<GiftWrapping>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<GiftWrapping>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'SimpleProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains details about simple products added to a requisition list. */
export type SimpleRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'SimpleRequisitionListItem';
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The amount added. */
  quantity: Scalars['Float'];
  /** The unique ID for the requisition list item. */
  uid: Scalars['ID'];
};

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Indicates whether to return results in ascending or descending order. */
export enum SortEnum {
  /** @deprecated  */
  Asc = 'ASC',
  /** @deprecated  */
  Desc = 'DESC'
}

/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField';
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** The default sort field value. */
  default?: Maybe<Scalars['String']>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

export type SovendusData = {
  __typename?: 'SovendusData';
  trafficMediumNumber: Scalars['String'];
  trafficSourceNumber: Scalars['String'];
};

/** The type contains information about a store config */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']>;
  /** Adyen front end resources region. */
  adyen_checkout_frontend_region?: Maybe<Scalars['String']>;
  /** Adyen client key for LIVE environment. */
  adyen_client_key_live?: Maybe<Scalars['String']>;
  /** Adyen client key for TEST environment. */
  adyen_client_key_test?: Maybe<Scalars['String']>;
  /** Adyen demo mode enabled (TEST). */
  adyen_demo_mode?: Maybe<Scalars['Boolean']>;
  /** Adyen card holder's name is visible. */
  adyen_has_holder_name?: Maybe<Scalars['Boolean']>;
  /** Adyen card holder's name is required. */
  adyen_holder_name_required?: Maybe<Scalars['Boolean']>;
  /** Adyen Return path in case of error */
  adyen_return_path_error?: Maybe<Scalars['String']>;
  /** Adyen Render Mode for Payment Method. */
  adyen_title_renderer?: Maybe<Scalars['String']>;
  /** Indicates if the gift sender has the option to send a gift receipt. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_receipt?: Maybe<Scalars['String']>;
  /** Indicates whether gift wrapping can be added for the entire order. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order?: Maybe<Scalars['String']>;
  /** Indicates whether gift wrapping can be added for individual order items. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order_items?: Maybe<Scalars['String']>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars['String']>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars['String']>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars['String']>;
  /** Indicates if a printed card can accompany an order. Possible values: 1 (Yes) and 0 (No). */
  allow_printed_card?: Maybe<Scalars['String']>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']>;
  /** Indicates if gift wrapping prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_gift_wrapping?: Maybe<Scalars['String']>;
  /** Indicates if printed card prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_printed_card?: Maybe<Scalars['String']>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']>;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']>;
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']>;
  /** Indicates whether customers can have multiple wish lists. Possible values: 1 (Yes) and 0 (No). */
  enable_multiple_wishlists?: Maybe<Scalars['String']>;
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']>;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']>;
  /** Indicates whether negotiable quote functionality is enabled. */
  is_negotiable_quote_active?: Maybe<Scalars['Boolean']>;
  /** Indicates whether requisition lists are enabled. Possible values: 1 (Yes) and 0 (No). */
  is_requisition_list_active?: Maybe<Scalars['String']>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']>;
  /** The store locale. */
  locale?: Maybe<Scalars['String']>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']>;
  /** Indicates whether reward points functionality is enabled. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled?: Maybe<Scalars['String']>;
  /** Indicates whether reward points functionality is enabled on the storefront. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled_on_front?: Maybe<Scalars['String']>;
  /** The minimum point balance customers must have before they can redeem them. A null value indicates no minimum. */
  magento_reward_general_min_points_balance?: Maybe<Scalars['String']>;
  /** When enabled, customers can see a detailed history of their reward points. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_publish_history?: Maybe<Scalars['String']>;
  /** The number of points for a referral when an invitee registers on the site. */
  magento_reward_points_invitation_customer?: Maybe<Scalars['String']>;
  /** The maximum number of registration referrals that will qualify for rewards. A null value indicates no limit. */
  magento_reward_points_invitation_customer_limit?: Maybe<Scalars['String']>;
  /** The number of points for a referral, when an invitee places their first order on the site. */
  magento_reward_points_invitation_order?: Maybe<Scalars['String']>;
  /** The number of order conversions that can earn points for the customer who sends the invitation. A null value indicates no limit. */
  magento_reward_points_invitation_order_limit?: Maybe<Scalars['String']>;
  /** The number of points earned by registered customers who subscribe to a newsletter. */
  magento_reward_points_newsletter?: Maybe<Scalars['String']>;
  /** Indicates customers earn points for shopping according to the reward point exchange rate. In Luma, this also controls whether to show a message in the shopping cart about the rewards points earned for the purchase, as well as the customer’s current reward point balance. */
  magento_reward_points_order?: Maybe<Scalars['String']>;
  /** The number of points customer gets for registering. */
  magento_reward_points_register?: Maybe<Scalars['String']>;
  /** The number of points for writing a review. */
  magento_reward_points_review?: Maybe<Scalars['String']>;
  /** The maximum number of reviews that will qualify for the rewards. A null value indicates no limit. */
  magento_reward_points_review_limit?: Maybe<Scalars['String']>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']>;
  /** If multiple wish lists are enabled, the maximum number of wish lists the customer can have. */
  maximum_number_of_wishlists?: Maybe<Scalars['String']>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']>;
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']>;
  /** Returns bank account transfer details */
  payment_banktransfer_instructions?: Maybe<Scalars['String']>;
  /** Returns bank account transfer details (for checkout view) */
  payment_banktransfer_instructions_checkout?: Maybe<Scalars['String']>;
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars['String']>;
  /** The default price of a printed card that accompanies an order. */
  printed_card_price?: Maybe<Scalars['String']>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars['String']>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']>;
  /** Indicates whether RMA is enabled on the storefront. Possible values: enabled/disabled. */
  returns_enabled: Scalars['String'];
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Indicates if gift wrapping prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_gift_wrapping?: Maybe<Scalars['String']>;
  /** Indicates if printed card prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_printed_card?: Maybe<Scalars['String']>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']>;
  /** Email to a Friend configuration. */
  send_friend?: Maybe<SendFriendConfiguration>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']>;
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars['String']>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']>;
};

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties';
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']>;
};

/** Specifies the quote template properties to update. */
export type SubmitNegotiableQuoteTemplateForReviewInput = {
  /** A comment for the seller to review. */
  comment?: InputMaybe<Scalars['String']>;
  /** Commitment for maximum orders */
  max_order_commitment?: InputMaybe<Scalars['Int']>;
  /** Commitment for minimum orders */
  min_order_commitment?: InputMaybe<Scalars['Int']>;
  /** The title assigned to the negotiable quote template. */
  name?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput';
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export enum SubscriptionStatusesEnum {
  /** @deprecated  */
  NotActive = 'NOT_ACTIVE',
  /** @deprecated  */
  Subscribed = 'SUBSCRIBED',
  /** @deprecated  */
  Unconfirmed = 'UNCONFIRMED',
  /** @deprecated  */
  Unsubscribed = 'UNSUBSCRIBED'
}

/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData';
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']>;
};

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  __typename?: 'SwatchLayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float'];
  /** A title that describes the tax. */
  title: Scalars['String'];
};

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']>;
};

export type TrustedShopsData = {
  __typename?: 'TrustedShopsData';
  tsCheckoutBuyerEmail: Scalars['String'];
  tsCheckoutBuyerId: Scalars['Int'];
  tsCheckoutOrderAmount: Scalars['Float'];
  tsCheckoutOrderCurrency: Scalars['String'];
  tsCheckoutOrderEstDeliveryDate: Scalars['String'];
  tsCheckoutOrderNr: Scalars['String'];
  tsCheckoutOrderPaymentType: Scalars['String'];
};

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  /** The cart after updating products. */
  cart: Cart;
};

/** Contains the response to the request to update the company. */
export type UpdateCompanyOutput = {
  __typename?: 'UpdateCompanyOutput';
  /** The updated company instance. */
  company: Company;
};

/** Contains the response to the request to update the company role. */
export type UpdateCompanyRoleOutput = {
  __typename?: 'UpdateCompanyRoleOutput';
  /** The updated company role instance. */
  role: CompanyRole;
};

/** Contains the response to the request to update the company structure. */
export type UpdateCompanyStructureOutput = {
  __typename?: 'UpdateCompanyStructureOutput';
  /** The updated company instance. */
  company: Company;
};

/** Contains the response to the request to update a company team. */
export type UpdateCompanyTeamOutput = {
  __typename?: 'UpdateCompanyTeamOutput';
  /** The updated company team instance. */
  team: CompanyTeam;
};

/** Contains the response to the request to update the company user. */
export type UpdateCompanyUserOutput = {
  __typename?: 'UpdateCompanyUserOutput';
  /** The updated company user instance. */
  user: Customer;
};

/** Defines updates to a `GiftRegistry` object. */
export type UpdateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. Unspecified dynamic attributes are not changed. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<GiftRegistryDynamicAttributeInput>>>;
  /** The updated name of the event. */
  event_name?: InputMaybe<Scalars['String']>;
  /** The updated message describing the event. */
  message?: InputMaybe<Scalars['String']>;
  /** Indicates whether the gift registry is PRIVATE or PUBLIC. */
  privacy_settings?: InputMaybe<GiftRegistryPrivacySettings>;
  /** The updated shipping address for all gift registry items. */
  shipping_address?: InputMaybe<GiftRegistryShippingAddressInput>;
  /** Indicates whether the gift registry is ACTIVE or INACTIVE. */
  status?: InputMaybe<GiftRegistryStatus>;
};

/** Defines updates to an item in a gift registry. */
export type UpdateGiftRegistryItemInput = {
  /** The unique ID of a `giftRegistryItem` object. */
  gift_registry_item_uid: Scalars['ID'];
  /** The updated description of the item. */
  note?: InputMaybe<Scalars['String']>;
  /** The updated quantity of the gift registry item. */
  quantity: Scalars['Float'];
};

/** Contains the results of a request to update gift registry items. */
export type UpdateGiftRegistryItemsOutput = {
  __typename?: 'UpdateGiftRegistryItemsOutput';
  /** The gift registry after updating updating items. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Contains the results of a request to update a gift registry. */
export type UpdateGiftRegistryOutput = {
  __typename?: 'UpdateGiftRegistryOutput';
  /** The updated gift registry. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Defines updates to an existing registrant. */
export type UpdateGiftRegistryRegistrantInput = {
  /** As a result of the update, only the values of provided attributes will be affected. If the attribute is missing in the request, its value will not be changed. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<GiftRegistryDynamicAttributeInput>>>;
  /** The updated email address of the registrant. */
  email?: InputMaybe<Scalars['String']>;
  /** The updated first name of the registrant. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The unique ID of a `giftRegistryRegistrant` object. */
  gift_registry_registrant_uid: Scalars['ID'];
  /** The updated last name of the registrant. */
  lastname?: InputMaybe<Scalars['String']>;
};

/** Contains the results a request to update registrants. */
export type UpdateGiftRegistryRegistrantsOutput = {
  __typename?: 'UpdateGiftRegistryRegistrantsOutput';
  /** The gift registry after updating registrants. */
  gift_registry?: Maybe<GiftRegistry>;
};

/** Contains the updated negotiable quote. */
export type UpdateNegotiableQuoteItemsQuantityOutput = {
  __typename?: 'UpdateNegotiableQuoteItemsQuantityOutput';
  /** The updated negotiable quote. */
  quote?: Maybe<NegotiableQuote>;
};

/** Specifies the items to update. */
export type UpdateNegotiableQuoteQuantitiesInput = {
  /** An array of items to update. */
  items: Array<InputMaybe<NegotiableQuoteItemQuantityInput>>;
  /** The unique ID of a `NegotiableQuote` object. */
  quote_uid: Scalars['ID'];
};

/** Contains the updated negotiable quote template. */
export type UpdateNegotiableQuoteTemplateItemsQuantityOutput = {
  __typename?: 'UpdateNegotiableQuoteTemplateItemsQuantityOutput';
  /** The updated negotiable quote template. */
  quote_template?: Maybe<NegotiableQuoteTemplate>;
};

/** Specifies the items to update. */
export type UpdateNegotiableQuoteTemplateQuantitiesInput = {
  /** An array of items to update. */
  items: Array<InputMaybe<NegotiableQuoteTemplateItemQuantityInput>>;
  /** The unique ID of a `NegotiableQuoteTemplate` object. */
  template_id: Scalars['ID'];
};

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput';
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist;
};

/** Defines the changes to be made to an approval rule. */
export type UpdatePurchaseOrderApprovalRuleInput = {
  /** An updated list of company user role IDs to which this purchase order approval rule should be applied. When an empty array is provided, the rule is applied to all user roles in the system, including those created in the future. */
  applies_to?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** An updated list of B2B user roles that can approve this purchase order approval rule. */
  approvers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The updated condition of the purchase order approval rule. */
  condition?: InputMaybe<CreatePurchaseOrderApprovalRuleConditionInput>;
  /** The updated approval rule description. */
  description?: InputMaybe<Scalars['String']>;
  /** The updated approval rule name. */
  name?: InputMaybe<Scalars['String']>;
  /** The updated status of the purchase order approval rule. */
  status?: InputMaybe<PurchaseOrderApprovalRuleStatus>;
  /** Unique identifier for the purchase order approval rule. */
  uid: Scalars['ID'];
};

/** An input object that defines which requistion list characteristics to update. */
export type UpdateRequisitionListInput = {
  /** The updated description of the requisition list. */
  description?: InputMaybe<Scalars['String']>;
  /** The new name of the requisition list. */
  name: Scalars['String'];
};

/** Defines which items in a requisition list to update. */
export type UpdateRequisitionListItemsInput = {
  /** An array of customer-entered options. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The ID of the requisition list item to update. */
  item_id: Scalars['ID'];
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** An array of selected option IDs. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Output of the request to update items in the specified requisition list. */
export type UpdateRequisitionListItemsOutput = {
  __typename?: 'UpdateRequisitionListItemsOutput';
  /** The requisition list after updating items. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Output of the request to rename the requisition list. */
export type UpdateRequisitionListOutput = {
  __typename?: 'UpdateRequisitionListOutput';
  /** The renamed requisition list. */
  requisition_list?: Maybe<RequisitionList>;
};

/** Contains the name and visibility of an updated wish list. */
export type UpdateWishlistOutput = {
  __typename?: 'UpdateWishlistOutput';
  /** The wish list name. */
  name: Scalars['String'];
  /** The unique ID of a `Wishlist` object. */
  uid: Scalars['ID'];
  /** Indicates whether the wish list is public or private. */
  visibility: WishlistVisibilityEnum;
};

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars['String']>;
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  /** @deprecated  */
  Category = 'CATEGORY',
  /** @deprecated  */
  CmsPage = 'CMS_PAGE',
  /** @deprecated  */
  Product = 'PRODUCT'
}

/** Defines whether the attribute is filterable in layered navigation. */
export enum UseInLayeredNavigationOptions {
  /** @deprecated  */
  FilterableNoResult = 'FILTERABLE_NO_RESULT',
  /** @deprecated  */
  FilterableWithResults = 'FILTERABLE_WITH_RESULTS',
  /** @deprecated  */
  No = 'NO'
}

/** Defines the input for returning matching companies the customer is assigned to. */
export type UserCompaniesInput = {
  /** Specifies which page of results to return. The default value is 1. */
  currentPage?: InputMaybe<Scalars['Int']>;
  /** Specifies the maximum number of results to return at once. This attribute is optional. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Defines the sorting of the results. */
  sort?: InputMaybe<Array<InputMaybe<CompaniesSortInput>>>;
};

/** An object that contains a list of companies customer is assigned to. */
export type UserCompaniesOutput = {
  __typename?: 'UserCompaniesOutput';
  /** An array of companies customer is assigned to. */
  items: Array<Maybe<CompanyBasicInfo>>;
  /** Provides navigation for the query response. */
  page_info: SearchResultPageInfo;
};

/** Contains details about a failed validation attempt. */
export type ValidatePurchaseOrderError = {
  __typename?: 'ValidatePurchaseOrderError';
  /** The returned error message. */
  message: Scalars['String'];
  /** Error type. */
  type: ValidatePurchaseOrderErrorType;
};

export enum ValidatePurchaseOrderErrorType {
  /** @deprecated  */
  CouldNotSave = 'COULD_NOT_SAVE',
  /** @deprecated  */
  NotFound = 'NOT_FOUND',
  /** @deprecated  */
  NotValidData = 'NOT_VALID_DATA',
  /** @deprecated  */
  OperationNotApplicable = 'OPERATION_NOT_APPLICABLE',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Defines the purchase orders to be validated. */
export type ValidatePurchaseOrdersInput = {
  /** An array of the purchase order IDs. */
  purchase_order_uids: Array<InputMaybe<Scalars['ID']>>;
};

/** Contains the results of validation attempts. */
export type ValidatePurchaseOrdersOutput = {
  __typename?: 'ValidatePurchaseOrdersOutput';
  /** An array of error messages encountered while performing the operation. */
  errors: Array<Maybe<ValidatePurchaseOrderError>>;
  /** An array of the purchase orders in the request. */
  purchase_orders: Array<Maybe<PurchaseOrder>>;
};

/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String'];
};

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Contains discount for quote line item. */
  discount?: Maybe<Array<Maybe<Discount>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** Line item max qty in quote template */
  max_qty?: Maybe<Scalars['Float']>;
  /** Line item min qty in quote template */
  min_qty?: Maybe<Scalars['Float']>;
  /** The buyer's quote line item note. */
  note_from_buyer?: Maybe<Array<Maybe<ItemNote>>>;
  /** The seller's quote line item note. */
  note_from_seller?: Maybe<Array<Maybe<ItemNote>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'VirtualProduct';
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_ar?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_collection?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_color_filter?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_floor_heating?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_form_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_fuellmaterial?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_lifestyle?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_living_area?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_material?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_motive_design?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_height?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pile_material?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_pricegroup_new?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_production_type?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_rueckseite?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_teppichunterlage?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_test_seal?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_verfuegbare_groessen?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_waschbar?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benuta_zusammensetzung?: Maybe<Scalars['Int']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  collections_name?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  eannummer?: Maybe<Scalars['String']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  l_preis?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label_danger?: Maybe<Scalars['Int']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lagerungshinweise?: Maybe<Scalars['String']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** The value assigned to the Only X Left Threshold option in the Admin. */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_count?: Maybe<Scalars['Float']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  reviews_io_score?: Maybe<Scalars['Float']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The stock status of the product. */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  test_special_sortorder?: Maybe<Scalars['Float']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /** @deprecated Use the `custom_attributes` field instead. */
  umsatz?: Maybe<Scalars['Float']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_url?: Maybe<Scalars['String']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  warning_code?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains details about virtual products added to a requisition list. */
export type VirtualRequisitionListItem = RequisitionListItemInterface & {
  __typename?: 'VirtualRequisitionListItem';
  /** Selected custom options for an item in the requisition list. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Details about a requisition list item. */
  product: ProductInterface;
  /** The amount added. */
  quantity: Scalars['Float'];
  /** The unique ID for the requisition list item. */
  uid: Scalars['ID'];
};

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']>;
};

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError';
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

/** A list of possible error types. */
export enum WishListUserInputErrorType {
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist';
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>;
  /** The name of the wish list. */
  name?: Maybe<Scalars['String']>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']>;
  /** Indicates whether the wish list is public or private. */
  visibility: WishlistVisibilityEnum;
};


/** Contains a customer wish list. */
export type WishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError';
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID'];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID'];
};

/** A list of possible error types. */
export enum WishlistCartUserInputErrorType {
  /** @deprecated  */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NotSalable = 'NOT_SALABLE',
  /** @deprecated  */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  Undefined = 'UNDEFINED'
}

/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']>;
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']>;
};

/** Specifies the IDs of items to copy and their quantities. */
export type WishlistItemCopyInput = {
  /** The quantity of this item to copy to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** The unique ID of the `WishlistItemInterface` object to be copied. */
  wishlist_item_id: Scalars['ID'];
};

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of items to add. */
  quantity: Scalars['Float'];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String'];
};

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Specifies the IDs of the items to move and their quantities. */
export type WishlistItemMoveInput = {
  /** The quantity of this item to move to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** The unique ID of the `WishlistItemInterface` object to be moved. */
  wishlist_item_id: Scalars['ID'];
};

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID'];
};

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems';
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput';
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']>;
};

/** Defines the wish list visibility types. */
export enum WishlistVisibilityEnum {
  /** @deprecated  */
  Private = 'PRIVATE',
  /** @deprecated  */
  Public = 'PUBLIC'
}

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']>;
};

export type CreateKlarnaPaymentsSessionInput = {
  cart_id: Scalars['String'];
};

export type IsConfigSettingEnabledOutput = {
  __typename?: 'isConfigSettingEnabledOutput';
  /** Is config setting enabled */
  is_enabled?: Maybe<Scalars['Boolean']>;
};

export type TrackingData = {
  __typename?: 'trackingData';
  /** Is Page Tracking enabled */
  page_tracking_enabled?: Maybe<Scalars['Boolean']>;
  /** Dotdigital region prefix */
  region_prefix?: Maybe<Scalars['String']>;
  /** Is ROI Tracking enabled */
  roi_tracking_enabled?: Maybe<Scalars['Boolean']>;
  /** Web Behaviour Tracking profile ID */
  wbt_profile_id?: Maybe<Scalars['String']>;
};

export type AddStockNotificationMutationVariables = Exact<{
  sku: Scalars['String'];
  storeCode: Scalars['String'];
  email: Scalars['String'];
}>;


export type AddStockNotificationMutation = { __typename?: 'Mutation', addStockNotification: boolean };

export type AddToCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  cartItems: Array<CartItemInput> | CartItemInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', addProductsToCart?: { __typename?: 'AddProductsToCartOutput', cart: { __typename?: 'Cart', items?: Array<{ __typename?: 'BundleCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | { __typename?: 'ConfigurableCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | { __typename?: 'DownloadableCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | { __typename?: 'GiftCardCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | { __typename?: 'SimpleCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | { __typename?: 'VirtualCartItem', uid: string, product: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } } | null> | null }, user_errors: Array<{ __typename?: 'CartUserInputError', code: CartUserInputErrorType, message: string } | null> } | null };

export type AddToWishlistMutationVariables = Exact<{
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemInput> | WishlistItemInput;
}>;


export type AddToWishlistMutation = { __typename?: 'Mutation', addProductsToWishlist?: { __typename?: 'AddProductsToWishlistOutput', user_errors: Array<{ __typename?: 'WishListUserInputError', code: WishListUserInputErrorType, message: string } | null> } | null };

export type AdyenPaymentDetailsMutationVariables = Exact<{
  payload: Scalars['String'];
  cartId: Scalars['String'];
}>;


export type AdyenPaymentDetailsMutation = { __typename?: 'Mutation', adyenPaymentDetails?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null };

export type AggregationsQueryVariables = Exact<{
  filter?: InputMaybe<ProductAttributeFilterInput>;
}>;


export type AggregationsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', label?: string | null, value: string } | null> | null } | null> | null } | null };

export type ApplyCouponToCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  couponCode: Scalars['String'];
}>;


export type ApplyCouponToCartMutation = { __typename?: 'Mutation', applyCouponToCart?: { __typename?: 'ApplyCouponToCartOutput', cart: { __typename?: 'Cart', applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null } } | null };

export type CartQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, email?: string | null, total_quantity: number, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null, items?: Array<{ __typename?: 'BundleCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename: 'ConfigurableCartItem', quantity: number, uid: string, configurable_options: Array<{ __typename?: 'SelectedConfigurableOption', value_label: string } | null>, configured_variant: { __typename?: 'BundleProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'ConfigurableProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'DownloadableProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'GiftCardProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'GroupedProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'SimpleProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'VirtualProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'DownloadableCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'GiftCardCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'SimpleCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'VirtualCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null } } | null> | null } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, stock_status?: ProductStockStatus | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | null> | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', firstname: string, lastname: string, street: Array<string | null>, city: string, postcode?: string | null, customer_notes?: string | null, telephone?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string }, selected_shipping_method?: { __typename?: 'SelectedShippingMethod', carrier_code: string, method_code: string, method_title: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, available_shipping_methods?: Array<{ __typename?: 'AvailableShippingMethod', available: boolean, carrier_code: string, carrier_title: string, error_message?: string | null, method_code?: string | null, method_title?: string | null, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, price_excl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, price_incl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null>, billing_address?: { __typename?: 'BillingCartAddress', firstname: string, lastname: string, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string } } | null, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string } | null, prices?: { __typename?: 'CartPrices', subtotal_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, subtotal_excluding_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, grand_total?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, applied_taxes?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null } | null };

export type CartPageQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CartPageQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null, prices?: { __typename?: 'CartPrices', subtotal_including_tax?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null, grand_total?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null, applied_taxes?: Array<{ __typename?: 'CartTaxItem', amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', country: { __typename?: 'CartAddressCountry', label: string }, selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_code: string, method_title: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, available_shipping_methods?: Array<{ __typename?: 'AvailableShippingMethod', available: boolean, carrier_code: string, carrier_title: string, error_message?: string | null, method_code?: string | null, method_title?: string | null, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, price_excl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, price_incl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null>, items?: Array<{ __typename: 'BundleCartItem', uid: string, quantity: number, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | { __typename: 'ConfigurableCartItem', uid: string, quantity: number, configurable_options: Array<{ __typename?: 'SelectedConfigurableOption', option_label: string, value_label: string, value_id: number } | null>, configured_variant: { __typename?: 'BundleProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'ConfigurableProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'DownloadableProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GiftCardProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GroupedProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'SimpleProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'VirtualProduct', eannummer?: string | null, sku?: string | null, only_x_left_in_stock?: number | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } }, product: { __typename?: 'BundleProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'ConfigurableProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'GiftCardProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'GroupedProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'SimpleProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null } | { __typename?: 'VirtualProduct', eannummer?: string | null, sku?: string | null, name?: string | null, url_key?: string | null, stock_status?: ProductStockStatus | null, only_x_left_in_stock?: number | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', label?: string | null, url?: string | null } | null }, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | { __typename: 'DownloadableCartItem', uid: string, quantity: number, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | { __typename: 'GiftCardCartItem', uid: string, quantity: number, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | { __typename: 'SimpleCartItem', uid: string, quantity: number, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | { __typename: 'VirtualCartItem', uid: string, quantity: number, prices?: { __typename?: 'CartItemPrices', row_total_including_tax: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null } | null } | null> | null } | null };

export type CartPreviewProductQueryVariables = Exact<{
  sku: Scalars['String'];
}>;


export type CartPreviewProductQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, items?: Array<{ __typename?: 'BundleProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string } | null> | null, product?: { __typename?: 'SimpleProduct', attribute_set_id?: number | null, uid: string, name?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | null };

export type CartSelectedShippingQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CartSelectedShippingQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_code: string, method_title: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null } | null> } | null };

export type CategoriesQueryVariables = Exact<{
  uid: Scalars['String'];
}>;


export type CategoriesQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', name?: string | null, product_count?: number | null, meta_title?: string | null, meta_description?: string | null, uid: string } | null> | null };

export type CategoryUrlsQueryVariables = Exact<{
  identifier: Scalars['Int'];
}>;


export type CategoryUrlsQuery = { __typename?: 'Query', categoryUrls: Array<string | null> };

export type ChangeCustomerPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangeCustomerPasswordMutation = { __typename?: 'Mutation', changeCustomerPassword?: { __typename?: 'Customer', status?: CompanyUserStatusEnum | null } | null };

export type CmsPageFragment = { __typename?: 'CmsPage', identifier?: string | null, url_key?: string | null, title?: string | null, content?: string | null, content_heading?: string | null, page_layout?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keywords?: string | null };

export type ConfirmNewsletterRegistrationMutationVariables = Exact<{
  id: Scalars['Int'];
  code: Scalars['String'];
}>;


export type ConfirmNewsletterRegistrationMutation = { __typename?: 'Mutation', confirmNewsletterRegistration: boolean };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', two_letter_abbreviation?: string | null, full_name_english?: string | null, full_name_locale?: string | null, default?: boolean | null } | null> | null };

export type CreateCustomerMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  is_subscribed: Scalars['Boolean'];
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomerV2?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, is_subscribed?: boolean | null } } | null };

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CustomerAddressInput;
}>;


export type CreateCustomerAddressMutation = { __typename?: 'Mutation', createCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, company?: string | null, country_code?: CountryCodeEnum | null, default_billing?: boolean | null, default_shipping?: boolean | null, firstname?: string | null, lastname?: string | null, postcode?: string | null, prefix?: string | null, street?: Array<string | null> | null, telephone?: string | null, vat_id?: string | null } | null };

export type CreateEmptyCartMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateEmptyCartMutation = { __typename?: 'Mutation', createEmptyCart?: string | null };

export type CreateKlarnaPaymentsSessionMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CreateKlarnaPaymentsSessionMutation = { __typename?: 'Mutation', createKlarnaPaymentsSession?: { __typename?: 'CreateKlarnaPaymentsSessionOutput', client_token?: string | null, payment_method_categories?: Array<{ __typename?: 'Categories', identifier: string, name: string } | null> | null } | null };

export type CreatePaypalExpressTokenMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CreatePaypalExpressTokenMutation = { __typename?: 'Mutation', createPaypalExpressToken?: { __typename?: 'PaypalExpressTokenOutput', token?: string | null, paypal_urls?: { __typename?: 'PaypalExpressUrlList', start?: string | null, edit?: string | null } | null } | null };

export type CrossSellProductsQueryVariables = Exact<{
  skus: Array<Scalars['String']> | Scalars['String'];
}>;


export type CrossSellProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null, attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', label?: string | null, uid: string } | null> | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null, manufacturer?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | null };

export type CustomAttributeMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomAttributeMetadataQuery = { __typename?: 'Query', customAttributeMetadata?: { __typename?: 'CustomAttributeMetadata', items?: Array<{ __typename?: 'Attribute', attribute_code?: string | null, attribute_type?: string | null, attribute_options?: Array<{ __typename?: 'AttributeOption', value?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type CustomerAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', addresses?: Array<{ __typename?: 'CustomerAddress', id?: number | null, city?: string | null, company?: string | null, country_code?: CountryCodeEnum | null, default_billing?: boolean | null, default_shipping?: boolean | null, firstname?: string | null, lastname?: string | null, postcode?: string | null, prefix?: string | null, street?: Array<string | null> | null, telephone?: string | null } | null> | null } | null };

export type CustomerCartQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCartQuery = { __typename?: 'Query', customerCart: { __typename?: 'Cart', id: string, billing_address?: { __typename: 'BillingCartAddress' } | null, shipping_addresses: Array<{ __typename: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_code: string } | null } | null> } };

export type CustomerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerDataQuery = { __typename?: 'Query', first_time_customer?: boolean | null, live_time_value?: number | null };

export type CustomerInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerInformationQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null } | null };

export type CustomerNewsletterSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerNewsletterSubscriptionQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', firstname?: string | null, email?: string | null, is_subscribed?: boolean | null } | null };

export type CustomerOrderByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type CustomerOrderByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', email?: string | null, orders?: { __typename?: 'CustomerOrders', items: Array<{ __typename?: 'CustomerOrder', id: string, number: string, order_date: string, shipping_method?: string | null, items?: Array<{ __typename?: 'BundleOrderItem', id: string, product_sku: string, product_name?: string | null, product_url_key?: string | null, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | { __typename?: 'DownloadableOrderItem', id: string, product_sku: string, product_name?: string | null, product_url_key?: string | null, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | { __typename?: 'GiftCardOrderItem', id: string, product_sku: string, product_name?: string | null, product_url_key?: string | null, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | { __typename?: 'OrderItem', id: string, product_sku: string, product_name?: string | null, product_url_key?: string | null, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | null> | null, shipping_address?: { __typename?: 'OrderAddress', firstname: string, middlename?: string | null, lastname: string, street: Array<string | null>, city: string, prefix?: string | null, suffix?: string | null, postcode?: string | null, telephone?: string | null, company?: string | null, country_code?: CountryCodeEnum | null } | null, billing_address?: { __typename?: 'OrderAddress', firstname: string, middlename?: string | null, lastname: string, street: Array<string | null>, city: string, prefix?: string | null, suffix?: string | null, postcode?: string | null, telephone?: string | null, company?: string | null, country_code?: CountryCodeEnum | null } | null, payment_methods?: Array<{ __typename?: 'OrderPaymentMethod', name: string, type: string, additional_data?: Array<{ __typename?: 'KeyValue', name?: string | null, value?: string | null } | null> | null } | null> | null, total?: { __typename?: 'OrderTotal', subtotal: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null, taxes?: Array<{ __typename?: 'TaxItem', rate: number, title: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null> | null, total_shipping: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, grand_total: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null } | null> } | null } | null };

export type CustomerOrderReturnsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerOrderReturnsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', returns?: { __typename?: 'Returns', items?: Array<{ __typename?: 'Return', uid: string, number: string, created_at: string, status?: ReturnStatus | null, customer: { __typename?: 'ReturnCustomer', firstname?: string | null, lastname?: string | null }, order?: { __typename?: 'CustomerOrder', total?: { __typename?: 'OrderTotal', grand_total: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null } | null } | null> | null } | null } | null };

export type CustomerOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerOrdersQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', ordersReversed?: { __typename?: 'CustomerOrders', page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null, page_size?: number | null } | null, items: Array<{ __typename?: 'CustomerOrder', id: string, number: string, status: string, order_date: string, shipping_address?: { __typename?: 'OrderAddress', firstname: string, middlename?: string | null, lastname: string } | null, total?: { __typename?: 'OrderTotal', grand_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | null> } | null } | null };

export type CustomerReturnByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerReturnByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', return?: { __typename?: 'Return', number: string, created_at: string, customer: { __typename?: 'ReturnCustomer', email: string }, order?: { __typename?: 'CustomerOrder', id: string, number: string, order_date: string, shipping_address?: { __typename?: 'OrderAddress', firstname: string, middlename?: string | null, lastname: string, street: Array<string | null>, city: string, prefix?: string | null, suffix?: string | null, postcode?: string | null, telephone?: string | null, company?: string | null, country_code?: CountryCodeEnum | null } | null } | null, items?: Array<{ __typename?: 'ReturnItem', uid: string, request_quantity: number, status: ReturnItemStatus, order_item: { __typename?: 'BundleOrderItem', product_name?: string | null, product_sku: string } | { __typename?: 'DownloadableOrderItem', product_name?: string | null, product_sku: string } | { __typename?: 'GiftCardOrderItem', product_name?: string | null, product_sku: string } | { __typename?: 'OrderItem', product_name?: string | null, product_sku: string } } | null> | null } | null } | null };

export type DeleteCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCustomerAddressMutation = { __typename?: 'Mutation', deleteCustomerAddress?: boolean | null };

export type DeleteCustomerNewsletterSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCustomerNewsletterSubscriptionMutation = { __typename?: 'Mutation', updateCustomerV2?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', firstname?: string | null } } | null };

export type FetchCartHeaderQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type FetchCartHeaderQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, total_quantity: number, email?: string | null, items?: Array<{ __typename?: 'BundleCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'ConfigurableCartItem', quantity: number, uid: string, configurable_options: Array<{ __typename?: 'SelectedConfigurableOption', value_label: string } | null>, configured_variant: { __typename?: 'BundleProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'ConfigurableProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'DownloadableProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'GiftCardProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'GroupedProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'SimpleProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } } | { __typename?: 'VirtualProduct', eannummer?: string | null, sku?: string | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } } }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'DownloadableCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'GiftCardCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'SimpleCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | { __typename?: 'VirtualCartItem', quantity: number, uid: string, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, product: { __typename?: 'BundleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, eannummer?: string | null, manufacturer?: number | null, name?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, regular_price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', amount?: { __typename?: 'Money', value?: number | null } | null } | null> | null } }, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } } | null> | null, prices?: { __typename?: 'CartPrices', subtotal_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, grand_total?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, applied_taxes?: Array<{ __typename?: 'CartTaxItem', amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_code: string, method_title: string, amount: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, available_shipping_methods?: Array<{ __typename?: 'AvailableShippingMethod', method_code?: string | null, price_incl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null> } | null };

export type FetchUserWishlistQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserWishlistQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', wishlists: Array<{ __typename?: 'Wishlist', items_v2?: { __typename?: 'WishlistItems', items: Array<{ __typename?: 'BundleWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'ConfigurableWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'DownloadableWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'GiftCardWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'GroupedProductWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'SimpleWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | { __typename?: 'VirtualWishlistItem', product?: { __typename: 'BundleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', uid: string, name?: string | null, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> } | null } | null> } | null };

export type FetchWishlistProductsQueryVariables = Exact<{
  sku: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type FetchWishlistProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename: 'BundleProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', name?: string | null, uid: string, url_key?: string | null, sku?: string | null, benuta_ar?: string | null, manufacturer?: number | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type GetAdyenPaymentMethodsQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type GetAdyenPaymentMethodsQuery = { __typename?: 'Query', adyenPaymentMethods?: { __typename?: 'AdyenPaymentMethods', paymentMethodsExtraDetails?: Array<{ __typename?: 'AdyenPaymentMethodsExtraDetails', type?: string | null, isOpenInvoice?: boolean | null, icon?: { __typename?: 'AdyenPaymentMethodIcon', url?: string | null, width?: number | null, height?: number | null } | null, configuration?: { __typename?: 'AdyenPaymentMethodsExtraDetailsConfiguration', currency?: string | null, amount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } | null> | null, paymentMethodsResponse?: { __typename?: 'AdyenPaymentMethodsResponse', paymentMethods?: Array<{ __typename?: 'AdyenPaymentMethodsArray', name?: string | null, type?: string | null, brand?: string | null, brands?: Array<string | null> | null, issuers?: Array<{ __typename?: 'AdyenPaymentMethodsIssuers', id?: string | null, name?: string | null } | null> | null, configuration?: { __typename?: 'AdyenPaymentMethodsConfiguration', merchantId?: string | null, merchantName?: string | null, gatewayMerchantId?: string | null } | null } | null> | null } | null } | null };

export type GetAdyenPaymentStatusQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  cartId: Scalars['String'];
}>;


export type GetAdyenPaymentStatusQuery = { __typename?: 'Query', adyenPaymentStatus?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null };

export type GetCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null } | null };

export type GetProductsViaSkuQueryVariables = Exact<{
  sku: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type GetProductsViaSkuQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename: 'BundleProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'ConfigurableProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null } | null> | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'DownloadableProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'GiftCardProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'GroupedProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'SimpleProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | { __typename: 'VirtualProduct', name?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, uid: string, url_key?: string | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null } | null> | null } | null };

export type GetSovendusDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSovendusDataQuery = { __typename?: 'Query', getSovendusData: { __typename?: 'SovendusData', trafficMediumNumber: string, trafficSourceNumber: string } };

export type GetWishlistIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWishlistIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', wishlists: Array<{ __typename?: 'Wishlist', id?: string | null, items_v2?: { __typename?: 'WishlistItems', items: Array<{ __typename?: 'BundleWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'ConfigurableWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'DownloadableWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'GiftCardWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'GroupedProductWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'SimpleWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | { __typename?: 'VirtualWishlistItem', id: string, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | null> } | null } | null> } | null };

export type KlarnaAuthorizeMutationVariables = Exact<{
  token: Scalars['String'];
  requestBody: Scalars['String'];
}>;


export type KlarnaAuthorizeMutation = { __typename?: 'Mutation', klarnaAuthorize: number };

export type MergeCartsMutationVariables = Exact<{
  sourceCartId: Scalars['String'];
  destinationCartId: Scalars['String'];
}>;


export type MergeCartsMutation = { __typename?: 'Mutation', mergeCarts: { __typename?: 'Cart', items?: Array<{ __typename?: 'BundleCartItem', uid: string, quantity: number } | { __typename?: 'ConfigurableCartItem', uid: string, quantity: number } | { __typename?: 'DownloadableCartItem', uid: string, quantity: number } | { __typename?: 'GiftCardCartItem', uid: string, quantity: number } | { __typename?: 'SimpleCartItem', uid: string, quantity: number } | { __typename?: 'VirtualCartItem', uid: string, quantity: number } | null> | null } };

export type PdpQueryVariables = Exact<{
  urlKey: Scalars['String'];
}>;


export type PdpQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, items?: Array<{ __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', eannummer?: string | null, stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'GiftCardProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null, attribute_set_id?: number | null, id?: number | null, video_url?: string | null, benuta_color_filter?: number | null, benuta_living_area?: string | null, benuta_fuellmaterial?: number | null, benuta_floor_heating?: number | null, benuta_motive_design?: string | null, benuta_pile_height?: number | null, benuta_pile_material?: number | null, benuta_test_seal?: string | null, benuta_waschbar?: number | null, benuta_rueckseite?: number | null, benuta_production_type?: string | null, benuta_collection?: string | null, dimensions?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_form_new?: number | null, benuta_verfuegbare_groessen?: string | null, benuta_ar?: string | null, ingredients?: string | null, warning_code?: string | null, lagerungshinweise?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryTree', uid: string, url_key?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null, upsell_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GiftCardProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, id?: number | null, url_key?: string | null, sku?: string | null, uid: string, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null> | null } | null> | null } | null };

export type PlaceOrderMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string } } | null };

export type ProductCardDetailsQueryVariables = Exact<{
  sku: Scalars['String'];
}>;


export type ProductCardDetailsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'ConfigurableProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'DownloadableProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GiftCardProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GroupedProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'SimpleProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'VirtualProduct', url_key?: string | null, name?: string | null, sku?: string | null, umsatz?: number | null, benuta_test_seal?: string | null, benuta_production_type?: string | null, benuta_pile_material?: number | null, benuta_waschbar?: number | null, benuta_ar?: string | null, created_at?: string | null, stock_status?: ProductStockStatus | null, benuta_collection?: string | null, benuta_color_filter?: number | null, manufacturer?: number | null, benuta_motive_design?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type GetProductImageQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']>;
}>;


export type GetProductImageQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'ConfigurableProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'DownloadableProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'GiftCardProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'GroupedProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'SimpleProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'VirtualProduct', name?: string | null, image?: { __typename?: 'ProductImage', url?: string | null } | null } | null> | null } | null };

export type ProductPriceQueryVariables = Exact<{
  urlKey: Scalars['String'];
}>;


export type ProductPriceQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'ConfigurableProduct', stock_status?: ProductStockStatus | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'DownloadableProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GiftCardProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GroupedProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'VirtualProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | null> | null } | null };

export type ProductSizesQueryVariables = Exact<{
  urlKey: Scalars['String'];
}>;


export type ProductSizesQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, uid: string, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, url_key?: string | null, sku?: string | null, uid: string, only_x_left_in_stock?: number | null, stock_status?: ProductStockStatus | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GiftCardProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null, benuta_form_new?: number | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type ProductUrlsQueryVariables = Exact<{
  identifier: Scalars['Int'];
}>;


export type ProductUrlsQuery = { __typename?: 'Query', productUrls: Array<string | null> };

export type ProductsQueryVariables = Exact<{
  pageSize: Scalars['Int'];
  currentPage: Scalars['Int'];
  filter?: InputMaybe<ProductAttributeFilterInput>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } | null, items?: Array<{ __typename: 'BundleProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null, value_index?: number | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', stock_status?: ProductStockStatus | null, sku?: string | null } | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', attribute_set_id?: number | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, id?: number | null, uid: string, url_key?: string | null, sku?: string | null, stock_status?: ProductStockStatus | null, related_products?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, benuta_form_new?: number | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type ProductsOfPopularSearchTermsQueryVariables = Exact<{
  skus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ProductsOfPopularSearchTermsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename: 'BundleProduct' } | { __typename: 'ConfigurableProduct', sku?: string | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null } | { __typename: 'DownloadableProduct' } | { __typename: 'GiftCardProduct' } | { __typename: 'GroupedProduct' } | { __typename: 'SimpleProduct' } | { __typename: 'VirtualProduct' } | null> | null } | null };

export type ProductsPricesQueryVariables = Exact<{
  pageSize: Scalars['Int'];
  currentPage: Scalars['Int'];
  filter?: InputMaybe<ProductAttributeFilterInput>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductsPricesQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'ConfigurableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'DownloadableProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GiftCardProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'GroupedProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'SimpleProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename?: 'VirtualProduct', sku?: string | null, stock_status?: ProductStockStatus | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type RecentlyViewedProductsQueryVariables = Exact<{
  urlKeys: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type RecentlyViewedProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename: 'BundleProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null, value_index?: number | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, name?: string | null, uid: string, url_key?: string | null, sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type RecentlyViewedProductsViaSkuQueryVariables = Exact<{
  skus: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type RecentlyViewedProductsViaSkuQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename: 'BundleProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'ConfigurableProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_uid: string, attribute_code?: string | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', label?: string | null, uid?: string | null, value_index?: number | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'DownloadableProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GiftCardProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'GroupedProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'SimpleProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | { __typename: 'VirtualProduct', name?: string | null, uid: string, url_key?: string | null, manufacturer?: number | null, created_at?: string | null, umsatz?: number | null, benuta_pile_material?: number | null, benuta_production_type?: string | null, benuta_waschbar?: number | null, benuta_ar?: string | null, benuta_test_seal?: string | null, benuta_color_filter?: number | null, benuta_collection?: string | null, benuta_form_new?: number | null, reviews_io_score?: number | null, sku?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, related_products?: Array<{ __typename?: 'BundleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'ConfigurableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'DownloadableProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GiftCardProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'GroupedProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'SimpleProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | { __typename?: 'VirtualProduct', benuta_form_new?: number | null, sku?: string | null, url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null } | null } | null> | null, image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, small_image?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null, disabled?: boolean | null, position?: number | null } | null, media_gallery?: Array<{ __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | { __typename?: 'ProductVideo', url?: string | null, position?: number | null, label?: string | null, disabled?: boolean | null } | null> | null, price_range: { __typename?: 'PriceRange', minimum_price: { __typename?: 'ProductPrice', regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null> | null } | null };

export type RemoveCouponFromCartMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type RemoveCouponFromCartMutation = { __typename?: 'Mutation', removeCouponFromCart?: { __typename?: 'RemoveCouponFromCartOutput', cart?: { __typename?: 'Cart', applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null } | null } | null };

export type RemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  cartItemUid: Scalars['ID'];
}>;


export type RemoveItemFromCartMutation = { __typename?: 'Mutation', removeItemFromCart?: { __typename?: 'RemoveItemFromCartOutput', cart: { __typename?: 'Cart', total_quantity: number } } | null };

export type RemoveItemsFromWishlistMutationVariables = Exact<{
  wishlistId: Scalars['ID'];
  wishlistItemsIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveItemsFromWishlistMutation = { __typename?: 'Mutation', removeProductsFromWishlist?: { __typename?: 'RemoveProductsFromWishlistOutput', user_errors: Array<{ __typename?: 'WishListUserInputError', code: WishListUserInputErrorType, message: string } | null> } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordResetEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type RouteQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RouteQuery = { __typename?: 'Query', route?: { __typename: 'BundleProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'CategoryTree', id?: number | null, uid: string, relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'CmsPage', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null, identifier?: string | null, url_key?: string | null, title?: string | null, content?: string | null, content_heading?: string | null, page_layout?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keywords?: string | null } | { __typename: 'ConfigurableProduct', meta_title?: string | null, meta_description?: string | null, url_key?: string | null, relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'DownloadableProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'GiftCardProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'GroupedProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'SimpleProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | { __typename: 'VirtualProduct', relative_url?: string | null, redirect_code: number, type?: UrlRewriteEntityTypeEnum | null } | null };

export type SetBillingAddressOnCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  billingAddresses: BillingAddressInput;
}>;


export type SetBillingAddressOnCartMutation = { __typename?: 'Mutation', setBillingAddressOnCart?: { __typename?: 'SetBillingAddressOnCartOutput', cart: { __typename?: 'Cart', id: string, billing_address?: { __typename?: 'BillingCartAddress', telephone?: string | null } | null } } | null };

export type SetGuestEmailOnCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  email: Scalars['String'];
}>;


export type SetGuestEmailOnCartMutation = { __typename?: 'Mutation', setGuestEmailOnCart?: { __typename?: 'SetGuestEmailOnCartOutput', cart: { __typename?: 'Cart', email?: string | null } } | null };

export type SetPaymentMethodMutationVariables = Exact<{
  cartId: Scalars['String'];
  paymentMethod: PaymentMethodInput;
}>;


export type SetPaymentMethodMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string } | null } } | null };

export type SetPaymentMethodAndPalceOrderPaypalMutationVariables = Exact<{
  cartId: Scalars['String'];
  payerId: Scalars['String'];
  token: Scalars['String'];
}>;


export type SetPaymentMethodAndPalceOrderPaypalMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string } } | null };

export type SetPaymentMethodAndPlaceOrderMutationVariables = Exact<{
  cartId: Scalars['String'];
  stateData: Scalars['String'];
  cardType?: InputMaybe<Scalars['String']>;
}>;


export type SetPaymentMethodAndPlaceOrderMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, order_id?: string | null, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetPaymentMethodAndPlaceOrderAdyenHppMutationVariables = Exact<{
  cartId: Scalars['String'];
  paymentCode: Scalars['String'];
  stateData: Scalars['String'];
  brandCode: Scalars['String'];
}>;


export type SetPaymentMethodAndPlaceOrderAdyenHppMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, order_id?: string | null, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetPaymentMethodAndPlaceOrderApplePayMutationVariables = Exact<{
  cartId: Scalars['String'];
  stateData: Scalars['String'];
}>;


export type SetPaymentMethodAndPlaceOrderApplePayMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, order_id?: string | null, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetPaymentMethodAndPlaceOrderGooglePayMutationVariables = Exact<{
  cartId: Scalars['String'];
  stateData: Scalars['String'];
}>;


export type SetPaymentMethodAndPlaceOrderGooglePayMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, order_id?: string | null, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetPaymentMethodAndPlaceOrderKlarnaMutationVariables = Exact<{
  cartId: Scalars['String'];
  code: Scalars['String'];
  klarnaAuthToken: Scalars['String'];
}>;


export type SetPaymentMethodAndPlaceOrderKlarnaMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetPaymentMethodAndPlaceOrderVorkasseMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type SetPaymentMethodAndPlaceOrderVorkasseMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null, placeOrder?: { __typename?: 'PlaceOrderOutput', order: { __typename?: 'Order', order_number: string, cart_id: string, order_id?: string | null, adyen_payment_status?: { __typename?: 'AdyenPaymentStatus', isFinal?: boolean | null, resultCode?: string | null, additionalData?: string | null, action?: string | null } | null } } | null };

export type SetShippingAddressMutationVariables = Exact<{
  cartId: Scalars['String'];
  address: CartAddressInput;
}>;


export type SetShippingAddressMutation = { __typename?: 'Mutation', setShippingAddressesOnCart?: { __typename?: 'SetShippingAddressesOnCartOutput', cart: { __typename?: 'Cart', shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', firstname: string, lastname: string, company?: string | null, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null, label?: string | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string } } | null> } } | null };

export type SetShippingMethodsMutationVariables = Exact<{
  cartId: Scalars['String'];
  shippingMethods: Array<InputMaybe<ShippingMethodInput>> | InputMaybe<ShippingMethodInput>;
}>;


export type SetShippingMethodsMutation = { __typename?: 'Mutation', setShippingMethodsOnCart?: { __typename?: 'SetShippingMethodsOnCartOutput', cart: { __typename?: 'Cart', shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', carrier_code: string, method_code: string, carrier_title: string, method_title: string } | null } | null>, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null } } | null };

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', generateCustomerToken?: { __typename?: 'CustomerToken', token?: string | null } | null };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', revokeCustomerToken?: { __typename?: 'RevokeCustomerTokenOutput', result: boolean } | null };

export type SitemapCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapCategoriesQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', url_path?: string | null, children?: Array<{ __typename?: 'CategoryTree', url_path?: string | null } | null> | null } | null> | null };

export type SitemapProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, items?: Array<{ __typename: 'BundleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'ConfigurableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'DownloadableProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'GiftCardProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'GroupedProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'SimpleProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | { __typename: 'VirtualProduct', url_key?: string | null, url_rewrites?: Array<{ __typename?: 'UrlRewrite', url?: string | null } | null> | null } | null> | null } | null };

export type GetRelatedSkusQueryVariables = Exact<{
  sku: Scalars['String'];
}>;


export type GetRelatedSkusQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'DownloadableProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GiftCardProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GroupedProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'SimpleProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'VirtualProduct', sku?: string | null, related_products?: Array<{ __typename?: 'BundleProduct' } | { __typename: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', product?: { __typename?: 'SimpleProduct', sku?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GiftCardProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct' } | { __typename?: 'VirtualProduct' } | null> | null } | null> | null } | null };

export type StoreConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreConfigQuery = { __typename?: 'Query', storeConfig?: { __typename?: 'StoreConfig', base_currency_code?: string | null, adyen_client_key_live?: string | null, adyen_client_key_test?: string | null, payment_banktransfer_instructions?: string | null, payment_banktransfer_instructions_checkout?: string | null } | null };

export type SubscribeEmailToNewsletterMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SubscribeEmailToNewsletterMutation = { __typename?: 'Mutation', subscribeEmailToNewsletter?: { __typename?: 'SubscribeEmailToNewsletterOutput', status?: SubscriptionStatusesEnum | null } | null };

export type UpdateCartItemsMutationVariables = Exact<{
  cartId: Scalars['String'];
  cartItemUid: Scalars['ID'];
  qty: Scalars['Float'];
}>;


export type UpdateCartItemsMutation = { __typename?: 'Mutation', updateCartItems?: { __typename?: 'UpdateCartItemsOutput', cart: { __typename?: 'Cart', total_quantity: number } } | null };

export type UpdateCustomerMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null } } | null };

export type UpdateCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<CountryCodeEnum>;
  default_billing?: InputMaybe<Scalars['Boolean']>;
  default_shipping?: InputMaybe<Scalars['Boolean']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  telephone?: InputMaybe<Scalars['String']>;
  vat_id?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCustomerAddressMutation = { __typename?: 'Mutation', updateCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, company?: string | null, country_code?: CountryCodeEnum | null, default_billing?: boolean | null, default_shipping?: boolean | null, firstname?: string | null, lastname?: string | null, postcode?: string | null, prefix?: string | null, street?: Array<string | null> | null, telephone?: string | null, vat_id?: string | null } | null };

export type UpdateCustomerNewsletterSubscriptionMutationVariables = Exact<{
  firstname: Scalars['String'];
  email: Scalars['String'];
}>;


export type UpdateCustomerNewsletterSubscriptionMutation = { __typename?: 'Mutation', updateCustomerV2?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', firstname?: string | null } } | null, subscribeEmailToNewsletter?: { __typename?: 'SubscribeEmailToNewsletterOutput', status?: SubscriptionStatusesEnum | null } | null };

export type UpdateCustomerTelephoneMutationVariables = Exact<{
  id: Scalars['Int'];
  telephone?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCustomerTelephoneMutation = { __typename?: 'Mutation', updateCustomerAddress?: { __typename?: 'CustomerAddress', telephone?: string | null } | null };

export type ValidateCartQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type ValidateCartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string } | null };

export const CmsPageFragmentDoc = `
    fragment cmsPage on CmsPage {
  identifier
  url_key
  title
  content
  content_heading
  page_layout
  meta_title
  meta_description
  meta_keywords
}
    `;
export const AddStockNotificationDocument = `
    mutation addStockNotification($sku: String!, $storeCode: String!, $email: String!) {
  addStockNotification(sku: $sku, storeCode: $storeCode, email: $email)
}
    `;
export const useAddStockNotificationMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddStockNotificationMutation, TError, AddStockNotificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddStockNotificationMutation, TError, AddStockNotificationMutationVariables, TContext>(
      ['addStockNotification'],
      (variables?: AddStockNotificationMutationVariables) => fetcher<AddStockNotificationMutation, AddStockNotificationMutationVariables>(client, AddStockNotificationDocument, variables, headers)(),
      options
    );
useAddStockNotificationMutation.getKey = () => ['addStockNotification'];

export const AddToCartDocument = `
    mutation AddToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      items {
        uid
        product {
          sku
        }
      }
    }
    user_errors {
      code
      message
    }
  }
}
    `;
export const useAddToCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddToCartMutation, TError, AddToCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddToCartMutation, TError, AddToCartMutationVariables, TContext>(
      ['AddToCart'],
      (variables?: AddToCartMutationVariables) => fetcher<AddToCartMutation, AddToCartMutationVariables>(client, AddToCartDocument, variables, headers)(),
      options
    );
useAddToCartMutation.getKey = () => ['AddToCart'];

export const AddToWishlistDocument = `
    mutation AddToWishlist($wishlistId: ID!, $wishlistItems: [WishlistItemInput!]!) {
  addProductsToWishlist(wishlistId: $wishlistId, wishlistItems: $wishlistItems) {
    user_errors {
      code
      message
    }
  }
}
    `;
export const useAddToWishlistMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddToWishlistMutation, TError, AddToWishlistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddToWishlistMutation, TError, AddToWishlistMutationVariables, TContext>(
      ['AddToWishlist'],
      (variables?: AddToWishlistMutationVariables) => fetcher<AddToWishlistMutation, AddToWishlistMutationVariables>(client, AddToWishlistDocument, variables, headers)(),
      options
    );
useAddToWishlistMutation.getKey = () => ['AddToWishlist'];

export const AdyenPaymentDetailsDocument = `
    mutation adyenPaymentDetails($payload: String!, $cartId: String!) {
  adyenPaymentDetails(payload: $payload, cart_id: $cartId) {
    isFinal
    resultCode
    additionalData
    action
  }
}
    `;
export const useAdyenPaymentDetailsMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AdyenPaymentDetailsMutation, TError, AdyenPaymentDetailsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AdyenPaymentDetailsMutation, TError, AdyenPaymentDetailsMutationVariables, TContext>(
      ['adyenPaymentDetails'],
      (variables?: AdyenPaymentDetailsMutationVariables) => fetcher<AdyenPaymentDetailsMutation, AdyenPaymentDetailsMutationVariables>(client, AdyenPaymentDetailsDocument, variables, headers)(),
      options
    );
useAdyenPaymentDetailsMutation.getKey = () => ['adyenPaymentDetails'];

export const AggregationsDocument = `
    query aggregations($filter: ProductAttributeFilterInput) {
  products(filter: $filter) {
    aggregations {
      attribute_code
      label
      options {
        label
        value
      }
    }
  }
}
    `;
export const useAggregationsQuery = <
      TData = AggregationsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: AggregationsQueryVariables,
      options?: UseQueryOptions<AggregationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AggregationsQuery, TError, TData>(
      variables === undefined ? ['aggregations'] : ['aggregations', variables],
      fetcher<AggregationsQuery, AggregationsQueryVariables>(client, AggregationsDocument, variables, headers),
      options
    );
useAggregationsQuery.document = AggregationsDocument;


useAggregationsQuery.getKey = (variables?: AggregationsQueryVariables) => variables === undefined ? ['aggregations'] : ['aggregations', variables];
;

export const useInfiniteAggregationsQuery = <
      TData = AggregationsQuery,
      TError = Error
    >(
      _pageParamKey: keyof AggregationsQueryVariables,
      client: GraphQLClient,
      variables?: AggregationsQueryVariables,
      options?: UseInfiniteQueryOptions<AggregationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<AggregationsQuery, TError, TData>(
      variables === undefined ? ['aggregations.infinite'] : ['aggregations.infinite', variables],
      (metaData) => fetcher<AggregationsQuery, AggregationsQueryVariables>(client, AggregationsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteAggregationsQuery.getKey = (variables?: AggregationsQueryVariables) => variables === undefined ? ['aggregations.infinite'] : ['aggregations.infinite', variables];
;

export const ApplyCouponToCartDocument = `
    mutation ApplyCouponToCart($cartId: String!, $couponCode: String!) {
  applyCouponToCart(input: {cart_id: $cartId, coupon_code: $couponCode}) {
    cart {
      applied_coupons {
        code
      }
    }
  }
}
    `;
export const useApplyCouponToCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyCouponToCartMutation, TError, ApplyCouponToCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyCouponToCartMutation, TError, ApplyCouponToCartMutationVariables, TContext>(
      ['ApplyCouponToCart'],
      (variables?: ApplyCouponToCartMutationVariables) => fetcher<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>(client, ApplyCouponToCartDocument, variables, headers)(),
      options
    );
useApplyCouponToCartMutation.getKey = () => ['ApplyCouponToCart'];

export const CartDocument = `
    query cart($cartId: String!) {
  cart(cart_id: $cartId) {
    applied_coupons {
      code
    }
    id
    email
    total_quantity
    items {
      ... on ConfigurableCartItem {
        __typename
        configurable_options {
          value_label
        }
        configured_variant {
          eannummer
          sku
          price_range {
            minimum_price {
              final_price {
                value
                currency
              }
              regular_price {
                value
                currency
              }
            }
          }
        }
      }
      quantity
      uid
      prices {
        price {
          value
          currency
        }
        row_total_including_tax {
          value
          currency
        }
        discounts {
          label
          amount {
            value
          }
        }
      }
      product {
        sku
        eannummer
        manufacturer
        stock_status
        url_rewrites {
          url
        }
        price_range {
          minimum_price {
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
            fixed_product_taxes {
              amount {
                value
              }
            }
          }
        }
        name
        image {
          url
          label
        }
      }
    }
    shipping_addresses {
      firstname
      lastname
      street
      city
      postcode
      customer_notes
      telephone
      region {
        code
      }
      country {
        code
        label
      }
      selected_shipping_method {
        carrier_code
        method_code
        method_title
        amount {
          currency
          value
        }
      }
      available_shipping_methods {
        amount {
          currency
          value
        }
        available
        carrier_code
        carrier_title
        error_message
        method_code
        method_title
        price_excl_tax {
          value
          currency
        }
        price_incl_tax {
          value
          currency
        }
      }
    }
    billing_address {
      firstname
      lastname
      street
      city
      postcode
      telephone
      region {
        code
      }
      country {
        code
        label
      }
    }
    available_payment_methods {
      code
      title
    }
    selected_payment_method {
      code
    }
    prices {
      subtotal_including_tax {
        value
        currency
      }
      subtotal_excluding_tax {
        value
        currency
      }
      grand_total {
        value
        currency
      }
      applied_taxes {
        amount {
          value
          currency
        }
        label
      }
    }
  }
}
    `;
export const useCartQuery = <
      TData = CartQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CartQueryVariables,
      options?: UseQueryOptions<CartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CartQuery, TError, TData>(
      ['cart', variables],
      fetcher<CartQuery, CartQueryVariables>(client, CartDocument, variables, headers),
      options
    );
useCartQuery.document = CartDocument;


useCartQuery.getKey = (variables: CartQueryVariables) => ['cart', variables];
;

export const useInfiniteCartQuery = <
      TData = CartQuery,
      TError = Error
    >(
      _pageParamKey: keyof CartQueryVariables,
      client: GraphQLClient,
      variables: CartQueryVariables,
      options?: UseInfiniteQueryOptions<CartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CartQuery, TError, TData>(
      ['cart.infinite', variables],
      (metaData) => fetcher<CartQuery, CartQueryVariables>(client, CartDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCartQuery.getKey = (variables: CartQueryVariables) => ['cart.infinite', variables];
;

export const CartPageDocument = `
    query CartPage($cartId: String!) {
  cart(cart_id: $cartId) {
    applied_coupons {
      code
    }
    prices {
      subtotal_including_tax {
        currency
        value
      }
      grand_total {
        currency
        value
      }
      applied_taxes {
        amount {
          currency
          value
        }
      }
    }
    shipping_addresses {
      country {
        label
      }
      selected_shipping_method {
        method_code
        method_title
        amount {
          currency
          value
        }
      }
      available_shipping_methods {
        amount {
          currency
          value
        }
        available
        carrier_code
        carrier_title
        error_message
        method_code
        method_title
        price_excl_tax {
          value
          currency
        }
        price_incl_tax {
          value
          currency
        }
      }
    }
    items {
      __typename
      prices {
        row_total_including_tax {
          currency
          value
        }
        discounts {
          label
          amount {
            currency
            value
          }
        }
      }
      uid
      quantity
      ... on ConfigurableCartItem {
        configurable_options {
          option_label
          value_label
          value_id
        }
        configured_variant {
          eannummer
          sku
          only_x_left_in_stock
          price_range {
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
        }
        product {
          eannummer
          sku
          name
          url_key
          stock_status
          url_rewrites {
            url
          }
          only_x_left_in_stock
          stock_status
          manufacturer
          image {
            label
            url
          }
        }
      }
    }
  }
}
    `;
export const useCartPageQuery = <
      TData = CartPageQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CartPageQueryVariables,
      options?: UseQueryOptions<CartPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CartPageQuery, TError, TData>(
      ['CartPage', variables],
      fetcher<CartPageQuery, CartPageQueryVariables>(client, CartPageDocument, variables, headers),
      options
    );
useCartPageQuery.document = CartPageDocument;


useCartPageQuery.getKey = (variables: CartPageQueryVariables) => ['CartPage', variables];
;

export const useInfiniteCartPageQuery = <
      TData = CartPageQuery,
      TError = Error
    >(
      _pageParamKey: keyof CartPageQueryVariables,
      client: GraphQLClient,
      variables: CartPageQueryVariables,
      options?: UseInfiniteQueryOptions<CartPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CartPageQuery, TError, TData>(
      ['CartPage.infinite', variables],
      (metaData) => fetcher<CartPageQuery, CartPageQueryVariables>(client, CartPageDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCartPageQuery.getKey = (variables: CartPageQueryVariables) => ['CartPage.infinite', variables];
;

export const CartPreviewProductDocument = `
    query CartPreviewProduct($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    total_count
    items {
      ... on ConfigurableProduct {
        variants {
          attributes {
            code
            label
            uid
          }
          product {
            ... on SimpleProduct {
              attribute_set_id
              uid
              name
              price_range {
                minimum_price {
                  regular_price {
                    currency
                    value
                  }
                  final_price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
      small_image {
        url
        label
      }
    }
  }
}
    `;
export const useCartPreviewProductQuery = <
      TData = CartPreviewProductQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CartPreviewProductQueryVariables,
      options?: UseQueryOptions<CartPreviewProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CartPreviewProductQuery, TError, TData>(
      ['CartPreviewProduct', variables],
      fetcher<CartPreviewProductQuery, CartPreviewProductQueryVariables>(client, CartPreviewProductDocument, variables, headers),
      options
    );
useCartPreviewProductQuery.document = CartPreviewProductDocument;


useCartPreviewProductQuery.getKey = (variables: CartPreviewProductQueryVariables) => ['CartPreviewProduct', variables];
;

export const useInfiniteCartPreviewProductQuery = <
      TData = CartPreviewProductQuery,
      TError = Error
    >(
      _pageParamKey: keyof CartPreviewProductQueryVariables,
      client: GraphQLClient,
      variables: CartPreviewProductQueryVariables,
      options?: UseInfiniteQueryOptions<CartPreviewProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CartPreviewProductQuery, TError, TData>(
      ['CartPreviewProduct.infinite', variables],
      (metaData) => fetcher<CartPreviewProductQuery, CartPreviewProductQueryVariables>(client, CartPreviewProductDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCartPreviewProductQuery.getKey = (variables: CartPreviewProductQueryVariables) => ['CartPreviewProduct.infinite', variables];
;

export const CartSelectedShippingDocument = `
    query cartSelectedShipping($cartId: String!) {
  cart(cart_id: $cartId) {
    shipping_addresses {
      selected_shipping_method {
        method_code
        method_title
        amount {
          currency
          value
        }
      }
    }
  }
}
    `;
export const useCartSelectedShippingQuery = <
      TData = CartSelectedShippingQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CartSelectedShippingQueryVariables,
      options?: UseQueryOptions<CartSelectedShippingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CartSelectedShippingQuery, TError, TData>(
      ['cartSelectedShipping', variables],
      fetcher<CartSelectedShippingQuery, CartSelectedShippingQueryVariables>(client, CartSelectedShippingDocument, variables, headers),
      options
    );
useCartSelectedShippingQuery.document = CartSelectedShippingDocument;


useCartSelectedShippingQuery.getKey = (variables: CartSelectedShippingQueryVariables) => ['cartSelectedShipping', variables];
;

export const useInfiniteCartSelectedShippingQuery = <
      TData = CartSelectedShippingQuery,
      TError = Error
    >(
      _pageParamKey: keyof CartSelectedShippingQueryVariables,
      client: GraphQLClient,
      variables: CartSelectedShippingQueryVariables,
      options?: UseInfiniteQueryOptions<CartSelectedShippingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CartSelectedShippingQuery, TError, TData>(
      ['cartSelectedShipping.infinite', variables],
      (metaData) => fetcher<CartSelectedShippingQuery, CartSelectedShippingQueryVariables>(client, CartSelectedShippingDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCartSelectedShippingQuery.getKey = (variables: CartSelectedShippingQueryVariables) => ['cartSelectedShipping.infinite', variables];
;

export const CategoriesDocument = `
    query categories($uid: String!) {
  categoryList(filters: {category_uid: {eq: $uid}}) {
    name
    product_count
    meta_title
    meta_description
    uid
  }
}
    `;
export const useCategoriesQuery = <
      TData = CategoriesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CategoriesQueryVariables,
      options?: UseQueryOptions<CategoriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CategoriesQuery, TError, TData>(
      ['categories', variables],
      fetcher<CategoriesQuery, CategoriesQueryVariables>(client, CategoriesDocument, variables, headers),
      options
    );
useCategoriesQuery.document = CategoriesDocument;


useCategoriesQuery.getKey = (variables: CategoriesQueryVariables) => ['categories', variables];
;

export const useInfiniteCategoriesQuery = <
      TData = CategoriesQuery,
      TError = Error
    >(
      _pageParamKey: keyof CategoriesQueryVariables,
      client: GraphQLClient,
      variables: CategoriesQueryVariables,
      options?: UseInfiniteQueryOptions<CategoriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CategoriesQuery, TError, TData>(
      ['categories.infinite', variables],
      (metaData) => fetcher<CategoriesQuery, CategoriesQueryVariables>(client, CategoriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCategoriesQuery.getKey = (variables: CategoriesQueryVariables) => ['categories.infinite', variables];
;

export const CategoryUrlsDocument = `
    query categoryUrls($identifier: Int!) {
  categoryUrls(identifier: $identifier)
}
    `;
export const useCategoryUrlsQuery = <
      TData = CategoryUrlsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CategoryUrlsQueryVariables,
      options?: UseQueryOptions<CategoryUrlsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CategoryUrlsQuery, TError, TData>(
      ['categoryUrls', variables],
      fetcher<CategoryUrlsQuery, CategoryUrlsQueryVariables>(client, CategoryUrlsDocument, variables, headers),
      options
    );
useCategoryUrlsQuery.document = CategoryUrlsDocument;


useCategoryUrlsQuery.getKey = (variables: CategoryUrlsQueryVariables) => ['categoryUrls', variables];
;

export const useInfiniteCategoryUrlsQuery = <
      TData = CategoryUrlsQuery,
      TError = Error
    >(
      _pageParamKey: keyof CategoryUrlsQueryVariables,
      client: GraphQLClient,
      variables: CategoryUrlsQueryVariables,
      options?: UseInfiniteQueryOptions<CategoryUrlsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CategoryUrlsQuery, TError, TData>(
      ['categoryUrls.infinite', variables],
      (metaData) => fetcher<CategoryUrlsQuery, CategoryUrlsQueryVariables>(client, CategoryUrlsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCategoryUrlsQuery.getKey = (variables: CategoryUrlsQueryVariables) => ['categoryUrls.infinite', variables];
;

export const ChangeCustomerPasswordDocument = `
    mutation changeCustomerPassword($currentPassword: String!, $newPassword: String!) {
  changeCustomerPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
  ) {
    status
  }
}
    `;
export const useChangeCustomerPasswordMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeCustomerPasswordMutation, TError, ChangeCustomerPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeCustomerPasswordMutation, TError, ChangeCustomerPasswordMutationVariables, TContext>(
      ['changeCustomerPassword'],
      (variables?: ChangeCustomerPasswordMutationVariables) => fetcher<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>(client, ChangeCustomerPasswordDocument, variables, headers)(),
      options
    );
useChangeCustomerPasswordMutation.getKey = () => ['changeCustomerPassword'];

export const ConfirmNewsletterRegistrationDocument = `
    mutation ConfirmNewsletterRegistration($id: Int!, $code: String!) {
  confirmNewsletterRegistration(id: $id, code: $code)
}
    `;
export const useConfirmNewsletterRegistrationMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmNewsletterRegistrationMutation, TError, ConfirmNewsletterRegistrationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmNewsletterRegistrationMutation, TError, ConfirmNewsletterRegistrationMutationVariables, TContext>(
      ['ConfirmNewsletterRegistration'],
      (variables?: ConfirmNewsletterRegistrationMutationVariables) => fetcher<ConfirmNewsletterRegistrationMutation, ConfirmNewsletterRegistrationMutationVariables>(client, ConfirmNewsletterRegistrationDocument, variables, headers)(),
      options
    );
useConfirmNewsletterRegistrationMutation.getKey = () => ['ConfirmNewsletterRegistration'];

export const CountriesDocument = `
    query countries {
  countries {
    two_letter_abbreviation
    full_name_english
    full_name_locale
    default
  }
}
    `;
export const useCountriesQuery = <
      TData = CountriesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CountriesQueryVariables,
      options?: UseQueryOptions<CountriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CountriesQuery, TError, TData>(
      variables === undefined ? ['countries'] : ['countries', variables],
      fetcher<CountriesQuery, CountriesQueryVariables>(client, CountriesDocument, variables, headers),
      options
    );
useCountriesQuery.document = CountriesDocument;


useCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['countries'] : ['countries', variables];
;

export const useInfiniteCountriesQuery = <
      TData = CountriesQuery,
      TError = Error
    >(
      _pageParamKey: keyof CountriesQueryVariables,
      client: GraphQLClient,
      variables?: CountriesQueryVariables,
      options?: UseInfiniteQueryOptions<CountriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CountriesQuery, TError, TData>(
      variables === undefined ? ['countries.infinite'] : ['countries.infinite', variables],
      (metaData) => fetcher<CountriesQuery, CountriesQueryVariables>(client, CountriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['countries.infinite'] : ['countries.infinite', variables];
;

export const CreateCustomerDocument = `
    mutation createCustomer($firstName: String!, $lastName: String!, $email: String!, $password: String!, $is_subscribed: Boolean!) {
  createCustomerV2(
    input: {firstname: $firstName, lastname: $lastName, email: $email, password: $password, is_subscribed: $is_subscribed}
  ) {
    customer {
      firstname
      lastname
      email
      is_subscribed
    }
  }
}
    `;
export const useCreateCustomerMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>(
      ['createCustomer'],
      (variables?: CreateCustomerMutationVariables) => fetcher<CreateCustomerMutation, CreateCustomerMutationVariables>(client, CreateCustomerDocument, variables, headers)(),
      options
    );
useCreateCustomerMutation.getKey = () => ['createCustomer'];

export const CreateCustomerAddressDocument = `
    mutation createCustomerAddress($input: CustomerAddressInput!) {
  createCustomerAddress(input: $input) {
    city
    company
    country_code
    default_billing
    default_shipping
    firstname
    lastname
    postcode
    prefix
    street
    telephone
    vat_id
  }
}
    `;
export const useCreateCustomerAddressMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCustomerAddressMutation, TError, CreateCustomerAddressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCustomerAddressMutation, TError, CreateCustomerAddressMutationVariables, TContext>(
      ['createCustomerAddress'],
      (variables?: CreateCustomerAddressMutationVariables) => fetcher<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>(client, CreateCustomerAddressDocument, variables, headers)(),
      options
    );
useCreateCustomerAddressMutation.getKey = () => ['createCustomerAddress'];

export const CreateEmptyCartDocument = `
    mutation createEmptyCart {
  createEmptyCart
}
    `;
export const useCreateEmptyCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEmptyCartMutation, TError, CreateEmptyCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateEmptyCartMutation, TError, CreateEmptyCartMutationVariables, TContext>(
      ['createEmptyCart'],
      (variables?: CreateEmptyCartMutationVariables) => fetcher<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>(client, CreateEmptyCartDocument, variables, headers)(),
      options
    );
useCreateEmptyCartMutation.getKey = () => ['createEmptyCart'];

export const CreateKlarnaPaymentsSessionDocument = `
    mutation createKlarnaPaymentsSession($cartId: String!) {
  createKlarnaPaymentsSession(input: {cart_id: $cartId}) {
    client_token
    payment_method_categories {
      identifier
      name
    }
  }
}
    `;
export const useCreateKlarnaPaymentsSessionMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateKlarnaPaymentsSessionMutation, TError, CreateKlarnaPaymentsSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateKlarnaPaymentsSessionMutation, TError, CreateKlarnaPaymentsSessionMutationVariables, TContext>(
      ['createKlarnaPaymentsSession'],
      (variables?: CreateKlarnaPaymentsSessionMutationVariables) => fetcher<CreateKlarnaPaymentsSessionMutation, CreateKlarnaPaymentsSessionMutationVariables>(client, CreateKlarnaPaymentsSessionDocument, variables, headers)(),
      options
    );
useCreateKlarnaPaymentsSessionMutation.getKey = () => ['createKlarnaPaymentsSession'];

export const CreatePaypalExpressTokenDocument = `
    mutation createPaypalExpressToken($cartId: String!) {
  createPaypalExpressToken(
    input: {cart_id: $cartId, code: "paypal_express", urls: {cancel_url: "checkout/payment", return_url: "checkout/paypal"}}
  ) {
    token
    paypal_urls {
      start
      edit
    }
  }
}
    `;
export const useCreatePaypalExpressTokenMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePaypalExpressTokenMutation, TError, CreatePaypalExpressTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePaypalExpressTokenMutation, TError, CreatePaypalExpressTokenMutationVariables, TContext>(
      ['createPaypalExpressToken'],
      (variables?: CreatePaypalExpressTokenMutationVariables) => fetcher<CreatePaypalExpressTokenMutation, CreatePaypalExpressTokenMutationVariables>(client, CreatePaypalExpressTokenDocument, variables, headers)(),
      options
    );
useCreatePaypalExpressTokenMutation.getKey = () => ['createPaypalExpressToken'];

export const CrossSellProductsDocument = `
    query CrossSellProducts($skus: [String!]!) {
  products(filter: {sku: {in: $skus}}, sort: {relevance: DESC}) {
    items {
      name
      sku
      url_key
      url_rewrites {
        url
      }
      manufacturer
      image {
        url
        label
      }
      ... on ConfigurableProduct {
        variants {
          product {
            sku
            stock_status
            price_range {
              minimum_price {
                regular_price {
                  currency
                  value
                }
                final_price {
                  currency
                  value
                }
              }
            }
          }
          attributes {
            label
            uid
          }
        }
      }
    }
  }
}
    `;
export const useCrossSellProductsQuery = <
      TData = CrossSellProductsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CrossSellProductsQueryVariables,
      options?: UseQueryOptions<CrossSellProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CrossSellProductsQuery, TError, TData>(
      ['CrossSellProducts', variables],
      fetcher<CrossSellProductsQuery, CrossSellProductsQueryVariables>(client, CrossSellProductsDocument, variables, headers),
      options
    );
useCrossSellProductsQuery.document = CrossSellProductsDocument;


useCrossSellProductsQuery.getKey = (variables: CrossSellProductsQueryVariables) => ['CrossSellProducts', variables];
;

export const useInfiniteCrossSellProductsQuery = <
      TData = CrossSellProductsQuery,
      TError = Error
    >(
      _pageParamKey: keyof CrossSellProductsQueryVariables,
      client: GraphQLClient,
      variables: CrossSellProductsQueryVariables,
      options?: UseInfiniteQueryOptions<CrossSellProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CrossSellProductsQuery, TError, TData>(
      ['CrossSellProducts.infinite', variables],
      (metaData) => fetcher<CrossSellProductsQuery, CrossSellProductsQueryVariables>(client, CrossSellProductsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCrossSellProductsQuery.getKey = (variables: CrossSellProductsQueryVariables) => ['CrossSellProducts.infinite', variables];
;

export const CustomAttributeMetadataDocument = `
    query CustomAttributeMetadata {
  customAttributeMetadata(
    attributes: [{attribute_code: "manufacturer", entity_type: "catalog_product"}, {attribute_code: "benuta_test_seal", entity_type: "catalog_product"}, {attribute_code: "benuta_pile_height", entity_type: "catalog_product"}, {attribute_code: "benuta_fuellmaterial", entity_type: "catalog_product"}, {attribute_code: "benuta_living_area", entity_type: "catalog_product"}, {attribute_code: "benuta_floor_heating", entity_type: "catalog_product"}, {attribute_code: "benuta_motive_design", entity_type: "catalog_product"}, {attribute_code: "benuta_production_type", entity_type: "catalog_product"}, {attribute_code: "benuta_form_new", entity_type: "catalog_product"}, {attribute_code: "benuta_pile_material", entity_type: "catalog_product"}, {attribute_code: "benuta_waschbar", entity_type: "catalog_product"}, {attribute_code: "benuta_color_filter", entity_type: "catalog_product"}, {attribute_code: "benuta_collection", entity_type: "catalog_product"}, {attribute_code: "benuta_rueckseite", entity_type: "catalog_product"}]
  ) {
    items {
      attribute_code
      attribute_type
      attribute_options {
        value
        label
      }
    }
  }
}
    `;
export const useCustomAttributeMetadataQuery = <
      TData = CustomAttributeMetadataQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomAttributeMetadataQueryVariables,
      options?: UseQueryOptions<CustomAttributeMetadataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomAttributeMetadataQuery, TError, TData>(
      variables === undefined ? ['CustomAttributeMetadata'] : ['CustomAttributeMetadata', variables],
      fetcher<CustomAttributeMetadataQuery, CustomAttributeMetadataQueryVariables>(client, CustomAttributeMetadataDocument, variables, headers),
      options
    );
useCustomAttributeMetadataQuery.document = CustomAttributeMetadataDocument;


useCustomAttributeMetadataQuery.getKey = (variables?: CustomAttributeMetadataQueryVariables) => variables === undefined ? ['CustomAttributeMetadata'] : ['CustomAttributeMetadata', variables];
;

export const useInfiniteCustomAttributeMetadataQuery = <
      TData = CustomAttributeMetadataQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomAttributeMetadataQueryVariables,
      client: GraphQLClient,
      variables?: CustomAttributeMetadataQueryVariables,
      options?: UseInfiniteQueryOptions<CustomAttributeMetadataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomAttributeMetadataQuery, TError, TData>(
      variables === undefined ? ['CustomAttributeMetadata.infinite'] : ['CustomAttributeMetadata.infinite', variables],
      (metaData) => fetcher<CustomAttributeMetadataQuery, CustomAttributeMetadataQueryVariables>(client, CustomAttributeMetadataDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomAttributeMetadataQuery.getKey = (variables?: CustomAttributeMetadataQueryVariables) => variables === undefined ? ['CustomAttributeMetadata.infinite'] : ['CustomAttributeMetadata.infinite', variables];
;

export const CustomerAddressesDocument = `
    query customerAddresses {
  customer {
    addresses {
      id
      city
      company
      country_code
      default_billing
      default_shipping
      firstname
      lastname
      postcode
      prefix
      street
      telephone
    }
  }
}
    `;
export const useCustomerAddressesQuery = <
      TData = CustomerAddressesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerAddressesQueryVariables,
      options?: UseQueryOptions<CustomerAddressesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerAddressesQuery, TError, TData>(
      variables === undefined ? ['customerAddresses'] : ['customerAddresses', variables],
      fetcher<CustomerAddressesQuery, CustomerAddressesQueryVariables>(client, CustomerAddressesDocument, variables, headers),
      options
    );
useCustomerAddressesQuery.document = CustomerAddressesDocument;


useCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['customerAddresses'] : ['customerAddresses', variables];
;

export const useInfiniteCustomerAddressesQuery = <
      TData = CustomerAddressesQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerAddressesQueryVariables,
      client: GraphQLClient,
      variables?: CustomerAddressesQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerAddressesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerAddressesQuery, TError, TData>(
      variables === undefined ? ['customerAddresses.infinite'] : ['customerAddresses.infinite', variables],
      (metaData) => fetcher<CustomerAddressesQuery, CustomerAddressesQueryVariables>(client, CustomerAddressesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['customerAddresses.infinite'] : ['customerAddresses.infinite', variables];
;

export const CustomerCartDocument = `
    query customerCart {
  customerCart {
    id
    billing_address {
      __typename
    }
    shipping_addresses {
      __typename
      selected_shipping_method {
        method_code
      }
    }
  }
}
    `;
export const useCustomerCartQuery = <
      TData = CustomerCartQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerCartQueryVariables,
      options?: UseQueryOptions<CustomerCartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerCartQuery, TError, TData>(
      variables === undefined ? ['customerCart'] : ['customerCart', variables],
      fetcher<CustomerCartQuery, CustomerCartQueryVariables>(client, CustomerCartDocument, variables, headers),
      options
    );
useCustomerCartQuery.document = CustomerCartDocument;


useCustomerCartQuery.getKey = (variables?: CustomerCartQueryVariables) => variables === undefined ? ['customerCart'] : ['customerCart', variables];
;

export const useInfiniteCustomerCartQuery = <
      TData = CustomerCartQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerCartQueryVariables,
      client: GraphQLClient,
      variables?: CustomerCartQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerCartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerCartQuery, TError, TData>(
      variables === undefined ? ['customerCart.infinite'] : ['customerCart.infinite', variables],
      (metaData) => fetcher<CustomerCartQuery, CustomerCartQueryVariables>(client, CustomerCartDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerCartQuery.getKey = (variables?: CustomerCartQueryVariables) => variables === undefined ? ['customerCart.infinite'] : ['customerCart.infinite', variables];
;

export const CustomerDataDocument = `
    query CustomerData {
  first_time_customer
  live_time_value
}
    `;
export const useCustomerDataQuery = <
      TData = CustomerDataQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerDataQueryVariables,
      options?: UseQueryOptions<CustomerDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerDataQuery, TError, TData>(
      variables === undefined ? ['CustomerData'] : ['CustomerData', variables],
      fetcher<CustomerDataQuery, CustomerDataQueryVariables>(client, CustomerDataDocument, variables, headers),
      options
    );
useCustomerDataQuery.document = CustomerDataDocument;


useCustomerDataQuery.getKey = (variables?: CustomerDataQueryVariables) => variables === undefined ? ['CustomerData'] : ['CustomerData', variables];
;

export const useInfiniteCustomerDataQuery = <
      TData = CustomerDataQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerDataQueryVariables,
      client: GraphQLClient,
      variables?: CustomerDataQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerDataQuery, TError, TData>(
      variables === undefined ? ['CustomerData.infinite'] : ['CustomerData.infinite', variables],
      (metaData) => fetcher<CustomerDataQuery, CustomerDataQueryVariables>(client, CustomerDataDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerDataQuery.getKey = (variables?: CustomerDataQueryVariables) => variables === undefined ? ['CustomerData.infinite'] : ['CustomerData.infinite', variables];
;

export const CustomerInformationDocument = `
    query customerInformation {
  customer {
    firstname
    lastname
    email
  }
}
    `;
export const useCustomerInformationQuery = <
      TData = CustomerInformationQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerInformationQueryVariables,
      options?: UseQueryOptions<CustomerInformationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerInformationQuery, TError, TData>(
      variables === undefined ? ['customerInformation'] : ['customerInformation', variables],
      fetcher<CustomerInformationQuery, CustomerInformationQueryVariables>(client, CustomerInformationDocument, variables, headers),
      options
    );
useCustomerInformationQuery.document = CustomerInformationDocument;


useCustomerInformationQuery.getKey = (variables?: CustomerInformationQueryVariables) => variables === undefined ? ['customerInformation'] : ['customerInformation', variables];
;

export const useInfiniteCustomerInformationQuery = <
      TData = CustomerInformationQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerInformationQueryVariables,
      client: GraphQLClient,
      variables?: CustomerInformationQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerInformationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerInformationQuery, TError, TData>(
      variables === undefined ? ['customerInformation.infinite'] : ['customerInformation.infinite', variables],
      (metaData) => fetcher<CustomerInformationQuery, CustomerInformationQueryVariables>(client, CustomerInformationDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerInformationQuery.getKey = (variables?: CustomerInformationQueryVariables) => variables === undefined ? ['customerInformation.infinite'] : ['customerInformation.infinite', variables];
;

export const CustomerNewsletterSubscriptionDocument = `
    query customerNewsletterSubscription {
  customer {
    firstname
    email
    is_subscribed
  }
}
    `;
export const useCustomerNewsletterSubscriptionQuery = <
      TData = CustomerNewsletterSubscriptionQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerNewsletterSubscriptionQueryVariables,
      options?: UseQueryOptions<CustomerNewsletterSubscriptionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerNewsletterSubscriptionQuery, TError, TData>(
      variables === undefined ? ['customerNewsletterSubscription'] : ['customerNewsletterSubscription', variables],
      fetcher<CustomerNewsletterSubscriptionQuery, CustomerNewsletterSubscriptionQueryVariables>(client, CustomerNewsletterSubscriptionDocument, variables, headers),
      options
    );
useCustomerNewsletterSubscriptionQuery.document = CustomerNewsletterSubscriptionDocument;


useCustomerNewsletterSubscriptionQuery.getKey = (variables?: CustomerNewsletterSubscriptionQueryVariables) => variables === undefined ? ['customerNewsletterSubscription'] : ['customerNewsletterSubscription', variables];
;

export const useInfiniteCustomerNewsletterSubscriptionQuery = <
      TData = CustomerNewsletterSubscriptionQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerNewsletterSubscriptionQueryVariables,
      client: GraphQLClient,
      variables?: CustomerNewsletterSubscriptionQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerNewsletterSubscriptionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerNewsletterSubscriptionQuery, TError, TData>(
      variables === undefined ? ['customerNewsletterSubscription.infinite'] : ['customerNewsletterSubscription.infinite', variables],
      (metaData) => fetcher<CustomerNewsletterSubscriptionQuery, CustomerNewsletterSubscriptionQueryVariables>(client, CustomerNewsletterSubscriptionDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerNewsletterSubscriptionQuery.getKey = (variables?: CustomerNewsletterSubscriptionQueryVariables) => variables === undefined ? ['customerNewsletterSubscription.infinite'] : ['customerNewsletterSubscription.infinite', variables];
;

export const CustomerOrderByIdDocument = `
    query customerOrderById($id: String) {
  customer {
    email
    orders(filter: {number: {eq: $id}}) {
      items {
        id
        number
        order_date
        items {
          id
          product_sku
          product_name
          product_sale_price {
            currency
            value
          }
          product_url_key
          quantity_ordered
          selected_options {
            label
            value
          }
        }
        shipping_address {
          firstname
          middlename
          lastname
          street
          city
          prefix
          suffix
          postcode
          telephone
          company
          country_code
        }
        billing_address {
          firstname
          middlename
          lastname
          street
          city
          prefix
          suffix
          postcode
          telephone
          company
          country_code
        }
        payment_methods {
          name
          type
          additional_data {
            name
            value
          }
        }
        shipping_method
        total {
          subtotal {
            currency
            value
          }
          discounts {
            amount {
              currency
              value
            }
            label
          }
          taxes {
            amount {
              currency
              value
            }
            rate
            title
          }
          total_shipping {
            currency
            value
          }
          grand_total {
            currency
            value
          }
        }
      }
    }
  }
}
    `;
export const useCustomerOrderByIdQuery = <
      TData = CustomerOrderByIdQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerOrderByIdQueryVariables,
      options?: UseQueryOptions<CustomerOrderByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerOrderByIdQuery, TError, TData>(
      variables === undefined ? ['customerOrderById'] : ['customerOrderById', variables],
      fetcher<CustomerOrderByIdQuery, CustomerOrderByIdQueryVariables>(client, CustomerOrderByIdDocument, variables, headers),
      options
    );
useCustomerOrderByIdQuery.document = CustomerOrderByIdDocument;


useCustomerOrderByIdQuery.getKey = (variables?: CustomerOrderByIdQueryVariables) => variables === undefined ? ['customerOrderById'] : ['customerOrderById', variables];
;

export const useInfiniteCustomerOrderByIdQuery = <
      TData = CustomerOrderByIdQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerOrderByIdQueryVariables,
      client: GraphQLClient,
      variables?: CustomerOrderByIdQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerOrderByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerOrderByIdQuery, TError, TData>(
      variables === undefined ? ['customerOrderById.infinite'] : ['customerOrderById.infinite', variables],
      (metaData) => fetcher<CustomerOrderByIdQuery, CustomerOrderByIdQueryVariables>(client, CustomerOrderByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerOrderByIdQuery.getKey = (variables?: CustomerOrderByIdQueryVariables) => variables === undefined ? ['customerOrderById.infinite'] : ['customerOrderById.infinite', variables];
;

export const CustomerOrderReturnsDocument = `
    query customerOrderReturns($page: Int) {
  customer {
    returns(currentPage: $page) {
      items {
        uid
        number
        created_at
        customer {
          firstname
          lastname
        }
        order {
          total {
            grand_total {
              currency
              value
            }
          }
        }
        status
      }
    }
  }
}
    `;
export const useCustomerOrderReturnsQuery = <
      TData = CustomerOrderReturnsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerOrderReturnsQueryVariables,
      options?: UseQueryOptions<CustomerOrderReturnsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerOrderReturnsQuery, TError, TData>(
      variables === undefined ? ['customerOrderReturns'] : ['customerOrderReturns', variables],
      fetcher<CustomerOrderReturnsQuery, CustomerOrderReturnsQueryVariables>(client, CustomerOrderReturnsDocument, variables, headers),
      options
    );
useCustomerOrderReturnsQuery.document = CustomerOrderReturnsDocument;


useCustomerOrderReturnsQuery.getKey = (variables?: CustomerOrderReturnsQueryVariables) => variables === undefined ? ['customerOrderReturns'] : ['customerOrderReturns', variables];
;

export const useInfiniteCustomerOrderReturnsQuery = <
      TData = CustomerOrderReturnsQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerOrderReturnsQueryVariables,
      client: GraphQLClient,
      variables?: CustomerOrderReturnsQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerOrderReturnsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerOrderReturnsQuery, TError, TData>(
      variables === undefined ? ['customerOrderReturns.infinite'] : ['customerOrderReturns.infinite', variables],
      (metaData) => fetcher<CustomerOrderReturnsQuery, CustomerOrderReturnsQueryVariables>(client, CustomerOrderReturnsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerOrderReturnsQuery.getKey = (variables?: CustomerOrderReturnsQueryVariables) => variables === undefined ? ['customerOrderReturns.infinite'] : ['customerOrderReturns.infinite', variables];
;

export const CustomerOrdersDocument = `
    query customerOrders($page: Int) {
  customer {
    ordersReversed(currentPage: $page) {
      page_info {
        current_page
        total_pages
        page_size
      }
      items {
        id
        shipping_address {
          firstname
          middlename
          lastname
        }
        number
        status
        order_date
        total {
          grand_total {
            value
            currency
          }
        }
      }
    }
  }
}
    `;
export const useCustomerOrdersQuery = <
      TData = CustomerOrdersQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: CustomerOrdersQueryVariables,
      options?: UseQueryOptions<CustomerOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerOrdersQuery, TError, TData>(
      variables === undefined ? ['customerOrders'] : ['customerOrders', variables],
      fetcher<CustomerOrdersQuery, CustomerOrdersQueryVariables>(client, CustomerOrdersDocument, variables, headers),
      options
    );
useCustomerOrdersQuery.document = CustomerOrdersDocument;


useCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['customerOrders'] : ['customerOrders', variables];
;

export const useInfiniteCustomerOrdersQuery = <
      TData = CustomerOrdersQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerOrdersQueryVariables,
      client: GraphQLClient,
      variables?: CustomerOrdersQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerOrdersQuery, TError, TData>(
      variables === undefined ? ['customerOrders.infinite'] : ['customerOrders.infinite', variables],
      (metaData) => fetcher<CustomerOrdersQuery, CustomerOrdersQueryVariables>(client, CustomerOrdersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['customerOrders.infinite'] : ['customerOrders.infinite', variables];
;

export const CustomerReturnByIdDocument = `
    query customerReturnById($id: ID!) {
  customer {
    return(uid: $id) {
      number
      created_at
      customer {
        email
      }
      order {
        id
        number
        order_date
        shipping_address {
          firstname
          middlename
          lastname
          street
          city
          prefix
          suffix
          postcode
          telephone
          company
          country_code
        }
      }
      items {
        uid
        request_quantity
        status
        order_item {
          product_name
          product_sku
        }
      }
    }
  }
}
    `;
export const useCustomerReturnByIdQuery = <
      TData = CustomerReturnByIdQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CustomerReturnByIdQueryVariables,
      options?: UseQueryOptions<CustomerReturnByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerReturnByIdQuery, TError, TData>(
      ['customerReturnById', variables],
      fetcher<CustomerReturnByIdQuery, CustomerReturnByIdQueryVariables>(client, CustomerReturnByIdDocument, variables, headers),
      options
    );
useCustomerReturnByIdQuery.document = CustomerReturnByIdDocument;


useCustomerReturnByIdQuery.getKey = (variables: CustomerReturnByIdQueryVariables) => ['customerReturnById', variables];
;

export const useInfiniteCustomerReturnByIdQuery = <
      TData = CustomerReturnByIdQuery,
      TError = Error
    >(
      _pageParamKey: keyof CustomerReturnByIdQueryVariables,
      client: GraphQLClient,
      variables: CustomerReturnByIdQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerReturnByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CustomerReturnByIdQuery, TError, TData>(
      ['customerReturnById.infinite', variables],
      (metaData) => fetcher<CustomerReturnByIdQuery, CustomerReturnByIdQueryVariables>(client, CustomerReturnByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteCustomerReturnByIdQuery.getKey = (variables: CustomerReturnByIdQueryVariables) => ['customerReturnById.infinite', variables];
;

export const DeleteCustomerAddressDocument = `
    mutation deleteCustomerAddress($id: Int!) {
  deleteCustomerAddress(id: $id)
}
    `;
export const useDeleteCustomerAddressMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCustomerAddressMutation, TError, DeleteCustomerAddressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCustomerAddressMutation, TError, DeleteCustomerAddressMutationVariables, TContext>(
      ['deleteCustomerAddress'],
      (variables?: DeleteCustomerAddressMutationVariables) => fetcher<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>(client, DeleteCustomerAddressDocument, variables, headers)(),
      options
    );
useDeleteCustomerAddressMutation.getKey = () => ['deleteCustomerAddress'];

export const DeleteCustomerNewsletterSubscriptionDocument = `
    mutation deleteCustomerNewsletterSubscription {
  updateCustomerV2(input: {is_subscribed: false}) {
    customer {
      firstname
    }
  }
}
    `;
export const useDeleteCustomerNewsletterSubscriptionMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCustomerNewsletterSubscriptionMutation, TError, DeleteCustomerNewsletterSubscriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCustomerNewsletterSubscriptionMutation, TError, DeleteCustomerNewsletterSubscriptionMutationVariables, TContext>(
      ['deleteCustomerNewsletterSubscription'],
      (variables?: DeleteCustomerNewsletterSubscriptionMutationVariables) => fetcher<DeleteCustomerNewsletterSubscriptionMutation, DeleteCustomerNewsletterSubscriptionMutationVariables>(client, DeleteCustomerNewsletterSubscriptionDocument, variables, headers)(),
      options
    );
useDeleteCustomerNewsletterSubscriptionMutation.getKey = () => ['deleteCustomerNewsletterSubscription'];

export const FetchCartHeaderDocument = `
    query FetchCartHeader($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    total_quantity
    email
    items {
      ... on ConfigurableCartItem {
        configurable_options {
          value_label
        }
        configured_variant {
          eannummer
          sku
          price_range {
            minimum_price {
              final_price {
                value
                currency
              }
              regular_price {
                value
                currency
              }
            }
          }
        }
      }
      quantity
      uid
      prices {
        price {
          value
          currency
        }
        row_total_including_tax {
          value
          currency
        }
      }
      product {
        sku
        eannummer
        manufacturer
        url_rewrites {
          url
        }
        price_range {
          minimum_price {
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
            fixed_product_taxes {
              amount {
                value
              }
            }
          }
        }
        name
        image {
          url
          label
        }
      }
    }
    prices {
      subtotal_including_tax {
        value
        currency
      }
      grand_total {
        value
        currency
      }
      applied_taxes {
        amount {
          value
          currency
        }
      }
    }
    shipping_addresses {
      selected_shipping_method {
        method_code
        method_title
        amount {
          currency
          value
        }
      }
      available_shipping_methods {
        method_code
        price_incl_tax {
          value
          currency
        }
      }
    }
  }
}
    `;
export const useFetchCartHeaderQuery = <
      TData = FetchCartHeaderQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: FetchCartHeaderQueryVariables,
      options?: UseQueryOptions<FetchCartHeaderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchCartHeaderQuery, TError, TData>(
      ['FetchCartHeader', variables],
      fetcher<FetchCartHeaderQuery, FetchCartHeaderQueryVariables>(client, FetchCartHeaderDocument, variables, headers),
      options
    );
useFetchCartHeaderQuery.document = FetchCartHeaderDocument;


useFetchCartHeaderQuery.getKey = (variables: FetchCartHeaderQueryVariables) => ['FetchCartHeader', variables];
;

export const useInfiniteFetchCartHeaderQuery = <
      TData = FetchCartHeaderQuery,
      TError = Error
    >(
      _pageParamKey: keyof FetchCartHeaderQueryVariables,
      client: GraphQLClient,
      variables: FetchCartHeaderQueryVariables,
      options?: UseInfiniteQueryOptions<FetchCartHeaderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<FetchCartHeaderQuery, TError, TData>(
      ['FetchCartHeader.infinite', variables],
      (metaData) => fetcher<FetchCartHeaderQuery, FetchCartHeaderQueryVariables>(client, FetchCartHeaderDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteFetchCartHeaderQuery.getKey = (variables: FetchCartHeaderQueryVariables) => ['FetchCartHeader.infinite', variables];
;

export const FetchUserWishlistDocument = `
    query FetchUserWishlist {
  customer {
    wishlists {
      items_v2 {
        items {
          product {
            __typename
            uid
            ... on ConfigurableProduct {
              configurable_options {
                attribute_uid
                attribute_code
                values {
                  label
                  uid
                }
              }
              variants {
                attributes {
                  code
                  label
                  uid
                  value_index
                }
                product {
                  ... on SimpleProduct {
                    id
                    url_key
                    url_rewrites {
                      url
                    }
                    only_x_left_in_stock
                    stock_status
                    sku
                    uid
                    price_range {
                      minimum_price {
                        regular_price {
                          currency
                          value
                        }
                        final_price {
                          currency
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
            name
            uid
            url_key
            url_rewrites {
              url
            }
            sku
            image {
              url
              label
              disabled
              position
            }
            media_gallery {
              url
              position
              label
              disabled
            }
            price_range {
              minimum_price {
                regular_price {
                  currency
                  value
                }
                final_price {
                  currency
                  value
                }
              }
            }
            benuta_ar
            manufacturer
            umsatz
            benuta_test_seal
            benuta_pile_material
            benuta_production_type
          }
        }
      }
    }
  }
}
    `;
export const useFetchUserWishlistQuery = <
      TData = FetchUserWishlistQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: FetchUserWishlistQueryVariables,
      options?: UseQueryOptions<FetchUserWishlistQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchUserWishlistQuery, TError, TData>(
      variables === undefined ? ['FetchUserWishlist'] : ['FetchUserWishlist', variables],
      fetcher<FetchUserWishlistQuery, FetchUserWishlistQueryVariables>(client, FetchUserWishlistDocument, variables, headers),
      options
    );
useFetchUserWishlistQuery.document = FetchUserWishlistDocument;


useFetchUserWishlistQuery.getKey = (variables?: FetchUserWishlistQueryVariables) => variables === undefined ? ['FetchUserWishlist'] : ['FetchUserWishlist', variables];
;

export const useInfiniteFetchUserWishlistQuery = <
      TData = FetchUserWishlistQuery,
      TError = Error
    >(
      _pageParamKey: keyof FetchUserWishlistQueryVariables,
      client: GraphQLClient,
      variables?: FetchUserWishlistQueryVariables,
      options?: UseInfiniteQueryOptions<FetchUserWishlistQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<FetchUserWishlistQuery, TError, TData>(
      variables === undefined ? ['FetchUserWishlist.infinite'] : ['FetchUserWishlist.infinite', variables],
      (metaData) => fetcher<FetchUserWishlistQuery, FetchUserWishlistQueryVariables>(client, FetchUserWishlistDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteFetchUserWishlistQuery.getKey = (variables?: FetchUserWishlistQueryVariables) => variables === undefined ? ['FetchUserWishlist.infinite'] : ['FetchUserWishlist.infinite', variables];
;

export const FetchWishlistProductsDocument = `
    query FetchWishlistProducts($sku: [String]!) {
  products(filter: {sku: {in: $sku}}) {
    items {
      __typename
      ... on ConfigurableProduct {
        configurable_options {
          attribute_uid
          attribute_code
          values {
            label
            uid
          }
        }
        variants {
          attributes {
            code
            label
            uid
            value_index
          }
          product {
            ... on SimpleProduct {
              id
              url_key
              url_rewrites {
                url
              }
              only_x_left_in_stock
              stock_status
              sku
              uid
              price_range {
                minimum_price {
                  regular_price {
                    currency
                    value
                  }
                  final_price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
      name
      uid
      url_key
      url_rewrites {
        url
      }
      sku
      image {
        url
        label
        disabled
        position
      }
      media_gallery {
        url
        position
        label
        disabled
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      benuta_ar
      manufacturer
      umsatz
      benuta_test_seal
      benuta_pile_material
      benuta_production_type
    }
  }
}
    `;
export const useFetchWishlistProductsQuery = <
      TData = FetchWishlistProductsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: FetchWishlistProductsQueryVariables,
      options?: UseQueryOptions<FetchWishlistProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchWishlistProductsQuery, TError, TData>(
      ['FetchWishlistProducts', variables],
      fetcher<FetchWishlistProductsQuery, FetchWishlistProductsQueryVariables>(client, FetchWishlistProductsDocument, variables, headers),
      options
    );
useFetchWishlistProductsQuery.document = FetchWishlistProductsDocument;


useFetchWishlistProductsQuery.getKey = (variables: FetchWishlistProductsQueryVariables) => ['FetchWishlistProducts', variables];
;

export const useInfiniteFetchWishlistProductsQuery = <
      TData = FetchWishlistProductsQuery,
      TError = Error
    >(
      _pageParamKey: keyof FetchWishlistProductsQueryVariables,
      client: GraphQLClient,
      variables: FetchWishlistProductsQueryVariables,
      options?: UseInfiniteQueryOptions<FetchWishlistProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<FetchWishlistProductsQuery, TError, TData>(
      ['FetchWishlistProducts.infinite', variables],
      (metaData) => fetcher<FetchWishlistProductsQuery, FetchWishlistProductsQueryVariables>(client, FetchWishlistProductsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteFetchWishlistProductsQuery.getKey = (variables: FetchWishlistProductsQueryVariables) => ['FetchWishlistProducts.infinite', variables];
;

export const GetAdyenPaymentMethodsDocument = `
    query getAdyenPaymentMethods($cartId: String!) {
  adyenPaymentMethods(cart_id: $cartId) {
    paymentMethodsExtraDetails {
      type
      icon {
        url
        width
        height
      }
      isOpenInvoice
      configuration {
        amount {
          value
          currency
        }
        currency
      }
    }
    paymentMethodsResponse {
      paymentMethods {
        name
        type
        brand
        brands
        issuers {
          id
          name
        }
        configuration {
          merchantId
          merchantName
          gatewayMerchantId
        }
      }
    }
  }
}
    `;
export const useGetAdyenPaymentMethodsQuery = <
      TData = GetAdyenPaymentMethodsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: GetAdyenPaymentMethodsQueryVariables,
      options?: UseQueryOptions<GetAdyenPaymentMethodsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAdyenPaymentMethodsQuery, TError, TData>(
      ['getAdyenPaymentMethods', variables],
      fetcher<GetAdyenPaymentMethodsQuery, GetAdyenPaymentMethodsQueryVariables>(client, GetAdyenPaymentMethodsDocument, variables, headers),
      options
    );
useGetAdyenPaymentMethodsQuery.document = GetAdyenPaymentMethodsDocument;


useGetAdyenPaymentMethodsQuery.getKey = (variables: GetAdyenPaymentMethodsQueryVariables) => ['getAdyenPaymentMethods', variables];
;

export const useInfiniteGetAdyenPaymentMethodsQuery = <
      TData = GetAdyenPaymentMethodsQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetAdyenPaymentMethodsQueryVariables,
      client: GraphQLClient,
      variables: GetAdyenPaymentMethodsQueryVariables,
      options?: UseInfiniteQueryOptions<GetAdyenPaymentMethodsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetAdyenPaymentMethodsQuery, TError, TData>(
      ['getAdyenPaymentMethods.infinite', variables],
      (metaData) => fetcher<GetAdyenPaymentMethodsQuery, GetAdyenPaymentMethodsQueryVariables>(client, GetAdyenPaymentMethodsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetAdyenPaymentMethodsQuery.getKey = (variables: GetAdyenPaymentMethodsQueryVariables) => ['getAdyenPaymentMethods.infinite', variables];
;

export const GetAdyenPaymentStatusDocument = `
    query getAdyenPaymentStatus($orderNumber: String!, $cartId: String!) {
  adyenPaymentStatus(orderNumber: $orderNumber, cartId: $cartId) {
    isFinal
    resultCode
    additionalData
    action
  }
}
    `;
export const useGetAdyenPaymentStatusQuery = <
      TData = GetAdyenPaymentStatusQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: GetAdyenPaymentStatusQueryVariables,
      options?: UseQueryOptions<GetAdyenPaymentStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAdyenPaymentStatusQuery, TError, TData>(
      ['getAdyenPaymentStatus', variables],
      fetcher<GetAdyenPaymentStatusQuery, GetAdyenPaymentStatusQueryVariables>(client, GetAdyenPaymentStatusDocument, variables, headers),
      options
    );
useGetAdyenPaymentStatusQuery.document = GetAdyenPaymentStatusDocument;


useGetAdyenPaymentStatusQuery.getKey = (variables: GetAdyenPaymentStatusQueryVariables) => ['getAdyenPaymentStatus', variables];
;

export const useInfiniteGetAdyenPaymentStatusQuery = <
      TData = GetAdyenPaymentStatusQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetAdyenPaymentStatusQueryVariables,
      client: GraphQLClient,
      variables: GetAdyenPaymentStatusQueryVariables,
      options?: UseInfiniteQueryOptions<GetAdyenPaymentStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetAdyenPaymentStatusQuery, TError, TData>(
      ['getAdyenPaymentStatus.infinite', variables],
      (metaData) => fetcher<GetAdyenPaymentStatusQuery, GetAdyenPaymentStatusQueryVariables>(client, GetAdyenPaymentStatusDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetAdyenPaymentStatusQuery.getKey = (variables: GetAdyenPaymentStatusQueryVariables) => ['getAdyenPaymentStatus.infinite', variables];
;

export const GetCustomerDocument = `
    query getCustomer {
  customer {
    firstname
    lastname
    email
  }
}
    `;
export const useGetCustomerQuery = <
      TData = GetCustomerQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: GetCustomerQueryVariables,
      options?: UseQueryOptions<GetCustomerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCustomerQuery, TError, TData>(
      variables === undefined ? ['getCustomer'] : ['getCustomer', variables],
      fetcher<GetCustomerQuery, GetCustomerQueryVariables>(client, GetCustomerDocument, variables, headers),
      options
    );
useGetCustomerQuery.document = GetCustomerDocument;


useGetCustomerQuery.getKey = (variables?: GetCustomerQueryVariables) => variables === undefined ? ['getCustomer'] : ['getCustomer', variables];
;

export const useInfiniteGetCustomerQuery = <
      TData = GetCustomerQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetCustomerQueryVariables,
      client: GraphQLClient,
      variables?: GetCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<GetCustomerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetCustomerQuery, TError, TData>(
      variables === undefined ? ['getCustomer.infinite'] : ['getCustomer.infinite', variables],
      (metaData) => fetcher<GetCustomerQuery, GetCustomerQueryVariables>(client, GetCustomerDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetCustomerQuery.getKey = (variables?: GetCustomerQueryVariables) => variables === undefined ? ['getCustomer.infinite'] : ['getCustomer.infinite', variables];
;

export const GetProductsViaSkuDocument = `
    query GetProductsViaSku($sku: [String]!) {
  products(filter: {sku: {in: $sku}}) {
    items {
      __typename
      ... on ConfigurableProduct {
        configurable_options {
          attribute_uid
          attribute_code
          values {
            label
            uid
          }
        }
      }
      name
      manufacturer
      created_at
      umsatz
      benuta_production_type
      benuta_waschbar
      benuta_ar
      benuta_test_seal
      uid
      url_key
      url_rewrites {
        url
      }
      sku
      image {
        url
        label
        disabled
        position
      }
      thumbnail {
        url
        label
        disabled
        position
      }
      media_gallery {
        url
        position
        label
        disabled
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      related_products {
        url_key
        url_rewrites {
          url
        }
        thumbnail {
          url
          label
          disabled
          position
        }
        image {
          url
          label
          disabled
        }
      }
    }
  }
}
    `;
export const useGetProductsViaSkuQuery = <
      TData = GetProductsViaSkuQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: GetProductsViaSkuQueryVariables,
      options?: UseQueryOptions<GetProductsViaSkuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductsViaSkuQuery, TError, TData>(
      ['GetProductsViaSku', variables],
      fetcher<GetProductsViaSkuQuery, GetProductsViaSkuQueryVariables>(client, GetProductsViaSkuDocument, variables, headers),
      options
    );
useGetProductsViaSkuQuery.document = GetProductsViaSkuDocument;


useGetProductsViaSkuQuery.getKey = (variables: GetProductsViaSkuQueryVariables) => ['GetProductsViaSku', variables];
;

export const useInfiniteGetProductsViaSkuQuery = <
      TData = GetProductsViaSkuQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetProductsViaSkuQueryVariables,
      client: GraphQLClient,
      variables: GetProductsViaSkuQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductsViaSkuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetProductsViaSkuQuery, TError, TData>(
      ['GetProductsViaSku.infinite', variables],
      (metaData) => fetcher<GetProductsViaSkuQuery, GetProductsViaSkuQueryVariables>(client, GetProductsViaSkuDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetProductsViaSkuQuery.getKey = (variables: GetProductsViaSkuQueryVariables) => ['GetProductsViaSku.infinite', variables];
;

export const GetSovendusDataDocument = `
    query getSovendusData {
  getSovendusData {
    trafficMediumNumber
    trafficSourceNumber
  }
}
    `;
export const useGetSovendusDataQuery = <
      TData = GetSovendusDataQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: GetSovendusDataQueryVariables,
      options?: UseQueryOptions<GetSovendusDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSovendusDataQuery, TError, TData>(
      variables === undefined ? ['getSovendusData'] : ['getSovendusData', variables],
      fetcher<GetSovendusDataQuery, GetSovendusDataQueryVariables>(client, GetSovendusDataDocument, variables, headers),
      options
    );
useGetSovendusDataQuery.document = GetSovendusDataDocument;


useGetSovendusDataQuery.getKey = (variables?: GetSovendusDataQueryVariables) => variables === undefined ? ['getSovendusData'] : ['getSovendusData', variables];
;

export const useInfiniteGetSovendusDataQuery = <
      TData = GetSovendusDataQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetSovendusDataQueryVariables,
      client: GraphQLClient,
      variables?: GetSovendusDataQueryVariables,
      options?: UseInfiniteQueryOptions<GetSovendusDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetSovendusDataQuery, TError, TData>(
      variables === undefined ? ['getSovendusData.infinite'] : ['getSovendusData.infinite', variables],
      (metaData) => fetcher<GetSovendusDataQuery, GetSovendusDataQueryVariables>(client, GetSovendusDataDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetSovendusDataQuery.getKey = (variables?: GetSovendusDataQueryVariables) => variables === undefined ? ['getSovendusData.infinite'] : ['getSovendusData.infinite', variables];
;

export const GetWishlistIdDocument = `
    query GetWishlistId {
  customer {
    wishlists {
      id
      items_v2 {
        items {
          id
          product {
            sku
          }
        }
      }
    }
  }
}
    `;
export const useGetWishlistIdQuery = <
      TData = GetWishlistIdQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: GetWishlistIdQueryVariables,
      options?: UseQueryOptions<GetWishlistIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWishlistIdQuery, TError, TData>(
      variables === undefined ? ['GetWishlistId'] : ['GetWishlistId', variables],
      fetcher<GetWishlistIdQuery, GetWishlistIdQueryVariables>(client, GetWishlistIdDocument, variables, headers),
      options
    );
useGetWishlistIdQuery.document = GetWishlistIdDocument;


useGetWishlistIdQuery.getKey = (variables?: GetWishlistIdQueryVariables) => variables === undefined ? ['GetWishlistId'] : ['GetWishlistId', variables];
;

export const useInfiniteGetWishlistIdQuery = <
      TData = GetWishlistIdQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetWishlistIdQueryVariables,
      client: GraphQLClient,
      variables?: GetWishlistIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetWishlistIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetWishlistIdQuery, TError, TData>(
      variables === undefined ? ['GetWishlistId.infinite'] : ['GetWishlistId.infinite', variables],
      (metaData) => fetcher<GetWishlistIdQuery, GetWishlistIdQueryVariables>(client, GetWishlistIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetWishlistIdQuery.getKey = (variables?: GetWishlistIdQueryVariables) => variables === undefined ? ['GetWishlistId.infinite'] : ['GetWishlistId.infinite', variables];
;

export const KlarnaAuthorizeDocument = `
    mutation klarnaAuthorize($token: String!, $requestBody: String!) {
  klarnaAuthorize(token: $token, requestBody: $requestBody)
}
    `;
export const useKlarnaAuthorizeMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<KlarnaAuthorizeMutation, TError, KlarnaAuthorizeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<KlarnaAuthorizeMutation, TError, KlarnaAuthorizeMutationVariables, TContext>(
      ['klarnaAuthorize'],
      (variables?: KlarnaAuthorizeMutationVariables) => fetcher<KlarnaAuthorizeMutation, KlarnaAuthorizeMutationVariables>(client, KlarnaAuthorizeDocument, variables, headers)(),
      options
    );
useKlarnaAuthorizeMutation.getKey = () => ['klarnaAuthorize'];

export const MergeCartsDocument = `
    mutation MergeCarts($sourceCartId: String!, $destinationCartId: String!) {
  mergeCarts(
    source_cart_id: $sourceCartId
    destination_cart_id: $destinationCartId
  ) {
    items {
      uid
      quantity
    }
  }
}
    `;
export const useMergeCartsMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeCartsMutation, TError, MergeCartsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeCartsMutation, TError, MergeCartsMutationVariables, TContext>(
      ['MergeCarts'],
      (variables?: MergeCartsMutationVariables) => fetcher<MergeCartsMutation, MergeCartsMutationVariables>(client, MergeCartsDocument, variables, headers)(),
      options
    );
useMergeCartsMutation.getKey = () => ['MergeCarts'];

export const PdpDocument = `
    query Pdp($urlKey: String!) {
  products(filter: {url_key: {eq: $urlKey}}) {
    total_count
    items {
      name
      sku
      url_key
      url_rewrites {
        url
      }
      attribute_set_id
      id
      video_url
      benuta_color_filter
      benuta_living_area
      benuta_fuellmaterial
      benuta_floor_heating
      benuta_motive_design
      benuta_pile_height
      benuta_pile_material
      benuta_test_seal
      benuta_waschbar
      benuta_rueckseite
      benuta_production_type
      benuta_collection
      dimensions
      manufacturer
      created_at
      umsatz
      benuta_form_new
      benuta_verfuegbare_groessen
      benuta_ar
      ingredients
      warning_code
      lagerungshinweise
      categories {
        uid
        url_key
      }
      media_gallery {
        disabled
        label
        position
        url
      }
      ... on ConfigurableProduct {
        variants {
          attributes {
            code
            label
            uid
            value_index
          }
          product {
            ... on SimpleProduct {
              eannummer
              stock_status
              id
              url_key
              url_rewrites {
                url
              }
              sku
              uid
            }
          }
        }
      }
      description {
        html
      }
      small_image {
        url
        label
      }
      upsell_products {
        sku
      }
      related_products {
        sku
        name
        url_key
        url_rewrites {
          url
        }
        benuta_form_new
        small_image {
          url
          label
        }
        ... on ConfigurableProduct {
          variants {
            attributes {
              code
              label
              uid
              value_index
            }
            product {
              ... on SimpleProduct {
                stock_status
                id
                url_key
                url_rewrites {
                  url
                }
                sku
                uid
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const usePdpQuery = <
      TData = PdpQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: PdpQueryVariables,
      options?: UseQueryOptions<PdpQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PdpQuery, TError, TData>(
      ['Pdp', variables],
      fetcher<PdpQuery, PdpQueryVariables>(client, PdpDocument, variables, headers),
      options
    );
usePdpQuery.document = PdpDocument;


usePdpQuery.getKey = (variables: PdpQueryVariables) => ['Pdp', variables];
;

export const useInfinitePdpQuery = <
      TData = PdpQuery,
      TError = Error
    >(
      _pageParamKey: keyof PdpQueryVariables,
      client: GraphQLClient,
      variables: PdpQueryVariables,
      options?: UseInfiniteQueryOptions<PdpQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<PdpQuery, TError, TData>(
      ['Pdp.infinite', variables],
      (metaData) => fetcher<PdpQuery, PdpQueryVariables>(client, PdpDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfinitePdpQuery.getKey = (variables: PdpQueryVariables) => ['Pdp.infinite', variables];
;

export const PlaceOrderDocument = `
    mutation placeOrder($cartId: String!) {
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
    }
  }
}
    `;
export const usePlaceOrderMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PlaceOrderMutation, TError, PlaceOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PlaceOrderMutation, TError, PlaceOrderMutationVariables, TContext>(
      ['placeOrder'],
      (variables?: PlaceOrderMutationVariables) => fetcher<PlaceOrderMutation, PlaceOrderMutationVariables>(client, PlaceOrderDocument, variables, headers)(),
      options
    );
usePlaceOrderMutation.getKey = () => ['placeOrder'];

export const ProductCardDetailsDocument = `
    query ProductCardDetails($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      url_key
      name
      sku
      umsatz
      benuta_test_seal
      benuta_production_type
      benuta_pile_material
      benuta_waschbar
      benuta_ar
      created_at
      stock_status
      benuta_collection
      benuta_color_filter
      benuta_pile_material
      manufacturer
      benuta_motive_design
      media_gallery {
        disabled
        label
        position
        url
      }
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
      }
    }
  }
}
    `;
export const useProductCardDetailsQuery = <
      TData = ProductCardDetailsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductCardDetailsQueryVariables,
      options?: UseQueryOptions<ProductCardDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductCardDetailsQuery, TError, TData>(
      ['ProductCardDetails', variables],
      fetcher<ProductCardDetailsQuery, ProductCardDetailsQueryVariables>(client, ProductCardDetailsDocument, variables, headers),
      options
    );
useProductCardDetailsQuery.document = ProductCardDetailsDocument;


useProductCardDetailsQuery.getKey = (variables: ProductCardDetailsQueryVariables) => ['ProductCardDetails', variables];
;

export const useInfiniteProductCardDetailsQuery = <
      TData = ProductCardDetailsQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductCardDetailsQueryVariables,
      client: GraphQLClient,
      variables: ProductCardDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<ProductCardDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductCardDetailsQuery, TError, TData>(
      ['ProductCardDetails.infinite', variables],
      (metaData) => fetcher<ProductCardDetailsQuery, ProductCardDetailsQueryVariables>(client, ProductCardDetailsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductCardDetailsQuery.getKey = (variables: ProductCardDetailsQueryVariables) => ['ProductCardDetails.infinite', variables];
;

export const GetProductImageDocument = `
    query getProductImage($urlKey: String) {
  products(filter: {url_key: {eq: $urlKey}}) {
    items {
      image {
        url
      }
      name
    }
  }
}
    `;
export const useGetProductImageQuery = <
      TData = GetProductImageQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: GetProductImageQueryVariables,
      options?: UseQueryOptions<GetProductImageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductImageQuery, TError, TData>(
      variables === undefined ? ['getProductImage'] : ['getProductImage', variables],
      fetcher<GetProductImageQuery, GetProductImageQueryVariables>(client, GetProductImageDocument, variables, headers),
      options
    );
useGetProductImageQuery.document = GetProductImageDocument;


useGetProductImageQuery.getKey = (variables?: GetProductImageQueryVariables) => variables === undefined ? ['getProductImage'] : ['getProductImage', variables];
;

export const useInfiniteGetProductImageQuery = <
      TData = GetProductImageQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetProductImageQueryVariables,
      client: GraphQLClient,
      variables?: GetProductImageQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductImageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetProductImageQuery, TError, TData>(
      variables === undefined ? ['getProductImage.infinite'] : ['getProductImage.infinite', variables],
      (metaData) => fetcher<GetProductImageQuery, GetProductImageQueryVariables>(client, GetProductImageDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetProductImageQuery.getKey = (variables?: GetProductImageQueryVariables) => variables === undefined ? ['getProductImage.infinite'] : ['getProductImage.infinite', variables];
;

export const ProductPriceDocument = `
    query productPrice($urlKey: String!) {
  products(filter: {url_key: {eq: $urlKey}}) {
    items {
      stock_status
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      related_products {
        ... on ConfigurableProduct {
          variants {
            attributes {
              value_index
            }
            product {
              ... on SimpleProduct {
                stock_status
                price_range {
                  minimum_price {
                    regular_price {
                      currency
                      value
                    }
                    final_price {
                      currency
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          attributes {
            value_index
          }
          product {
            ... on SimpleProduct {
              stock_status
              price_range {
                minimum_price {
                  regular_price {
                    currency
                    value
                  }
                  final_price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useProductPriceQuery = <
      TData = ProductPriceQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductPriceQueryVariables,
      options?: UseQueryOptions<ProductPriceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductPriceQuery, TError, TData>(
      ['productPrice', variables],
      fetcher<ProductPriceQuery, ProductPriceQueryVariables>(client, ProductPriceDocument, variables, headers),
      options
    );
useProductPriceQuery.document = ProductPriceDocument;


useProductPriceQuery.getKey = (variables: ProductPriceQueryVariables) => ['productPrice', variables];
;

export const useInfiniteProductPriceQuery = <
      TData = ProductPriceQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductPriceQueryVariables,
      client: GraphQLClient,
      variables: ProductPriceQueryVariables,
      options?: UseInfiniteQueryOptions<ProductPriceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductPriceQuery, TError, TData>(
      ['productPrice.infinite', variables],
      (metaData) => fetcher<ProductPriceQuery, ProductPriceQueryVariables>(client, ProductPriceDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductPriceQuery.getKey = (variables: ProductPriceQueryVariables) => ['productPrice.infinite', variables];
;

export const ProductSizesDocument = `
    query ProductSizes($urlKey: String!) {
  products(filter: {url_key: {eq: $urlKey}}) {
    items {
      name
      sku
      url_key
      url_rewrites {
        url
      }
      benuta_form_new
      ... on ConfigurableProduct {
        variants {
          attributes {
            code
            label
            uid
            value_index
          }
          product {
            ... on SimpleProduct {
              id
              url_key
              url_rewrites {
                url
              }
              sku
              uid
              only_x_left_in_stock
              stock_status
              price_range {
                minimum_price {
                  regular_price {
                    currency
                    value
                  }
                  final_price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
    }
  }
}
    `;
export const useProductSizesQuery = <
      TData = ProductSizesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductSizesQueryVariables,
      options?: UseQueryOptions<ProductSizesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductSizesQuery, TError, TData>(
      ['ProductSizes', variables],
      fetcher<ProductSizesQuery, ProductSizesQueryVariables>(client, ProductSizesDocument, variables, headers),
      options
    );
useProductSizesQuery.document = ProductSizesDocument;


useProductSizesQuery.getKey = (variables: ProductSizesQueryVariables) => ['ProductSizes', variables];
;

export const useInfiniteProductSizesQuery = <
      TData = ProductSizesQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductSizesQueryVariables,
      client: GraphQLClient,
      variables: ProductSizesQueryVariables,
      options?: UseInfiniteQueryOptions<ProductSizesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductSizesQuery, TError, TData>(
      ['ProductSizes.infinite', variables],
      (metaData) => fetcher<ProductSizesQuery, ProductSizesQueryVariables>(client, ProductSizesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductSizesQuery.getKey = (variables: ProductSizesQueryVariables) => ['ProductSizes.infinite', variables];
;

export const ProductUrlsDocument = `
    query productUrls($identifier: Int!) {
  productUrls(identifier: $identifier)
}
    `;
export const useProductUrlsQuery = <
      TData = ProductUrlsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductUrlsQueryVariables,
      options?: UseQueryOptions<ProductUrlsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductUrlsQuery, TError, TData>(
      ['productUrls', variables],
      fetcher<ProductUrlsQuery, ProductUrlsQueryVariables>(client, ProductUrlsDocument, variables, headers),
      options
    );
useProductUrlsQuery.document = ProductUrlsDocument;


useProductUrlsQuery.getKey = (variables: ProductUrlsQueryVariables) => ['productUrls', variables];
;

export const useInfiniteProductUrlsQuery = <
      TData = ProductUrlsQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductUrlsQueryVariables,
      client: GraphQLClient,
      variables: ProductUrlsQueryVariables,
      options?: UseInfiniteQueryOptions<ProductUrlsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductUrlsQuery, TError, TData>(
      ['productUrls.infinite', variables],
      (metaData) => fetcher<ProductUrlsQuery, ProductUrlsQueryVariables>(client, ProductUrlsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductUrlsQuery.getKey = (variables: ProductUrlsQueryVariables) => ['productUrls.infinite', variables];
;

export const ProductsDocument = `
    query products($pageSize: Int!, $currentPage: Int!, $filter: ProductAttributeFilterInput, $sort: ProductAttributeSortInput) {
  products(
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    page_info {
      current_page
      total_pages
    }
    total_count
    items {
      __typename
      ... on ConfigurableProduct {
        configurable_options {
          attribute_uid
          attribute_code
          values {
            label
            uid
            value_index
          }
        }
      }
      attribute_set_id
      manufacturer
      created_at
      umsatz
      benuta_pile_material
      benuta_production_type
      benuta_waschbar
      benuta_ar
      benuta_test_seal
      benuta_color_filter
      benuta_collection
      benuta_form_new
      reviews_io_score
      related_products {
        sku
        stock_status
        ... on ConfigurableProduct {
          variants {
            product {
              ... on SimpleProduct {
                sku
              }
            }
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          attributes {
            code
            value_index
          }
          product {
            ... on SimpleProduct {
              stock_status
              sku
            }
          }
        }
      }
      name
      id
      uid
      url_key
      url_rewrites {
        url
      }
      sku
      stock_status
      image {
        url
        label
        disabled
        position
      }
      small_image {
        url
        label
        disabled
        position
      }
      thumbnail {
        url
        label
        disabled
        position
      }
      media_gallery {
        url
        position
        label
        disabled
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      related_products {
        benuta_form_new
        url_key
        url_rewrites {
          url
        }
        small_image {
          url
          label
          disabled
          position
        }
        thumbnail {
          url
          label
          disabled
          position
        }
        image {
          url
          label
          disabled
        }
      }
    }
  }
}
    `;
export const useProductsQuery = <
      TData = ProductsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductsQueryVariables,
      options?: UseQueryOptions<ProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductsQuery, TError, TData>(
      ['products', variables],
      fetcher<ProductsQuery, ProductsQueryVariables>(client, ProductsDocument, variables, headers),
      options
    );
useProductsQuery.document = ProductsDocument;


useProductsQuery.getKey = (variables: ProductsQueryVariables) => ['products', variables];
;

export const useInfiniteProductsQuery = <
      TData = ProductsQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductsQueryVariables,
      client: GraphQLClient,
      variables: ProductsQueryVariables,
      options?: UseInfiniteQueryOptions<ProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductsQuery, TError, TData>(
      ['products.infinite', variables],
      (metaData) => fetcher<ProductsQuery, ProductsQueryVariables>(client, ProductsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductsQuery.getKey = (variables: ProductsQueryVariables) => ['products.infinite', variables];
;

export const ProductsOfPopularSearchTermsDocument = `
    query productsOfPopularSearchTerms($skus: [String!]) {
  products(filter: {sku: {in: $skus}}) {
    items {
      __typename
      ... on ConfigurableProduct {
        sku
        image {
          url
          label
          disabled
          position
        }
        thumbnail {
          url
          label
          disabled
          position
        }
        media_gallery {
          url
          position
          label
          disabled
        }
      }
    }
  }
}
    `;
export const useProductsOfPopularSearchTermsQuery = <
      TData = ProductsOfPopularSearchTermsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: ProductsOfPopularSearchTermsQueryVariables,
      options?: UseQueryOptions<ProductsOfPopularSearchTermsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductsOfPopularSearchTermsQuery, TError, TData>(
      variables === undefined ? ['productsOfPopularSearchTerms'] : ['productsOfPopularSearchTerms', variables],
      fetcher<ProductsOfPopularSearchTermsQuery, ProductsOfPopularSearchTermsQueryVariables>(client, ProductsOfPopularSearchTermsDocument, variables, headers),
      options
    );
useProductsOfPopularSearchTermsQuery.document = ProductsOfPopularSearchTermsDocument;


useProductsOfPopularSearchTermsQuery.getKey = (variables?: ProductsOfPopularSearchTermsQueryVariables) => variables === undefined ? ['productsOfPopularSearchTerms'] : ['productsOfPopularSearchTerms', variables];
;

export const useInfiniteProductsOfPopularSearchTermsQuery = <
      TData = ProductsOfPopularSearchTermsQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductsOfPopularSearchTermsQueryVariables,
      client: GraphQLClient,
      variables?: ProductsOfPopularSearchTermsQueryVariables,
      options?: UseInfiniteQueryOptions<ProductsOfPopularSearchTermsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductsOfPopularSearchTermsQuery, TError, TData>(
      variables === undefined ? ['productsOfPopularSearchTerms.infinite'] : ['productsOfPopularSearchTerms.infinite', variables],
      (metaData) => fetcher<ProductsOfPopularSearchTermsQuery, ProductsOfPopularSearchTermsQueryVariables>(client, ProductsOfPopularSearchTermsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductsOfPopularSearchTermsQuery.getKey = (variables?: ProductsOfPopularSearchTermsQueryVariables) => variables === undefined ? ['productsOfPopularSearchTerms.infinite'] : ['productsOfPopularSearchTerms.infinite', variables];
;

export const ProductsPricesDocument = `
    query productsPrices($pageSize: Int!, $currentPage: Int!, $filter: ProductAttributeFilterInput, $sort: ProductAttributeSortInput) {
  products(
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    items {
      sku
      stock_status
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
    }
  }
}
    `;
export const useProductsPricesQuery = <
      TData = ProductsPricesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductsPricesQueryVariables,
      options?: UseQueryOptions<ProductsPricesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductsPricesQuery, TError, TData>(
      ['productsPrices', variables],
      fetcher<ProductsPricesQuery, ProductsPricesQueryVariables>(client, ProductsPricesDocument, variables, headers),
      options
    );
useProductsPricesQuery.document = ProductsPricesDocument;


useProductsPricesQuery.getKey = (variables: ProductsPricesQueryVariables) => ['productsPrices', variables];
;

export const useInfiniteProductsPricesQuery = <
      TData = ProductsPricesQuery,
      TError = Error
    >(
      _pageParamKey: keyof ProductsPricesQueryVariables,
      client: GraphQLClient,
      variables: ProductsPricesQueryVariables,
      options?: UseInfiniteQueryOptions<ProductsPricesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductsPricesQuery, TError, TData>(
      ['productsPrices.infinite', variables],
      (metaData) => fetcher<ProductsPricesQuery, ProductsPricesQueryVariables>(client, ProductsPricesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteProductsPricesQuery.getKey = (variables: ProductsPricesQueryVariables) => ['productsPrices.infinite', variables];
;

export const RecentlyViewedProductsDocument = `
    query RecentlyViewedProducts($urlKeys: [String]!) {
  products(filter: {url_key: {in: $urlKeys}}) {
    items {
      __typename
      ... on ConfigurableProduct {
        configurable_options {
          attribute_uid
          attribute_code
          values {
            label
            uid
            value_index
          }
        }
      }
      manufacturer
      created_at
      umsatz
      benuta_pile_material
      benuta_production_type
      benuta_waschbar
      benuta_ar
      benuta_test_seal
      benuta_color_filter
      benuta_collection
      benuta_form_new
      reviews_io_score
      related_products {
        benuta_form_new
        sku
        ... on ConfigurableProduct {
          variants {
            product {
              ... on SimpleProduct {
                sku
              }
            }
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          product {
            ... on SimpleProduct {
              sku
            }
          }
        }
      }
      name
      uid
      url_key
      url_rewrites {
        url
      }
      sku
      image {
        url
        label
        disabled
        position
      }
      small_image {
        url
        label
        disabled
        position
      }
      thumbnail {
        url
        label
        disabled
        position
      }
      media_gallery {
        url
        position
        label
        disabled
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      related_products {
        url_key
        url_rewrites {
          url
        }
        small_image {
          url
          label
          disabled
          position
        }
        thumbnail {
          url
          label
          disabled
          position
        }
        image {
          url
          label
          disabled
        }
      }
    }
  }
}
    `;
export const useRecentlyViewedProductsQuery = <
      TData = RecentlyViewedProductsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: RecentlyViewedProductsQueryVariables,
      options?: UseQueryOptions<RecentlyViewedProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RecentlyViewedProductsQuery, TError, TData>(
      ['RecentlyViewedProducts', variables],
      fetcher<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>(client, RecentlyViewedProductsDocument, variables, headers),
      options
    );
useRecentlyViewedProductsQuery.document = RecentlyViewedProductsDocument;


useRecentlyViewedProductsQuery.getKey = (variables: RecentlyViewedProductsQueryVariables) => ['RecentlyViewedProducts', variables];
;

export const useInfiniteRecentlyViewedProductsQuery = <
      TData = RecentlyViewedProductsQuery,
      TError = Error
    >(
      _pageParamKey: keyof RecentlyViewedProductsQueryVariables,
      client: GraphQLClient,
      variables: RecentlyViewedProductsQueryVariables,
      options?: UseInfiniteQueryOptions<RecentlyViewedProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<RecentlyViewedProductsQuery, TError, TData>(
      ['RecentlyViewedProducts.infinite', variables],
      (metaData) => fetcher<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>(client, RecentlyViewedProductsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteRecentlyViewedProductsQuery.getKey = (variables: RecentlyViewedProductsQueryVariables) => ['RecentlyViewedProducts.infinite', variables];
;

export const RecentlyViewedProductsViaSkuDocument = `
    query RecentlyViewedProductsViaSku($skus: [String]!) {
  products(filter: {sku: {in: $skus}}, sort: {relevance: ASC}) {
    items {
      __typename
      ... on ConfigurableProduct {
        configurable_options {
          attribute_uid
          attribute_code
          values {
            label
            uid
            value_index
          }
        }
      }
      name
      uid
      url_key
      url_rewrites {
        url
      }
      manufacturer
      created_at
      umsatz
      benuta_pile_material
      benuta_production_type
      benuta_waschbar
      benuta_ar
      benuta_test_seal
      benuta_color_filter
      benuta_collection
      benuta_form_new
      reviews_io_score
      related_products {
        benuta_form_new
        sku
        ... on ConfigurableProduct {
          variants {
            product {
              ... on SimpleProduct {
                sku
              }
            }
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          product {
            ... on SimpleProduct {
              sku
            }
          }
        }
      }
      sku
      image {
        url
        label
        disabled
        position
      }
      small_image {
        url
        label
        disabled
        position
      }
      thumbnail {
        url
        label
        disabled
        position
      }
      media_gallery {
        url
        position
        label
        disabled
      }
      price_range {
        minimum_price {
          regular_price {
            currency
            value
          }
          final_price {
            currency
            value
          }
        }
      }
      related_products {
        url_key
        url_rewrites {
          url
        }
        small_image {
          url
          label
          disabled
          position
        }
        thumbnail {
          url
          label
          disabled
          position
        }
        image {
          url
          label
          disabled
        }
      }
    }
  }
}
    `;
export const useRecentlyViewedProductsViaSkuQuery = <
      TData = RecentlyViewedProductsViaSkuQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: RecentlyViewedProductsViaSkuQueryVariables,
      options?: UseQueryOptions<RecentlyViewedProductsViaSkuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RecentlyViewedProductsViaSkuQuery, TError, TData>(
      ['RecentlyViewedProductsViaSku', variables],
      fetcher<RecentlyViewedProductsViaSkuQuery, RecentlyViewedProductsViaSkuQueryVariables>(client, RecentlyViewedProductsViaSkuDocument, variables, headers),
      options
    );
useRecentlyViewedProductsViaSkuQuery.document = RecentlyViewedProductsViaSkuDocument;


useRecentlyViewedProductsViaSkuQuery.getKey = (variables: RecentlyViewedProductsViaSkuQueryVariables) => ['RecentlyViewedProductsViaSku', variables];
;

export const useInfiniteRecentlyViewedProductsViaSkuQuery = <
      TData = RecentlyViewedProductsViaSkuQuery,
      TError = Error
    >(
      _pageParamKey: keyof RecentlyViewedProductsViaSkuQueryVariables,
      client: GraphQLClient,
      variables: RecentlyViewedProductsViaSkuQueryVariables,
      options?: UseInfiniteQueryOptions<RecentlyViewedProductsViaSkuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<RecentlyViewedProductsViaSkuQuery, TError, TData>(
      ['RecentlyViewedProductsViaSku.infinite', variables],
      (metaData) => fetcher<RecentlyViewedProductsViaSkuQuery, RecentlyViewedProductsViaSkuQueryVariables>(client, RecentlyViewedProductsViaSkuDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteRecentlyViewedProductsViaSkuQuery.getKey = (variables: RecentlyViewedProductsViaSkuQueryVariables) => ['RecentlyViewedProductsViaSku.infinite', variables];
;

export const RemoveCouponFromCartDocument = `
    mutation RemoveCouponFromCart($cartId: String!) {
  removeCouponFromCart(input: {cart_id: $cartId}) {
    cart {
      applied_coupons {
        code
      }
    }
  }
}
    `;
export const useRemoveCouponFromCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveCouponFromCartMutation, TError, RemoveCouponFromCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveCouponFromCartMutation, TError, RemoveCouponFromCartMutationVariables, TContext>(
      ['RemoveCouponFromCart'],
      (variables?: RemoveCouponFromCartMutationVariables) => fetcher<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(client, RemoveCouponFromCartDocument, variables, headers)(),
      options
    );
useRemoveCouponFromCartMutation.getKey = () => ['RemoveCouponFromCart'];

export const RemoveItemFromCartDocument = `
    mutation RemoveItemFromCart($cartId: String!, $cartItemUid: ID!) {
  removeItemFromCart(input: {cart_id: $cartId, cart_item_uid: $cartItemUid}) {
    cart {
      total_quantity
    }
  }
}
    `;
export const useRemoveItemFromCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveItemFromCartMutation, TError, RemoveItemFromCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveItemFromCartMutation, TError, RemoveItemFromCartMutationVariables, TContext>(
      ['RemoveItemFromCart'],
      (variables?: RemoveItemFromCartMutationVariables) => fetcher<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(client, RemoveItemFromCartDocument, variables, headers)(),
      options
    );
useRemoveItemFromCartMutation.getKey = () => ['RemoveItemFromCart'];

export const RemoveItemsFromWishlistDocument = `
    mutation RemoveItemsFromWishlist($wishlistId: ID!, $wishlistItemsIds: [ID!]!) {
  removeProductsFromWishlist(
    wishlistId: $wishlistId
    wishlistItemsIds: $wishlistItemsIds
  ) {
    user_errors {
      code
      message
    }
  }
}
    `;
export const useRemoveItemsFromWishlistMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveItemsFromWishlistMutation, TError, RemoveItemsFromWishlistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveItemsFromWishlistMutation, TError, RemoveItemsFromWishlistMutationVariables, TContext>(
      ['RemoveItemsFromWishlist'],
      (variables?: RemoveItemsFromWishlistMutationVariables) => fetcher<RemoveItemsFromWishlistMutation, RemoveItemsFromWishlistMutationVariables>(client, RemoveItemsFromWishlistDocument, variables, headers)(),
      options
    );
useRemoveItemsFromWishlistMutation.getKey = () => ['RemoveItemsFromWishlist'];

export const RequestPasswordResetDocument = `
    mutation requestPasswordReset($email: String!) {
  requestPasswordResetEmail(email: $email)
}
    `;
export const useRequestPasswordResetMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>(
      ['requestPasswordReset'],
      (variables?: RequestPasswordResetMutationVariables) => fetcher<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(client, RequestPasswordResetDocument, variables, headers)(),
      options
    );
useRequestPasswordResetMutation.getKey = () => ['requestPasswordReset'];

export const ResetPasswordDocument = `
    mutation resetPassword($email: String!, $password: String!, $resetPasswordToken: String!) {
  resetPassword(
    email: $email
    newPassword: $password
    resetPasswordToken: $resetPasswordToken
  )
}
    `;
export const useResetPasswordMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['resetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(client, ResetPasswordDocument, variables, headers)(),
      options
    );
useResetPasswordMutation.getKey = () => ['resetPassword'];

export const RouteDocument = `
    query route($slug: String!) {
  route(url: $slug) {
    __typename
    relative_url
    redirect_code
    type
    ...cmsPage
    ... on ConfigurableProduct {
      meta_title
      meta_description
      url_key
    }
    ... on CategoryInterface {
      id
      uid
    }
  }
}
    ${CmsPageFragmentDoc}`;
export const useRouteQuery = <
      TData = RouteQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: RouteQueryVariables,
      options?: UseQueryOptions<RouteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RouteQuery, TError, TData>(
      ['route', variables],
      fetcher<RouteQuery, RouteQueryVariables>(client, RouteDocument, variables, headers),
      options
    );
useRouteQuery.document = RouteDocument;


useRouteQuery.getKey = (variables: RouteQueryVariables) => ['route', variables];
;

export const useInfiniteRouteQuery = <
      TData = RouteQuery,
      TError = Error
    >(
      _pageParamKey: keyof RouteQueryVariables,
      client: GraphQLClient,
      variables: RouteQueryVariables,
      options?: UseInfiniteQueryOptions<RouteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<RouteQuery, TError, TData>(
      ['route.infinite', variables],
      (metaData) => fetcher<RouteQuery, RouteQueryVariables>(client, RouteDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteRouteQuery.getKey = (variables: RouteQueryVariables) => ['route.infinite', variables];
;

export const SetBillingAddressOnCartDocument = `
    mutation setBillingAddressOnCart($cartId: String!, $billingAddresses: BillingAddressInput!) {
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: $billingAddresses}
  ) {
    cart {
      id
      billing_address {
        telephone
      }
    }
  }
}
    `;
export const useSetBillingAddressOnCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetBillingAddressOnCartMutation, TError, SetBillingAddressOnCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetBillingAddressOnCartMutation, TError, SetBillingAddressOnCartMutationVariables, TContext>(
      ['setBillingAddressOnCart'],
      (variables?: SetBillingAddressOnCartMutationVariables) => fetcher<SetBillingAddressOnCartMutation, SetBillingAddressOnCartMutationVariables>(client, SetBillingAddressOnCartDocument, variables, headers)(),
      options
    );
useSetBillingAddressOnCartMutation.getKey = () => ['setBillingAddressOnCart'];

export const SetGuestEmailOnCartDocument = `
    mutation setGuestEmailOnCart($cartId: String!, $email: String!) {
  setGuestEmailOnCart(input: {cart_id: $cartId, email: $email}) {
    cart {
      email
    }
  }
}
    `;
export const useSetGuestEmailOnCartMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetGuestEmailOnCartMutation, TError, SetGuestEmailOnCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetGuestEmailOnCartMutation, TError, SetGuestEmailOnCartMutationVariables, TContext>(
      ['setGuestEmailOnCart'],
      (variables?: SetGuestEmailOnCartMutationVariables) => fetcher<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>(client, SetGuestEmailOnCartDocument, variables, headers)(),
      options
    );
useSetGuestEmailOnCartMutation.getKey = () => ['setGuestEmailOnCart'];

export const SetPaymentMethodDocument = `
    mutation setPaymentMethod($cartId: String!, $paymentMethod: PaymentMethodInput!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: $paymentMethod}
  ) {
    cart {
      selected_payment_method {
        code
      }
    }
  }
}
    `;
export const useSetPaymentMethodMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodMutation, TError, SetPaymentMethodMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodMutation, TError, SetPaymentMethodMutationVariables, TContext>(
      ['setPaymentMethod'],
      (variables?: SetPaymentMethodMutationVariables) => fetcher<SetPaymentMethodMutation, SetPaymentMethodMutationVariables>(client, SetPaymentMethodDocument, variables, headers)(),
      options
    );
useSetPaymentMethodMutation.getKey = () => ['setPaymentMethod'];

export const SetPaymentMethodAndPalceOrderPaypalDocument = `
    mutation setPaymentMethodAndPalceOrderPaypal($cartId: String!, $payerId: String!, $token: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: "paypal_express", paypal_express: {payer_id: $payerId, token: $token}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
    }
  }
}
    `;
export const useSetPaymentMethodAndPalceOrderPaypalMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPalceOrderPaypalMutation, TError, SetPaymentMethodAndPalceOrderPaypalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPalceOrderPaypalMutation, TError, SetPaymentMethodAndPalceOrderPaypalMutationVariables, TContext>(
      ['setPaymentMethodAndPalceOrderPaypal'],
      (variables?: SetPaymentMethodAndPalceOrderPaypalMutationVariables) => fetcher<SetPaymentMethodAndPalceOrderPaypalMutation, SetPaymentMethodAndPalceOrderPaypalMutationVariables>(client, SetPaymentMethodAndPalceOrderPaypalDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPalceOrderPaypalMutation.getKey = () => ['setPaymentMethodAndPalceOrderPaypal'];

export const SetPaymentMethodAndPlaceOrderDocument = `
    mutation setPaymentMethodAndPlaceOrder($cartId: String!, $stateData: String!, $cardType: String) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: "adyen_cc", adyen_additional_data_cc: {cc_type: $cardType, stateData: $stateData}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_id
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderMutation, TError, SetPaymentMethodAndPlaceOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderMutation, TError, SetPaymentMethodAndPlaceOrderMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrder'],
      (variables?: SetPaymentMethodAndPlaceOrderMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderMutation, SetPaymentMethodAndPlaceOrderMutationVariables>(client, SetPaymentMethodAndPlaceOrderDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderMutation.getKey = () => ['setPaymentMethodAndPlaceOrder'];

export const SetPaymentMethodAndPlaceOrderAdyenHppDocument = `
    mutation setPaymentMethodAndPlaceOrderAdyenHPP($cartId: String!, $paymentCode: String!, $stateData: String!, $brandCode: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: $paymentCode, adyen_additional_data: {brand_code: $brandCode, stateData: $stateData}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_id
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderAdyenHppMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderAdyenHppMutation, TError, SetPaymentMethodAndPlaceOrderAdyenHppMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderAdyenHppMutation, TError, SetPaymentMethodAndPlaceOrderAdyenHppMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrderAdyenHPP'],
      (variables?: SetPaymentMethodAndPlaceOrderAdyenHppMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderAdyenHppMutation, SetPaymentMethodAndPlaceOrderAdyenHppMutationVariables>(client, SetPaymentMethodAndPlaceOrderAdyenHppDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderAdyenHppMutation.getKey = () => ['setPaymentMethodAndPlaceOrderAdyenHPP'];

export const SetPaymentMethodAndPlaceOrderApplePayDocument = `
    mutation setPaymentMethodAndPlaceOrderApplePay($cartId: String!, $stateData: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: "adyen_applepay", adyen_additional_data: {brand_code: "adyen_applepay", stateData: $stateData}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_id
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderApplePayMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderApplePayMutation, TError, SetPaymentMethodAndPlaceOrderApplePayMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderApplePayMutation, TError, SetPaymentMethodAndPlaceOrderApplePayMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrderApplePay'],
      (variables?: SetPaymentMethodAndPlaceOrderApplePayMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderApplePayMutation, SetPaymentMethodAndPlaceOrderApplePayMutationVariables>(client, SetPaymentMethodAndPlaceOrderApplePayDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderApplePayMutation.getKey = () => ['setPaymentMethodAndPlaceOrderApplePay'];

export const SetPaymentMethodAndPlaceOrderGooglePayDocument = `
    mutation setPaymentMethodAndPlaceOrderGooglePay($cartId: String!, $stateData: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: "adyen_googlepay", adyen_additional_data: {brand_code: "adyen_googlepay", stateData: $stateData}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_id
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderGooglePayMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderGooglePayMutation, TError, SetPaymentMethodAndPlaceOrderGooglePayMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderGooglePayMutation, TError, SetPaymentMethodAndPlaceOrderGooglePayMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrderGooglePay'],
      (variables?: SetPaymentMethodAndPlaceOrderGooglePayMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderGooglePayMutation, SetPaymentMethodAndPlaceOrderGooglePayMutationVariables>(client, SetPaymentMethodAndPlaceOrderGooglePayDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderGooglePayMutation.getKey = () => ['setPaymentMethodAndPlaceOrderGooglePay'];

export const SetPaymentMethodAndPlaceOrderKlarnaDocument = `
    mutation setPaymentMethodAndPlaceOrderKlarna($cartId: String!, $code: String!, $klarnaAuthToken: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: $code, klarna: {authorization_token: $klarnaAuthToken}}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_number
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderKlarnaMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderKlarnaMutation, TError, SetPaymentMethodAndPlaceOrderKlarnaMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderKlarnaMutation, TError, SetPaymentMethodAndPlaceOrderKlarnaMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrderKlarna'],
      (variables?: SetPaymentMethodAndPlaceOrderKlarnaMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderKlarnaMutation, SetPaymentMethodAndPlaceOrderKlarnaMutationVariables>(client, SetPaymentMethodAndPlaceOrderKlarnaDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderKlarnaMutation.getKey = () => ['setPaymentMethodAndPlaceOrderKlarna'];

export const SetPaymentMethodAndPlaceOrderVorkasseDocument = `
    mutation setPaymentMethodAndPlaceOrderVorkasse($cartId: String!) {
  setPaymentMethodOnCart(
    input: {cart_id: $cartId, payment_method: {code: "banktransfer"}}
  ) {
    cart {
      selected_payment_method {
        code
        title
      }
    }
  }
  placeOrder(input: {cart_id: $cartId}) {
    order {
      order_number
      cart_id
      order_id
      adyen_payment_status {
        isFinal
        resultCode
        additionalData
        action
      }
    }
  }
}
    `;
export const useSetPaymentMethodAndPlaceOrderVorkasseMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetPaymentMethodAndPlaceOrderVorkasseMutation, TError, SetPaymentMethodAndPlaceOrderVorkasseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetPaymentMethodAndPlaceOrderVorkasseMutation, TError, SetPaymentMethodAndPlaceOrderVorkasseMutationVariables, TContext>(
      ['setPaymentMethodAndPlaceOrderVorkasse'],
      (variables?: SetPaymentMethodAndPlaceOrderVorkasseMutationVariables) => fetcher<SetPaymentMethodAndPlaceOrderVorkasseMutation, SetPaymentMethodAndPlaceOrderVorkasseMutationVariables>(client, SetPaymentMethodAndPlaceOrderVorkasseDocument, variables, headers)(),
      options
    );
useSetPaymentMethodAndPlaceOrderVorkasseMutation.getKey = () => ['setPaymentMethodAndPlaceOrderVorkasse'];

export const SetShippingAddressDocument = `
    mutation setShippingAddress($cartId: String!, $address: CartAddressInput!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{address: $address}]}
  ) {
    cart {
      shipping_addresses {
        firstname
        lastname
        company
        street
        city
        region {
          code
          label
        }
        postcode
        telephone
        country {
          code
          label
        }
      }
    }
  }
}
    `;
export const useSetShippingAddressMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetShippingAddressMutation, TError, SetShippingAddressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetShippingAddressMutation, TError, SetShippingAddressMutationVariables, TContext>(
      ['setShippingAddress'],
      (variables?: SetShippingAddressMutationVariables) => fetcher<SetShippingAddressMutation, SetShippingAddressMutationVariables>(client, SetShippingAddressDocument, variables, headers)(),
      options
    );
useSetShippingAddressMutation.getKey = () => ['setShippingAddress'];

export const SetShippingMethodsDocument = `
    mutation setShippingMethods($cartId: String!, $shippingMethods: [ShippingMethodInput]!) {
  setShippingMethodsOnCart(
    input: {cart_id: $cartId, shipping_methods: $shippingMethods}
  ) {
    cart {
      shipping_addresses {
        selected_shipping_method {
          carrier_code
          method_code
          carrier_title
          method_title
        }
      }
      available_payment_methods {
        code
        title
      }
    }
  }
}
    `;
export const useSetShippingMethodsMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetShippingMethodsMutation, TError, SetShippingMethodsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetShippingMethodsMutation, TError, SetShippingMethodsMutationVariables, TContext>(
      ['setShippingMethods'],
      (variables?: SetShippingMethodsMutationVariables) => fetcher<SetShippingMethodsMutation, SetShippingMethodsMutationVariables>(client, SetShippingMethodsDocument, variables, headers)(),
      options
    );
useSetShippingMethodsMutation.getKey = () => ['setShippingMethods'];

export const SignInDocument = `
    mutation signIn($email: String!, $password: String!) {
  generateCustomerToken(email: $email, password: $password) {
    token
  }
}
    `;
export const useSignInMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignInMutation, TError, SignInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignInMutation, TError, SignInMutationVariables, TContext>(
      ['signIn'],
      (variables?: SignInMutationVariables) => fetcher<SignInMutation, SignInMutationVariables>(client, SignInDocument, variables, headers)(),
      options
    );
useSignInMutation.getKey = () => ['signIn'];

export const SignOutDocument = `
    mutation signOut {
  revokeCustomerToken {
    result
  }
}
    `;
export const useSignOutMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignOutMutation, TError, SignOutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignOutMutation, TError, SignOutMutationVariables, TContext>(
      ['signOut'],
      (variables?: SignOutMutationVariables) => fetcher<SignOutMutation, SignOutMutationVariables>(client, SignOutDocument, variables, headers)(),
      options
    );
useSignOutMutation.getKey = () => ['signOut'];

export const SitemapCategoriesDocument = `
    query sitemapCategories {
  categoryList(filters: {}) {
    url_path
    children {
      url_path
    }
  }
}
    `;
export const useSitemapCategoriesQuery = <
      TData = SitemapCategoriesQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: SitemapCategoriesQueryVariables,
      options?: UseQueryOptions<SitemapCategoriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SitemapCategoriesQuery, TError, TData>(
      variables === undefined ? ['sitemapCategories'] : ['sitemapCategories', variables],
      fetcher<SitemapCategoriesQuery, SitemapCategoriesQueryVariables>(client, SitemapCategoriesDocument, variables, headers),
      options
    );
useSitemapCategoriesQuery.document = SitemapCategoriesDocument;


useSitemapCategoriesQuery.getKey = (variables?: SitemapCategoriesQueryVariables) => variables === undefined ? ['sitemapCategories'] : ['sitemapCategories', variables];
;

export const useInfiniteSitemapCategoriesQuery = <
      TData = SitemapCategoriesQuery,
      TError = Error
    >(
      _pageParamKey: keyof SitemapCategoriesQueryVariables,
      client: GraphQLClient,
      variables?: SitemapCategoriesQueryVariables,
      options?: UseInfiniteQueryOptions<SitemapCategoriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<SitemapCategoriesQuery, TError, TData>(
      variables === undefined ? ['sitemapCategories.infinite'] : ['sitemapCategories.infinite', variables],
      (metaData) => fetcher<SitemapCategoriesQuery, SitemapCategoriesQueryVariables>(client, SitemapCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteSitemapCategoriesQuery.getKey = (variables?: SitemapCategoriesQueryVariables) => variables === undefined ? ['sitemapCategories.infinite'] : ['sitemapCategories.infinite', variables];
;

export const SitemapProductsDocument = `
    query sitemapProducts {
  products(filter: {}, pageSize: 10000) {
    total_count
    items {
      __typename
      url_key
      url_rewrites {
        url
      }
    }
  }
}
    `;
export const useSitemapProductsQuery = <
      TData = SitemapProductsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: SitemapProductsQueryVariables,
      options?: UseQueryOptions<SitemapProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SitemapProductsQuery, TError, TData>(
      variables === undefined ? ['sitemapProducts'] : ['sitemapProducts', variables],
      fetcher<SitemapProductsQuery, SitemapProductsQueryVariables>(client, SitemapProductsDocument, variables, headers),
      options
    );
useSitemapProductsQuery.document = SitemapProductsDocument;


useSitemapProductsQuery.getKey = (variables?: SitemapProductsQueryVariables) => variables === undefined ? ['sitemapProducts'] : ['sitemapProducts', variables];
;

export const useInfiniteSitemapProductsQuery = <
      TData = SitemapProductsQuery,
      TError = Error
    >(
      _pageParamKey: keyof SitemapProductsQueryVariables,
      client: GraphQLClient,
      variables?: SitemapProductsQueryVariables,
      options?: UseInfiniteQueryOptions<SitemapProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<SitemapProductsQuery, TError, TData>(
      variables === undefined ? ['sitemapProducts.infinite'] : ['sitemapProducts.infinite', variables],
      (metaData) => fetcher<SitemapProductsQuery, SitemapProductsQueryVariables>(client, SitemapProductsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteSitemapProductsQuery.getKey = (variables?: SitemapProductsQueryVariables) => variables === undefined ? ['sitemapProducts.infinite'] : ['sitemapProducts.infinite', variables];
;

export const GetRelatedSkusDocument = `
    query GetRelatedSkus($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      sku
      related_products {
        ... on ConfigurableProduct {
          __typename
          variants {
            product {
              ... on SimpleProduct {
                sku
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetRelatedSkusQuery = <
      TData = GetRelatedSkusQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: GetRelatedSkusQueryVariables,
      options?: UseQueryOptions<GetRelatedSkusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRelatedSkusQuery, TError, TData>(
      ['GetRelatedSkus', variables],
      fetcher<GetRelatedSkusQuery, GetRelatedSkusQueryVariables>(client, GetRelatedSkusDocument, variables, headers),
      options
    );
useGetRelatedSkusQuery.document = GetRelatedSkusDocument;


useGetRelatedSkusQuery.getKey = (variables: GetRelatedSkusQueryVariables) => ['GetRelatedSkus', variables];
;

export const useInfiniteGetRelatedSkusQuery = <
      TData = GetRelatedSkusQuery,
      TError = Error
    >(
      _pageParamKey: keyof GetRelatedSkusQueryVariables,
      client: GraphQLClient,
      variables: GetRelatedSkusQueryVariables,
      options?: UseInfiniteQueryOptions<GetRelatedSkusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetRelatedSkusQuery, TError, TData>(
      ['GetRelatedSkus.infinite', variables],
      (metaData) => fetcher<GetRelatedSkusQuery, GetRelatedSkusQueryVariables>(client, GetRelatedSkusDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteGetRelatedSkusQuery.getKey = (variables: GetRelatedSkusQueryVariables) => ['GetRelatedSkus.infinite', variables];
;

export const StoreConfigDocument = `
    query storeConfig {
  storeConfig {
    base_currency_code
    adyen_client_key_live
    adyen_client_key_test
    payment_banktransfer_instructions
    payment_banktransfer_instructions_checkout
  }
}
    `;
export const useStoreConfigQuery = <
      TData = StoreConfigQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables?: StoreConfigQueryVariables,
      options?: UseQueryOptions<StoreConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StoreConfigQuery, TError, TData>(
      variables === undefined ? ['storeConfig'] : ['storeConfig', variables],
      fetcher<StoreConfigQuery, StoreConfigQueryVariables>(client, StoreConfigDocument, variables, headers),
      options
    );
useStoreConfigQuery.document = StoreConfigDocument;


useStoreConfigQuery.getKey = (variables?: StoreConfigQueryVariables) => variables === undefined ? ['storeConfig'] : ['storeConfig', variables];
;

export const useInfiniteStoreConfigQuery = <
      TData = StoreConfigQuery,
      TError = Error
    >(
      _pageParamKey: keyof StoreConfigQueryVariables,
      client: GraphQLClient,
      variables?: StoreConfigQueryVariables,
      options?: UseInfiniteQueryOptions<StoreConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<StoreConfigQuery, TError, TData>(
      variables === undefined ? ['storeConfig.infinite'] : ['storeConfig.infinite', variables],
      (metaData) => fetcher<StoreConfigQuery, StoreConfigQueryVariables>(client, StoreConfigDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteStoreConfigQuery.getKey = (variables?: StoreConfigQueryVariables) => variables === undefined ? ['storeConfig.infinite'] : ['storeConfig.infinite', variables];
;

export const SubscribeEmailToNewsletterDocument = `
    mutation SubscribeEmailToNewsletter($email: String!) {
  subscribeEmailToNewsletter(email: $email) {
    status
  }
}
    `;
export const useSubscribeEmailToNewsletterMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubscribeEmailToNewsletterMutation, TError, SubscribeEmailToNewsletterMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubscribeEmailToNewsletterMutation, TError, SubscribeEmailToNewsletterMutationVariables, TContext>(
      ['SubscribeEmailToNewsletter'],
      (variables?: SubscribeEmailToNewsletterMutationVariables) => fetcher<SubscribeEmailToNewsletterMutation, SubscribeEmailToNewsletterMutationVariables>(client, SubscribeEmailToNewsletterDocument, variables, headers)(),
      options
    );
useSubscribeEmailToNewsletterMutation.getKey = () => ['SubscribeEmailToNewsletter'];

export const UpdateCartItemsDocument = `
    mutation UpdateCartItems($cartId: String!, $cartItemUid: ID!, $qty: Float!) {
  updateCartItems(
    input: {cart_id: $cartId, cart_items: [{cart_item_uid: $cartItemUid, quantity: $qty}]}
  ) {
    cart {
      total_quantity
    }
  }
}
    `;
export const useUpdateCartItemsMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCartItemsMutation, TError, UpdateCartItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCartItemsMutation, TError, UpdateCartItemsMutationVariables, TContext>(
      ['UpdateCartItems'],
      (variables?: UpdateCartItemsMutationVariables) => fetcher<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>(client, UpdateCartItemsDocument, variables, headers)(),
      options
    );
useUpdateCartItemsMutation.getKey = () => ['UpdateCartItems'];

export const UpdateCustomerDocument = `
    mutation updateCustomer($firstname: String, $lastname: String, $email: String, $password: String) {
  updateCustomer(
    input: {firstname: $firstname, lastname: $lastname, email: $email, password: $password}
  ) {
    customer {
      firstname
      lastname
      email
    }
  }
}
    `;
export const useUpdateCustomerMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>(
      ['updateCustomer'],
      (variables?: UpdateCustomerMutationVariables) => fetcher<UpdateCustomerMutation, UpdateCustomerMutationVariables>(client, UpdateCustomerDocument, variables, headers)(),
      options
    );
useUpdateCustomerMutation.getKey = () => ['updateCustomer'];

export const UpdateCustomerAddressDocument = `
    mutation updateCustomerAddress($id: Int!, $city: String, $company: String, $country_code: CountryCodeEnum, $default_billing: Boolean, $default_shipping: Boolean, $firstname: String, $lastname: String, $postcode: String, $prefix: String, $street: [String], $telephone: String, $vat_id: String) {
  updateCustomerAddress(
    id: $id
    input: {city: $city, company: $company, country_code: $country_code, default_billing: $default_billing, default_shipping: $default_shipping, firstname: $firstname, lastname: $lastname, postcode: $postcode, prefix: $prefix, street: $street, telephone: $telephone, vat_id: $vat_id}
  ) {
    city
    company
    country_code
    default_billing
    default_shipping
    firstname
    lastname
    postcode
    prefix
    street
    telephone
    vat_id
  }
}
    `;
export const useUpdateCustomerAddressMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCustomerAddressMutation, TError, UpdateCustomerAddressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCustomerAddressMutation, TError, UpdateCustomerAddressMutationVariables, TContext>(
      ['updateCustomerAddress'],
      (variables?: UpdateCustomerAddressMutationVariables) => fetcher<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>(client, UpdateCustomerAddressDocument, variables, headers)(),
      options
    );
useUpdateCustomerAddressMutation.getKey = () => ['updateCustomerAddress'];

export const UpdateCustomerNewsletterSubscriptionDocument = `
    mutation updateCustomerNewsletterSubscription($firstname: String!, $email: String!) {
  updateCustomerV2(input: {firstname: $firstname, is_subscribed: true}) {
    customer {
      firstname
    }
  }
  subscribeEmailToNewsletter(email: $email) {
    status
  }
}
    `;
export const useUpdateCustomerNewsletterSubscriptionMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCustomerNewsletterSubscriptionMutation, TError, UpdateCustomerNewsletterSubscriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCustomerNewsletterSubscriptionMutation, TError, UpdateCustomerNewsletterSubscriptionMutationVariables, TContext>(
      ['updateCustomerNewsletterSubscription'],
      (variables?: UpdateCustomerNewsletterSubscriptionMutationVariables) => fetcher<UpdateCustomerNewsletterSubscriptionMutation, UpdateCustomerNewsletterSubscriptionMutationVariables>(client, UpdateCustomerNewsletterSubscriptionDocument, variables, headers)(),
      options
    );
useUpdateCustomerNewsletterSubscriptionMutation.getKey = () => ['updateCustomerNewsletterSubscription'];

export const UpdateCustomerTelephoneDocument = `
    mutation updateCustomerTelephone($id: Int!, $telephone: String) {
  updateCustomerAddress(id: $id, input: {telephone: $telephone}) {
    telephone
  }
}
    `;
export const useUpdateCustomerTelephoneMutation = <
      TError = Error,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCustomerTelephoneMutation, TError, UpdateCustomerTelephoneMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCustomerTelephoneMutation, TError, UpdateCustomerTelephoneMutationVariables, TContext>(
      ['updateCustomerTelephone'],
      (variables?: UpdateCustomerTelephoneMutationVariables) => fetcher<UpdateCustomerTelephoneMutation, UpdateCustomerTelephoneMutationVariables>(client, UpdateCustomerTelephoneDocument, variables, headers)(),
      options
    );
useUpdateCustomerTelephoneMutation.getKey = () => ['updateCustomerTelephone'];

export const ValidateCartDocument = `
    query ValidateCart($cartId: String!) {
  cart(cart_id: $cartId) {
    id
  }
}
    `;
export const useValidateCartQuery = <
      TData = ValidateCartQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ValidateCartQueryVariables,
      options?: UseQueryOptions<ValidateCartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateCartQuery, TError, TData>(
      ['ValidateCart', variables],
      fetcher<ValidateCartQuery, ValidateCartQueryVariables>(client, ValidateCartDocument, variables, headers),
      options
    );
useValidateCartQuery.document = ValidateCartDocument;


useValidateCartQuery.getKey = (variables: ValidateCartQueryVariables) => ['ValidateCart', variables];
;

export const useInfiniteValidateCartQuery = <
      TData = ValidateCartQuery,
      TError = Error
    >(
      _pageParamKey: keyof ValidateCartQueryVariables,
      client: GraphQLClient,
      variables: ValidateCartQueryVariables,
      options?: UseInfiniteQueryOptions<ValidateCartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ValidateCartQuery, TError, TData>(
      ['ValidateCart.infinite', variables],
      (metaData) => fetcher<ValidateCartQuery, ValidateCartQueryVariables>(client, ValidateCartDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );


useInfiniteValidateCartQuery.getKey = (variables: ValidateCartQueryVariables) => ['ValidateCart.infinite', variables];
;
